//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiBaseClass {
    protected getBaseUrl = (defaultUrl: string, baseUrl: string | undefined) => {
      return process.env.REACT_APP_API_BASE_URL || defaultUrl;
    };
  }
  
  export class MainAPI extends ApiBaseClass {
      private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
      private baseUrl: string;
      protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
  
      constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
          super();
          this.http = http ? http : window as any;
          this.baseUrl = this.getBaseUrl("", baseUrl);
      }
  
      /**
       * Get account details
       * @return Success
       */
      getAccountDetails(): Promise<AccountDto> {
          let url_ = this.baseUrl + "/account";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAccountDetails(_response);
          });
      }
  
      protected processGetAccountDetails(response: Response): Promise<AccountDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AccountDto>(null as any);
      }
  
      /**
       * Update account details for current user
       * @param body (optional) 
       * @return No Content
       */
      updateAccountDetails(body: UpdateUserAccountCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/account";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateAccountDetails(_response);
          });
      }
  
      protected processUpdateAccountDetails(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get user server access token
       * @return Success
       */
      getServerAccessToken(): Promise<string> {
          let url_ = this.baseUrl + "/account/access-token";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetServerAccessToken(_response);
          });
      }
  
      protected processGetServerAccessToken(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Validates an access token and returns userId
       * @param body (optional) 
       * @return Success
       */
      validateAccessToken(body: string | undefined): Promise<string> {
          let url_ = this.baseUrl + "/account/validate-access-token";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processValidateAccessToken(_response);
          });
      }
  
      protected processValidateAccessToken(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Get account details for CP
       * @return Success
       */
      getCPAccountDetails(): Promise<ContentProviderAccountDto> {
          let url_ = this.baseUrl + "/account/content-provider";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetCPAccountDetails(_response);
          });
      }
  
      protected processGetCPAccountDetails(response: Response): Promise<ContentProviderAccountDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContentProviderAccountDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ContentProviderAccountDto>(null as any);
      }
  
      /**
       * Resend verification email
       * @return No Content
       */
      resendVerificationEmail(): Promise<void> {
          let url_ = this.baseUrl + "/account/verification-email";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processResendVerificationEmail(_response);
          });
      }
  
      protected processResendVerificationEmail(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Fetch auth token for user
       * @param body (optional) 
       * @return No Content
       */
      getUserAuthToken(body: AuthCredentials | undefined): Promise<void> {
          let url_ = this.baseUrl + "/users/authorize";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserAuthToken(_response);
          });
      }
  
      protected processGetUserAuthToken(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Create new auth0 user
       * @param body (optional) 
       * @return No Content
       */
      createNewUser(body: CreateUserCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/users/create";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateNewUser(_response);
          });
      }
  
      protected processCreateNewUser(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Refresh Auth0 token
       * @return Success
       */
      refreshToken(token: string): Promise<AccessTokenResponse> {
          let url_ = this.baseUrl + "/users/refresh-token/{token}";
          if (token === undefined || token === null)
              throw new Error("The parameter 'token' must be defined.");
          url_ = url_.replace("{token}", encodeURIComponent("" + token));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRefreshToken(_response);
          });
      }
  
      protected processRefreshToken(response: Response): Promise<AccessTokenResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessTokenResponse;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AccessTokenResponse>(null as any);
      }
  
      /**
       * Triggers forgot password email
       * @return Success
       */
      forgotPassword(email: string): Promise<void> {
          let url_ = this.baseUrl + "/users/forgot-password/{email}";
          if (email === undefined || email === null)
              throw new Error("The parameter 'email' must be defined.");
          url_ = url_.replace("{email}", encodeURIComponent("" + email));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processForgotPassword(_response);
          });
      }
  
      protected processForgotPassword(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Update user avatar
       * @param body (optional) 
       * @return No Content
       */
      updateUserAvatar(body: UpdateAvatarCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/account/avatar";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateUserAvatar(_response);
          });
      }
  
      protected processUpdateUserAvatar(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * create an achievement
       * @param body (optional) 
       * @return Success
       */
      createAchievement(body: CreateAchievementRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/achievements";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateAchievement(_response);
          });
      }
  
      protected processCreateAchievement(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * updates an achievement
       * @param body (optional) 
       * @return Success
       */
      updateAchievement(body: AchievementDefinition | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/achievements";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateAchievement(_response);
          });
      }
  
      protected processUpdateAchievement(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * lists achievements for a project
       * @return Success
       */
      listAchievements(projectId: number): Promise<AchievementDefinition[]> {
          let url_ = this.baseUrl + "/achievements/{projectId}";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processListAchievements(_response);
          });
      }
  
      protected processListAchievements(response: Response): Promise<AchievementDefinition[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AchievementDefinition[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AchievementDefinition[]>(null as any);
      }
  
      /**
       * Gets the information about all achievements for a product
       * @param pageNum (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getAllAchievementDefinitions(productId: string, pageNum: number | undefined, pageSize: number | undefined): Promise<AchievementDefinitionPagedResponseListMessage> {
          let url_ = this.baseUrl + "/achievements/{productId}/get-all-definitions?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (pageNum === null)
              throw new Error("The parameter 'pageNum' cannot be null.");
          else if (pageNum !== undefined)
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAllAchievementDefinitions(_response);
          });
      }
  
      protected processGetAllAchievementDefinitions(response: Response): Promise<AchievementDefinitionPagedResponseListMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AchievementDefinitionPagedResponseListMessage;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AchievementDefinitionPagedResponseListMessage>(null as any);
      }
  
      /**
       * Gets the information about specified achievements
       * @param body (optional) 
       * @return Success
       */
      getAchievementDefinitionsByName(productId: string, body: ApiNamesRequest | undefined): Promise<AchievementDefinitionPagedResponseListMessage> {
          let url_ = this.baseUrl + "/achievements/{productId}/get-definitions-by-name";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAchievementDefinitionsByName(_response);
          });
      }
  
      protected processGetAchievementDefinitionsByName(response: Response): Promise<AchievementDefinitionPagedResponseListMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AchievementDefinitionPagedResponseListMessage;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AchievementDefinitionPagedResponseListMessage>(null as any);
      }
  
      /**
       * lists all achievement progress for user
       * @param pageNum (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getAllAchievementProgress(productId: string, pageNum: number | undefined, pageSize: number | undefined): Promise<AchievementProgressPagedResponseListMessage> {
          let url_ = this.baseUrl + "/achievements/{productId}/get-all-progress?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (pageNum === null)
              throw new Error("The parameter 'pageNum' cannot be null.");
          else if (pageNum !== undefined)
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAllAchievementProgress(_response);
          });
      }
  
      protected processGetAllAchievementProgress(response: Response): Promise<AchievementProgressPagedResponseListMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AchievementProgressPagedResponseListMessage;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AchievementProgressPagedResponseListMessage>(null as any);
      }
  
      /**
       * returns the achievement
       * @return Success
       */
      getAchievement(productId: string, apiName: string): Promise<AchievementDefinition> {
          let url_ = this.baseUrl + "/achievements/{productId}/{apiName}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (apiName === undefined || apiName === null)
              throw new Error("The parameter 'apiName' must be defined.");
          url_ = url_.replace("{apiName}", encodeURIComponent("" + apiName));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAchievement(_response);
          });
      }
  
      protected processGetAchievement(response: Response): Promise<AchievementDefinition> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AchievementDefinition;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AchievementDefinition>(null as any);
      }
  
      /**
       * returns the achievement progress for the user by api names
       * @param body (optional) 
       * @return Success
       */
      getAchievementProgressByName(productId: string, body: ApiNamesRequest | undefined): Promise<AchievementProgressPagedResponseListMessage> {
          let url_ = this.baseUrl + "/achievements/{productId}/get-progress-by-name";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAchievementProgressByName(_response);
          });
      }
  
      protected processGetAchievementProgressByName(response: Response): Promise<AchievementProgressPagedResponseListMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AchievementProgressPagedResponseListMessage;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AchievementProgressPagedResponseListMessage>(null as any);
      }
  
      /**
       * deletes an achievement
       * @return Success
       */
      deleteAchievements(achievementId: number): Promise<boolean> {
          let url_ = this.baseUrl + "/achievements/{achievementId}";
          if (achievementId === undefined || achievementId === null)
              throw new Error("The parameter 'achievementId' must be defined.");
          url_ = url_.replace("{achievementId}", encodeURIComponent("" + achievementId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteAchievements(_response);
          });
      }
  
      protected processDeleteAchievements(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Gets user achievement
       * @return Success
       */
      getUsersAchievement(productId: string, apiName: string): Promise<AchievementProgress> {
          let url_ = this.baseUrl + "/achievements/user/{productId}/{apiName}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{ProductId}", encodeURIComponent("" + productId));
          if (apiName === undefined || apiName === null)
              throw new Error("The parameter 'apiName' must be defined.");
          url_ = url_.replace("{ApiName}", encodeURIComponent("" + apiName));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUsersAchievement(_response);
          });
      }
  
      protected processGetUsersAchievement(response: Response): Promise<AchievementProgress> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AchievementProgress;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AchievementProgress>(null as any);
      }
  
      /**
       * Unlocks the user achievement
       * @param body (optional) 
       * @return Success
       */
      unlockUsersAchievement(productId: string, body: UnlockUserAchievementRequest | undefined): Promise<AchievementUpdate> {
          let url_ = this.baseUrl + "/achievements/{productId}/unlock";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUnlockUsersAchievement(_response);
          });
      }
  
      protected processUnlockUsersAchievement(response: Response): Promise<AchievementUpdate> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AchievementUpdate;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AchievementUpdate>(null as any);
      }
  
      /**
       * set the count for the user achievement
       * @param body (optional) 
       * @return Success
       */
      setUsersCountAchievement(productId: string, body: AchievementUpdateRequest | undefined): Promise<AchievementUpdateMessage> {
          let url_ = this.baseUrl + "/achievements/{productId}/add-count";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetUsersCountAchievement(_response);
          });
      }
  
      protected processSetUsersCountAchievement(response: Response): Promise<AchievementUpdateMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AchievementUpdateMessage;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AchievementUpdateMessage>(null as any);
      }
  
      /**
       * unlock the fields that are true
       * @param body (optional) 
       * @return Success
       */
      unlockFieldsUsersAchievement(productId: string, body: AchievementAddFieldsRequest | undefined): Promise<AchievementUpdateMessage> {
          let url_ = this.baseUrl + "/achievements/{productId}/add-fields";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUnlockFieldsUsersAchievement(_response);
          });
      }
  
      protected processUnlockFieldsUsersAchievement(response: Response): Promise<AchievementUpdateMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AchievementUpdateMessage;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AchievementUpdateMessage>(null as any);
      }
  
      /**
       * Upload Build
       * @param body (optional) 
       * @return Success
       */
      uploadProjectBuild(projectId: number, body: UploadProjectBuildCommand | undefined): Promise<string> {
          let url_ = this.baseUrl + "/content-provider/build/{projectId}";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUploadProjectBuild(_response);
          });
      }
  
      protected processUploadProjectBuild(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Update a projects build name
       * @param body (optional) 
       * @return Success
       */
      updateProjectBuildName(projectId: number, body: UpdateProjectBuildNameCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/build/{projectId}";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateProjectBuildName(_response);
          });
      }
  
      protected processUpdateProjectBuildName(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get project builds
       * @param releaseChannel (optional) 
       * @return Success
       */
      getProjectBuilds(projectId: number, releaseChannel: ReleaseChannel | undefined): Promise<ProductReleaseDtoIEnumerableResult> {
          let url_ = this.baseUrl + "/content-provider/build/{projectId}?";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          if (releaseChannel === null)
              throw new Error("The parameter 'releaseChannel' cannot be null.");
          else if (releaseChannel !== undefined)
              url_ += "releaseChannel=" + encodeURIComponent("" + releaseChannel) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProjectBuilds(_response);
          });
      }
  
      protected processGetProjectBuilds(response: Response): Promise<ProductReleaseDtoIEnumerableResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductReleaseDtoIEnumerableResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductReleaseDtoIEnumerableResult>(null as any);
      }
  
      /**
       * Get the latest project build
       * @param releaseChannel (optional) 
       * @return Success
       */
      getLatestProjectBuild(projectId: number, releaseChannel: ReleaseChannel | undefined): Promise<ProductReleaseDto> {
          let url_ = this.baseUrl + "/content-provider/build/{projectId}/latest?";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          if (releaseChannel === null)
              throw new Error("The parameter 'releaseChannel' cannot be null.");
          else if (releaseChannel !== undefined)
              url_ += "releaseChannel=" + encodeURIComponent("" + releaseChannel) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLatestProjectBuild(_response);
          });
      }
  
      protected processGetLatestProjectBuild(response: Response): Promise<ProductReleaseDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductReleaseDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductReleaseDto>(null as any);
      }
  
      /**
       * Delete a build for a project
       * @return Success
       */
      deleteProjectBuild(buildId: string, projectId: number): Promise<Result> {
          let url_ = this.baseUrl + "/content-provider/build/{projectId}/{buildId}";
          if (buildId === undefined || buildId === null)
              throw new Error("The parameter 'buildId' must be defined.");
          url_ = url_.replace("{buildId}", encodeURIComponent("" + buildId));
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteProjectBuild(_response);
          });
      }
  
      protected processDeleteProjectBuild(response: Response): Promise<Result> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Result>(null as any);
      }
  
      /**
       * Moves the uploaded file to permanent file and ties it to the user and the game
       * @param body (optional) 
       * @return Success
       */
      associateUpload(body: CloudAssoicateUpdateRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/cloud-api/associate-upload";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAssociateUpload(_response);
          });
      }
  
      protected processAssociateUpload(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get project collaborators
       * @param projectId (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getProjectCollaborators(projectId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<ProjectCollaboratorDtoPagedResult> {
          let url_ = this.baseUrl + "/content-provider/collaborators?";
          if (projectId === null)
              throw new Error("The parameter 'projectId' cannot be null.");
          else if (projectId !== undefined)
              url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProjectCollaborators(_response);
          });
      }
  
      protected processGetProjectCollaborators(response: Response): Promise<ProjectCollaboratorDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectCollaboratorDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProjectCollaboratorDtoPagedResult>(null as any);
      }
  
      /**
       * Update project collaborators
       * @param body (optional) 
       * @return Success
       */
      updateProjectCollaborators(body: UpdateCollaboratorsCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/collaborators";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateProjectCollaborators(_response);
          });
      }
  
      protected processUpdateProjectCollaborators(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Delete project collaborator
       * @return Success
       */
      deleteProjectCollaborator(collaboratorId: number, projectId: number): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/collaborators/{projectId}/remove-collaborator/{collaboratorId}";
          if (collaboratorId === undefined || collaboratorId === null)
              throw new Error("The parameter 'collaboratorId' must be defined.");
          url_ = url_.replace("{collaboratorId}", encodeURIComponent("" + collaboratorId));
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteProjectCollaborator(_response);
          });
      }
  
      protected processDeleteProjectCollaborator(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Invite project collaborator
       * @param body (optional) 
       * @return Success
       */
      inviteProjectCollaborator(body: InviteCollaboratorCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/collaborators/invite-collaborator";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processInviteProjectCollaborator(_response);
          });
      }
  
      protected processInviteProjectCollaborator(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Accept invitation
       * @param body (optional) 
       * @return Success
       */
      acceptInvitation(body: AcceptInvitationCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/collaborators/accept-invitation";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAcceptInvitation(_response);
          });
      }
  
      protected processAcceptInvitation(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Decline invitation
       * @param body (optional) 
       * @return Success
       */
      declineInvitation(body: DeclineInvitationCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/collaborators/decline-invitation";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeclineInvitation(_response);
          });
      }
  
      protected processDeclineInvitation(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get invitation info
       * @param invitationId (optional) 
       * @return Success
       */
      getInvitationInfo(invitationId: number | undefined): Promise<InvitationEmailDto> {
          let url_ = this.baseUrl + "/content-provider/collaborators/invitation-info?";
          if (invitationId === null)
              throw new Error("The parameter 'invitationId' cannot be null.");
          else if (invitationId !== undefined)
              url_ += "InvitationId=" + encodeURIComponent("" + invitationId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetInvitationInfo(_response);
          });
      }
  
      protected processGetInvitationInfo(response: Response): Promise<InvitationEmailDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvitationEmailDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<InvitationEmailDto>(null as any);
      }
  
      /**
       * Get invitations for user
       * @param userEmail (optional) 
       * @return Success
       */
      getUserInvitations(userEmail: string | undefined): Promise<ProjectInvitationDto[]> {
          let url_ = this.baseUrl + "/content-provider/collaborators/user-invitations?";
          if (userEmail === null)
              throw new Error("The parameter 'userEmail' cannot be null.");
          else if (userEmail !== undefined)
              url_ += "UserEmail=" + encodeURIComponent("" + userEmail) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserInvitations(_response);
          });
      }
  
      protected processGetUserInvitations(response: Response): Promise<ProjectInvitationDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectInvitationDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProjectInvitationDto[]>(null as any);
      }
  
      /**
       * Get list of submissions
       * @param search (optional) 
       * @return Success
       */
      getSubmissionList(includedStatuses: ProductStatus[], pageNum: number, pageSize: number, sortField: SubmissionsTableSortField, sortOrder: SortOrder, search: string | undefined): Promise<SubmissionItemDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions?";
          if (includedStatuses === undefined || includedStatuses === null)
              throw new Error("The parameter 'includedStatuses' must be defined and cannot be null.");
          else
              includedStatuses && includedStatuses.forEach(item => { url_ += "IncludedStatuses=" + encodeURIComponent("" + item) + "&"; });
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (search === null)
              throw new Error("The parameter 'search' cannot be null.");
          else if (search !== undefined)
              url_ += "Search=" + encodeURIComponent("" + search) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetSubmissionList(_response);
          });
      }
  
      protected processGetSubmissionList(response: Response): Promise<SubmissionItemDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubmissionItemDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubmissionItemDtoPagedResult>(null as any);
      }
  
      /**
       * Get list of submissions audit log
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param searchTerm (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getSubmissionsAuditLogList(sortField: SubmissionsAuditLogSortField | undefined, sortOrder: SortOrder | undefined, searchTerm: string | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<SubmissionsAuditLogDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions/auditLog?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetSubmissionsAuditLogList(_response);
          });
      }
  
      protected processGetSubmissionsAuditLogList(response: Response): Promise<SubmissionsAuditLogDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubmissionsAuditLogDtoPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubmissionsAuditLogDtoPagedResult>(null as any);
      }
  
      /**
       * Export list of submissions audit log
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param searchTerm (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      exportSubmissionsAuditLog(sortField: SubmissionsAuditLogSortField | undefined, sortOrder: SortOrder | undefined, searchTerm: string | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions/auditLog/export?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportSubmissionsAuditLog(_response);
          });
      }
  
      protected processExportSubmissionsAuditLog(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get list of statements
       * @param projectId (optional) 
       * @return Success
       */
      getStatementsList(pageNum: number, pageSize: number, sortField: StatementsSortField, sortOrder: SortOrder, projectId: number | undefined): Promise<StripeBalanceDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/cp-management/statements?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (projectId === null)
              throw new Error("The parameter 'projectId' cannot be null.");
          else if (projectId !== undefined)
              url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetStatementsList(_response);
          });
      }
  
      protected processGetStatementsList(response: Response): Promise<StripeBalanceDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripeBalanceDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StripeBalanceDtoPagedResult>(null as any);
      }
  
      /**
       * Get submission review detail
       * @return Success
       */
      getSubmissionReview(productId: string): Promise<SubmissionReviewDto> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions/{productId}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetSubmissionReview(_response);
          });
      }
  
      protected processGetSubmissionReview(response: Response): Promise<SubmissionReviewDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubmissionReviewDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubmissionReviewDto>(null as any);
      }
  
      /**
       * Set Review item values
       * @param body (optional) 
       * @return Success
       */
      updateReviewValues(productId: string, body: UpdateReviewValuesCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions/{productId}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateReviewValues(_response);
          });
      }
  
      protected processUpdateReviewValues(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Update user subscription
       * @param body (optional) 
       * @return Success
       */
      updateUserSubscription(body: boolean | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions/update-user-subscription";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateUserSubscription(_response);
          });
      }
  
      protected processUpdateUserSubscription(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Add/Remove a product to/from admin library
       * @param body (optional) 
       * @return Success
       */
      updateUserAcquirement(body: UpdateAcquirementToggleCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions/update-user-acquirement";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateUserAcquirement(_response);
          });
      }
  
      protected processUpdateUserAcquirement(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Entitle/unentitle a product
       * @param body (optional) 
       * @return Success
       */
      updateUserEntitlement(body: UpdateEntitlementToggleCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions/update-user-entitlement";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateUserEntitlement(_response);
          });
      }
  
      protected processUpdateUserEntitlement(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Request changes for a product
       * @return Success
       */
      requestProductChanges(productId: string): Promise<void> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions/request-changes/{productId}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRequestProductChanges(_response);
          });
      }
  
      protected processRequestProductChanges(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Reject a product
       * @param body (optional) 
       * @return Success
       */
      rejectProduct(productId: string, body: RejectProductCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions/reject/{productId}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRejectProduct(_response);
          });
      }
  
      protected processRejectProduct(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Approve a product
       * @return Success
       */
      approveProduct(productId: string): Promise<void> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions/approve/{productId}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processApproveProduct(_response);
          });
      }
  
      protected processApproveProduct(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get previous submission review doc
       * @return Success
       */
      getReviewDoc(productId: string): Promise<string> {
          let url_ = this.baseUrl + "/admin/cp-management/submissions/get-review-doc/{productId}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetReviewDoc(_response);
          });
      }
  
      protected processGetReviewDoc(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Gets summary of revenue related transactions by productId
       * @return Success
       */
      getContentProviderRevenueSummary(productId: string): Promise<ContentProviderRevenueSummaryDto> {
          let url_ = this.baseUrl + "/content-provider/revenue/{productId}/summary";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetContentProviderRevenueSummary(_response);
          });
      }
  
      protected processGetContentProviderRevenueSummary(response: Response): Promise<ContentProviderRevenueSummaryDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContentProviderRevenueSummaryDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ContentProviderRevenueSummaryDto>(null as any);
      }
  
      /**
       * Gets revenue stats by productId
       * @return Success
       */
      getContentProviderRevenueTimeline(productId: string): Promise<ContentProviderRevenueTimelineDto> {
          let url_ = this.baseUrl + "/content-provider/revenue/{productId}/timeline";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetContentProviderRevenueTimeline(_response);
          });
      }
  
      protected processGetContentProviderRevenueTimeline(response: Response): Promise<ContentProviderRevenueTimelineDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContentProviderRevenueTimelineDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ContentProviderRevenueTimelineDto>(null as any);
      }
  
      /**
       * Get country list
       * @return Success
       */
      getCountries(): Promise<CountryDto[]> {
          let url_ = this.baseUrl + "/countries";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetCountries(_response);
          });
      }
  
      protected processGetCountries(response: Response): Promise<CountryDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<CountryDto[]>(null as any);
      }
  
      /**
       * Get user country code
       * @return Success
       */
      getCurrentUserCountryCode(): Promise<CountryCodeDto> {
          let url_ = this.baseUrl + "/countries/current";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetCurrentUserCountryCode(_response);
          });
      }
  
      protected processGetCurrentUserCountryCode(response: Response): Promise<CountryCodeDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryCodeDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<CountryCodeDto>(null as any);
      }
  
      /**
       * Get dlc for product
       * @return Success
       */
      getAllDlcForProduct(pageNum: number, pageSize: number, productId: string, sortField: DownloadableContentSortField, sortOrder: SortOrder): Promise<DownloadableContentSummaryPagedResult> {
          let url_ = this.baseUrl + "/downloadable-content?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAllDlcForProduct(_response);
          });
      }
  
      protected processGetAllDlcForProduct(response: Response): Promise<DownloadableContentSummaryPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadableContentSummaryPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<DownloadableContentSummaryPagedResult>(null as any);
      }
  
      /**
       * Get published dlc details for product by list of skus
       * @param sKUs (optional) 
       * @return Success
       */
      getDetailsForProductBySKUs(productId: string, sKUs: string[] | undefined): Promise<DownloadableContentClientDetailsDtoPagedResponseListMessage> {
          let url_ = this.baseUrl + "/downloadable-content/get-details-for-product-by-skus?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (sKUs === null)
              throw new Error("The parameter 'sKUs' cannot be null.");
          else if (sKUs !== undefined)
              sKUs && sKUs.forEach(item => { url_ += "SKUs=" + encodeURIComponent("" + item) + "&"; });
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetDetailsForProductBySKUs(_response);
          });
      }
  
      protected processGetDetailsForProductBySKUs(response: Response): Promise<DownloadableContentClientDetailsDtoPagedResponseListMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadableContentClientDetailsDtoPagedResponseListMessage;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<DownloadableContentClientDetailsDtoPagedResponseListMessage>(null as any);
      }
  
      /**
       * Get  published dlc details for product by page
       * @return Success
       */
      getDetailsForProductByPage(productId: string, pageSize: number, pageNum: number): Promise<DownloadableContentClientDetailsDtoPagedResponseList> {
          let url_ = this.baseUrl + "/downloadable-content/get-details-for-product-by-page?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetDetailsForProductByPage(_response);
          });
      }
  
      protected processGetDetailsForProductByPage(response: Response): Promise<DownloadableContentClientDetailsDtoPagedResponseList> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadableContentClientDetailsDtoPagedResponseList;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<DownloadableContentClientDetailsDtoPagedResponseList>(null as any);
      }
  
      /**
       * Initialize a DLC
       * @param body (optional) 
       * @return Success
       */
      initializeForDLC(body: InitializeDLCRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/downloadable-content/initialize";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processInitializeForDLC(_response);
          });
      }
  
      protected processInitializeForDLC(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Update DLC description
       * @param body (optional) 
       * @return Success
       */
      updateDescriptionForDLC(body: UpdateDescriptionRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/downloadable-content/update-description";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateDescriptionForDLC(_response);
          });
      }
  
      protected processUpdateDescriptionForDLC(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Update DLC content rating
       * @param body (optional) 
       * @return Success
       */
      updateContentRatingForDLC(body: UpdateContentRatingRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/downloadable-content/update-content-rating";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateContentRatingForDLC(_response);
          });
      }
  
      protected processUpdateContentRatingForDLC(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Update DLC pricing
       * @param body (optional) 
       * @return Success
       */
      updatePricingForDLC(body: UpdatePricingRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/downloadable-content/update-pricing";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdatePricingForDLC(_response);
          });
      }
  
      protected processUpdatePricingForDLC(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Update DLC files
       * @param body (optional) 
       * @return Success
       */
      updateFilesForDLC(dlcId: number, body: UpdateDownloadableContentAssetItemsRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/downloadable-content/{dlcId}/dlc-files";
          if (dlcId === undefined || dlcId === null)
              throw new Error("The parameter 'dlcId' must be defined.");
          url_ = url_.replace("{dlcId}", encodeURIComponent("" + dlcId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateFilesForDLC(_response);
          });
      }
  
      protected processUpdateFilesForDLC(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Update DLC assets
       * @param body (optional) 
       * @return Success
       */
      updateAssetsForDLC(dlcId: number, body: UpdateDownloadableContentAssetItemsRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/downloadable-content/{dlcId}/dlc-assets";
          if (dlcId === undefined || dlcId === null)
              throw new Error("The parameter 'dlcId' must be defined.");
          url_ = url_.replace("{dlcId}", encodeURIComponent("" + dlcId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateAssetsForDLC(_response);
          });
      }
  
      protected processUpdateAssetsForDLC(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Validate a dlc file
       * @param uploadedFileNames (optional) 
       * @return No Content
       */
      validateDlcFile(dlcId: number, productId: string, fileName: string, uploadedFileNames: string[] | undefined): Promise<void> {
          let url_ = this.baseUrl + "/downloadable-content/{dlcId}/dlc-files/validate?";
          if (dlcId === undefined || dlcId === null)
              throw new Error("The parameter 'dlcId' must be defined.");
          url_ = url_.replace("{dlcId}", encodeURIComponent("" + dlcId));
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (fileName === undefined || fileName === null)
              throw new Error("The parameter 'fileName' must be defined and cannot be null.");
          else
              url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
          if (uploadedFileNames === null)
              throw new Error("The parameter 'uploadedFileNames' cannot be null.");
          else if (uploadedFileNames !== undefined)
              uploadedFileNames && uploadedFileNames.forEach(item => { url_ += "UploadedFileNames=" + encodeURIComponent("" + item) + "&"; });
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processValidateDlcFile(_response);
          });
      }
  
      protected processValidateDlcFile(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * validate sku
       * @param body (optional) 
       * @return Success
       */
      validateSKUForDLC(body: ValidateSKURequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/downloadable-content/validate-sku";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processValidateSKUForDLC(_response);
          });
      }
  
      protected processValidateSKUForDLC(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Get dlc details
       * @return Success
       */
      getDLCDetails(id: number): Promise<DownloadableContentDetailDto> {
          let url_ = this.baseUrl + "/downloadable-content/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetDLCDetails(_response);
          });
      }
  
      protected processGetDLCDetails(response: Response): Promise<DownloadableContentDetailDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadableContentDetailDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<DownloadableContentDetailDto>(null as any);
      }
  
      /**
       * Update DLC status
       * @param body (optional) 
       * @return Success
       */
      updateDLCStatusForDLC(body: UpdateStatusRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/downloadable-content/update-status";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateDLCStatusForDLC(_response);
          });
      }
  
      protected processUpdateDLCStatusForDLC(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get user dlc purchases
       * @return Success
       */
      getDlcPurchasesForUser(pageNum: number, pageSize: number, productId: string): Promise<DlcPurchasePagedResponseListMessage> {
          let url_ = this.baseUrl + "/downloadable-content/purchases?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetDlcPurchasesForUser(_response);
          });
      }
  
      protected processGetDlcPurchasesForUser(response: Response): Promise<DlcPurchasePagedResponseListMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcPurchasePagedResponseListMessage;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<DlcPurchasePagedResponseListMessage>(null as any);
      }
  
      /**
       * Get all assets for product
       * @return Success
       */
      getDlcAssetsForProduct(pageNum: number, pageSize: number, productId: string): Promise<DlcAssetDetailsDtoPagedResponseListMessage> {
          let url_ = this.baseUrl + "/downloadable-content/assets?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetDlcAssetsForProduct(_response);
          });
      }
  
      protected processGetDlcAssetsForProduct(response: Response): Promise<DlcAssetDetailsDtoPagedResponseListMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcAssetDetailsDtoPagedResponseListMessage;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<DlcAssetDetailsDtoPagedResponseListMessage>(null as any);
      }
  
      /**
       * Consume a consumable addon
       * @param body (optional) 
       * @return Success
       */
      consumeDlcForUser(body: ConsumeDlcForUserRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/downloadable-content/consume";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processConsumeDlcForUser(_response);
          });
      }
  
      protected processConsumeDlcForUser(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Purchase a DLC
       * @param body (optional) 
       * @return Success
       */
      purchaseDlc(body: PurchaseDlcRequest | undefined): Promise<DlcPurchaseMessage> {
          let url_ = this.baseUrl + "/downloadable-content/purchase";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processPurchaseDlc(_response);
          });
      }
  
      protected processPurchaseDlc(response: Response): Promise<DlcPurchaseMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcPurchaseMessage;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<DlcPurchaseMessage>(null as any);
      }
  
      /**
       * Get Purchase Details of DLC
       * @param productId (optional) 
       * @param sku (optional) 
       * @param paymentMethodId (optional) 
       * @return Success
       */
      getPurchaseDlcDetails(productId: string | undefined, sku: string | undefined, paymentMethodId: string | undefined): Promise<DlcPurchaseDetailsMessage> {
          let url_ = this.baseUrl + "/downloadable-content/purchase-details?";
          if (productId === null)
              throw new Error("The parameter 'productId' cannot be null.");
          else if (productId !== undefined)
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (sku === null)
              throw new Error("The parameter 'sku' cannot be null.");
          else if (sku !== undefined)
              url_ += "Sku=" + encodeURIComponent("" + sku) + "&";
          if (paymentMethodId === null)
              throw new Error("The parameter 'paymentMethodId' cannot be null.");
          else if (paymentMethodId !== undefined)
              url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetPurchaseDlcDetails(_response);
          });
      }
  
      protected processGetPurchaseDlcDetails(response: Response): Promise<DlcPurchaseDetailsMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DlcPurchaseDetailsMessage;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<DlcPurchaseDetailsMessage>(null as any);
      }
  
      /**
       * Get downloadable content file link
       * @param fileId (optional) 
       * @param fileName (optional) 
       * @return Success
       */
      getDlcFileById(productId: string, fileId: number | undefined, fileName: string | undefined): Promise<DownloadableContentFile> {
          let url_ = this.baseUrl + "/downloadable-content/file/{productId}?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (fileId === null)
              throw new Error("The parameter 'fileId' cannot be null.");
          else if (fileId !== undefined)
              url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
          if (fileName === null)
              throw new Error("The parameter 'fileName' cannot be null.");
          else if (fileName !== undefined)
              url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetDlcFileById(_response);
          });
      }
  
      protected processGetDlcFileById(response: Response): Promise<DownloadableContentFile> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadableContentFile;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<DownloadableContentFile>(null as any);
      }
  
      /**
       * Get version codes of builds by productId
       * @return Success
       */
      getVersionCodesByProductId(productId: string): Promise<VersionCodesDto[]> {
          let url_ = this.baseUrl + "/downloadable-content/{productId}/version-codes";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetVersionCodesByProductId(_response);
          });
      }
  
      protected processGetVersionCodesByProductId(response: Response): Promise<VersionCodesDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionCodesDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<VersionCodesDto[]>(null as any);
      }
  
      /**
       * remove dlc from user content by productId and sku, only available for qa
       * @return No Content
       */
      delete(productId: string, sku: string, userId: string): Promise<void> {
          let url_ = this.baseUrl + "/downloadable-content/remove-dlc?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "productId=" + encodeURIComponent("" + productId) + "&";
          if (sku === undefined || sku === null)
              throw new Error("The parameter 'sku' must be defined and cannot be null.");
          else
              url_ += "sku=" + encodeURIComponent("" + sku) + "&";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined and cannot be null.");
          else
              url_ += "userId=" + encodeURIComponent("" + userId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDelete(_response);
          });
      }
  
      protected processDelete(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Creates public/private key used for entitlement check
       * @return Success
       */
      initialize(): Promise<string> {
          let url_ = this.baseUrl + "/entitlement/initialize";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processInitialize(_response);
          });
      }
  
      protected processInitialize(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Returns if the user is entiled to play game
       * @param userId (optional) 
       * @param encryptedToken (optional) 
       * @param applicationId (optional) 
       * @param entitlementKey (optional) 
       * @return Success
       */
      isEntitled(userId: string | undefined, encryptedToken: string | undefined, applicationId: string | undefined, entitlementKey: string | undefined): Promise<string> {
          let url_ = this.baseUrl + "/entitlement/check";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = new FormData();
          if (userId === null || userId === undefined)
              throw new Error("The parameter 'userId' cannot be null.");
          else
              content_.append("userId", userId.toString());
          if (encryptedToken === null || encryptedToken === undefined)
              throw new Error("The parameter 'encryptedToken' cannot be null.");
          else
              content_.append("encryptedToken", encryptedToken.toString());
          if (applicationId === null || applicationId === undefined)
              throw new Error("The parameter 'applicationId' cannot be null.");
          else
              content_.append("applicationId", applicationId.toString());
          if (entitlementKey === null || entitlementKey === undefined)
              throw new Error("The parameter 'entitlementKey' cannot be null.");
          else
              content_.append("entitlementKey", entitlementKey.toString());
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processIsEntitled(_response);
          });
      }
  
      protected processIsEntitled(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Checks if the user has Omni Online service
       * @param omniSerialNumber (optional) 
       * @return Success
       */
      omniOnlineService(omniSerialNumber: string | undefined): Promise<string> {
          let url_ = this.baseUrl + "/entitlement/omni-online-service?";
          if (omniSerialNumber === null)
              throw new Error("The parameter 'omniSerialNumber' cannot be null.");
          else if (omniSerialNumber !== undefined)
              url_ += "omniSerialNumber=" + encodeURIComponent("" + omniSerialNumber) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processOmniOnlineService(_response);
          });
      }
  
      protected processOmniOnlineService(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Returns content for a given s3 key
       * @return Success
       */
      getBase64EncodedContent(key: string): Promise<string> {
          let url_ = this.baseUrl + "/files?";
          if (key === undefined || key === null)
              throw new Error("The parameter 'key' must be defined and cannot be null.");
          else
              url_ += "key=" + encodeURIComponent("" + key) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetBase64EncodedContent(_response);
          });
      }
  
      protected processGetBase64EncodedContent(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Get actual Android middleware
       * @param query (optional) 
       * @return Success
       */
      getLatestAndroidMiddleware(query: GetLatestMiddlewareQuery | undefined): Promise<AndroidMiddlewareFileInfoDto> {
          let url_ = this.baseUrl + "/files/middleware/latest?";
          if (query === null)
              throw new Error("The parameter 'query' cannot be null.");
          else if (query !== undefined)
              url_ += "query=" + encodeURIComponent("" + query) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLatestAndroidMiddleware(_response);
          });
      }
  
      protected processGetLatestAndroidMiddleware(response: Response): Promise<AndroidMiddlewareFileInfoDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AndroidMiddlewareFileInfoDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AndroidMiddlewareFileInfoDto>(null as any);
      }
  
      /**
       * Get actual pui middleware
       * @param query (optional) 
       * @return Success
       */
      getLatestPui(query: GetLatestMiddlewareQuery | undefined): Promise<AndroidMiddlewareFileInfoDto> {
          let url_ = this.baseUrl + "/files/pui/latest?";
          if (query === null)
              throw new Error("The parameter 'query' cannot be null.");
          else if (query !== undefined)
              url_ += "query=" + encodeURIComponent("" + query) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLatestPui(_response);
          });
      }
  
      protected processGetLatestPui(response: Response): Promise<AndroidMiddlewareFileInfoDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AndroidMiddlewareFileInfoDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AndroidMiddlewareFileInfoDto>(null as any);
      }
  
      /**
       * Get actual VR Launcher
       * @param query (optional) 
       * @return Success
       */
      getLatestVRLauncher(query: GetLatestVRLauncherQuery | undefined): Promise<VRLauncherFileInfoDto> {
          let url_ = this.baseUrl + "/files/launcher/latest?";
          if (query === null)
              throw new Error("The parameter 'query' cannot be null.");
          else if (query !== undefined)
              url_ += "query=" + encodeURIComponent("" + query) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLatestVRLauncher(_response);
          });
      }
  
      protected processGetLatestVRLauncher(response: Response): Promise<VRLauncherFileInfoDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VRLauncherFileInfoDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<VRLauncherFileInfoDto>(null as any);
      }
  
      /**
       * Get pre-signed upload link to s3
       * @param fileName (optional) 
       * @return Success
       */
      getUploadLink(fileName: string | undefined): Promise<FileStorageItemDto> {
          let url_ = this.baseUrl + "/admin/files/upload-link?";
          if (fileName === null)
              throw new Error("The parameter 'fileName' cannot be null.");
          else if (fileName !== undefined)
              url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUploadLink(_response);
          });
      }
  
      protected processGetUploadLink(response: Response): Promise<FileStorageItemDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileStorageItemDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileStorageItemDto>(null as any);
      }
  
      /**
       * Get pre-signed download link from s3
       * @param galleryItemId (optional) 
       * @return Success
       */
      getDownloadLink(galleryItemId: string | undefined): Promise<string> {
          let url_ = this.baseUrl + "/admin/files/download-link?";
          if (galleryItemId === null)
              throw new Error("The parameter 'galleryItemId' cannot be null.");
          else if (galleryItemId !== undefined)
              url_ += "GalleryItemId=" + encodeURIComponent("" + galleryItemId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetDownloadLink(_response);
          });
      }
  
      protected processGetDownloadLink(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Validate apk file
       * @param key (optional) 
       * @param fileName (optional) 
       * @return Success
       */
      validateProductBuild(key: string | undefined, fileName: string | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/files/validate-build?";
          if (key === null)
              throw new Error("The parameter 'key' cannot be null.");
          else if (key !== undefined)
              url_ += "Key=" + encodeURIComponent("" + key) + "&";
          if (fileName === null)
              throw new Error("The parameter 'fileName' cannot be null.");
          else if (fileName !== undefined)
              url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processValidateProductBuild(_response);
          });
      }
  
      protected processValidateProductBuild(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get Android middleware history
       * @return Success
       */
      getAndroidMiddlewareHistory(pageNum: number, pageSize: number, sortField: SystemFileTableSortField, sortOrder: SortOrder): Promise<SystemFileDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/files/middleware?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAndroidMiddlewareHistory(_response);
          });
      }
  
      protected processGetAndroidMiddlewareHistory(response: Response): Promise<SystemFileDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemFileDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SystemFileDtoPagedResult>(null as any);
      }
  
      /**
       * Upload Android middleware
       * @param body (optional) 
       * @return No Content
       */
      uploadAndroidMiddleware(body: UploadAndroidMiddlewareCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/files/middleware";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUploadAndroidMiddleware(_response);
          });
      }
  
      protected processUploadAndroidMiddleware(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get android file release history
       * @param fileType (optional) 
       * @return Success
       */
      getAndroidFileHistory(pageNum: number, pageSize: number, sortField: SystemFileTableSortField, sortOrder: SortOrder, fileType: SystemFileType | undefined): Promise<SystemFileDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/files/android?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (fileType === null)
              throw new Error("The parameter 'fileType' cannot be null.");
          else if (fileType !== undefined)
              url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAndroidFileHistory(_response);
          });
      }
  
      protected processGetAndroidFileHistory(response: Response): Promise<SystemFileDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemFileDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SystemFileDtoPagedResult>(null as any);
      }
  
      /**
       * Upload android files for headset
       * @param body (optional) 
       * @return No Content
       */
      uploadAndroidFile(body: UploadAndroidFileCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/files/android";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUploadAndroidFile(_response);
          });
      }
  
      protected processUploadAndroidFile(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get custom PUI history
       * @return Success
       */
      getCustomPuiHistory(pageNum: number, pageSize: number, sortField: SystemFileTableSortField, sortOrder: SortOrder): Promise<SystemFileDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/files/pui?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetCustomPuiHistory(_response);
          });
      }
  
      protected processGetCustomPuiHistory(response: Response): Promise<SystemFileDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemFileDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SystemFileDtoPagedResult>(null as any);
      }
  
      /**
       * Upload Custom PUI
       * @param body (optional) 
       * @return Success
       */
      uploadCustomPui(body: UploadCustomPuiCommand | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/admin/files/pui";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUploadCustomPui(_response);
          });
      }
  
      protected processUploadCustomPui(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Get Firmware history
       * @return Success
       */
      getFirmwareHistory(type: SystemFileType, pageNum: number, pageSize: number, sortField: SystemFileTableSortField, sortOrder: SortOrder): Promise<SystemFileDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/files/firmware?";
          if (type === undefined || type === null)
              throw new Error("The parameter 'type' must be defined and cannot be null.");
          else
              url_ += "Type=" + encodeURIComponent("" + type) + "&";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetFirmwareHistory(_response);
          });
      }
  
      protected processGetFirmwareHistory(response: Response): Promise<SystemFileDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemFileDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SystemFileDtoPagedResult>(null as any);
      }
  
      /**
       * Upload Firmware
       * @param body (optional) 
       * @return Success
       */
      uploadFirmware(body: UploadFirmwareCommand | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/admin/files/firmware";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUploadFirmware(_response);
          });
      }
  
      protected processUploadFirmware(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * create a firmware package
       * @return Success
       */
      createFirmwarePackage(): Promise<void> {
          let url_ = this.baseUrl + "/admin/files/firmware-package";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateFirmwarePackage(_response);
          });
      }
  
      protected processCreateFirmwarePackage(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * get all firmware package
       * @return Success
       */
      getAllFirmwarePackage(pageNumber: number, pageSize: number): Promise<FirmwarePackageDetailDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/files/firmware-package?";
          if (pageNumber === undefined || pageNumber === null)
              throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
          else
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAllFirmwarePackage(_response);
          });
      }
  
      protected processGetAllFirmwarePackage(response: Response): Promise<FirmwarePackageDetailDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FirmwarePackageDetailDtoPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FirmwarePackageDetailDtoPagedResult>(null as any);
      }
  
      /**
       * Validate image resolution
       * @param key (optional) 
       * @param maxHeight (optional) 
       * @param maxWidth (optional) 
       * @return Success
       */
      validateImageResolution(key: string | undefined, maxHeight: number | undefined, maxWidth: number | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/files/validate-resolution?";
          if (key === null)
              throw new Error("The parameter 'key' cannot be null.");
          else if (key !== undefined)
              url_ += "Key=" + encodeURIComponent("" + key) + "&";
          if (maxHeight === null)
              throw new Error("The parameter 'maxHeight' cannot be null.");
          else if (maxHeight !== undefined)
              url_ += "MaxHeight=" + encodeURIComponent("" + maxHeight) + "&";
          if (maxWidth === null)
              throw new Error("The parameter 'maxWidth' cannot be null.");
          else if (maxWidth !== undefined)
              url_ += "MaxWidth=" + encodeURIComponent("" + maxWidth) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processValidateImageResolution(_response);
          });
      }
  
      protected processValidateImageResolution(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Delete file from s3
       * @param body (optional) 
       */
      deleteFileByKey(body: DeleteFileCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/files";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "DELETE",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteFileByKey(_response);
          });
      }
  
      protected processDeleteFileByKey(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get account setup link
       * @param projectId (optional) 
       * @param returnUrl (optional) 
       * @return Success
       */
      getStripeAccountLink(projectId: number | undefined, returnUrl: string | undefined): Promise<StripeAccountLinkDto> {
          let url_ = this.baseUrl + "/content-provider/finance/account-link?";
          if (projectId === null)
              throw new Error("The parameter 'projectId' cannot be null.");
          else if (projectId !== undefined)
              url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
          if (returnUrl === null)
              throw new Error("The parameter 'returnUrl' cannot be null.");
          else if (returnUrl !== undefined)
              url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetStripeAccountLink(_response);
          });
      }
  
      protected processGetStripeAccountLink(response: Response): Promise<StripeAccountLinkDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripeAccountLinkDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StripeAccountLinkDto>(null as any);
      }
  
      /**
       * Get stripe account details
       * @param projectId (optional) 
       * @param returnUrl (optional) 
       * @return Success
       */
      getStripeAccount(projectId: number | undefined, returnUrl: string | undefined): Promise<StripeAccountResponseDto> {
          let url_ = this.baseUrl + "/content-provider/finance/stripe-account?";
          if (projectId === null)
              throw new Error("The parameter 'projectId' cannot be null.");
          else if (projectId !== undefined)
              url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
          if (returnUrl === null)
              throw new Error("The parameter 'returnUrl' cannot be null.");
          else if (returnUrl !== undefined)
              url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetStripeAccount(_response);
          });
      }
  
      protected processGetStripeAccount(response: Response): Promise<StripeAccountResponseDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripeAccountResponseDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StripeAccountResponseDto>(null as any);
      }
  
      /**
       * Submit FTUE feedback
       * @param body (optional) 
       * @return No Content
       */
      submitFtueFeedback(body: SubmitFtueFeedbackRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/ftue/feedback";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSubmitFtueFeedback(_response);
          });
      }
  
      protected processSubmitFtueFeedback(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Return if the user can redeem the code
       * @param productId (optional) 
       * @return Success
       */
      validateGameCode(code: string, productId: string | undefined): Promise<GameCode> {
          let url_ = this.baseUrl + "/game-codes/validate?";
          if (code === undefined || code === null)
              throw new Error("The parameter 'code' must be defined and cannot be null.");
          else
              url_ += "Code=" + encodeURIComponent("" + code) + "&";
          if (productId === null)
              throw new Error("The parameter 'productId' cannot be null.");
          else if (productId !== undefined)
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processValidateGameCode(_response);
          });
      }
  
      protected processValidateGameCode(response: Response): Promise<GameCode> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GameCode;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<GameCode>(null as any);
      }
  
      /**
       * Redeem a Game Code
       * @param body (optional) 
       * @return No Content
       */
      redeemGameCode(body: RedeemCodeRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/game-codes/redeem";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRedeemGameCode(_response);
          });
      }
  
      protected processRedeemGameCode(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get game credit by userId
       * @return Success
       */
      getGameCreditByUserId(userId: string): Promise<UserGameCreditDto> {
          let url_ = this.baseUrl + "/game-credit/{userId}";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetGameCreditByUserId(_response);
          });
      }
  
      protected processGetGameCreditByUserId(response: Response): Promise<UserGameCreditDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGameCreditDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserGameCreditDto>(null as any);
      }
  
      /**
       * Create game credit by userId
       * @param body (optional) 
       * @return Success
       */
      createGameCreditByUserId(body: CreateGameCreditByUserIdRequest | undefined): Promise<UserGameCreditDto> {
          let url_ = this.baseUrl + "/game-credit/create";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateGameCreditByUserId(_response);
          });
      }
  
      protected processCreateGameCreditByUserId(response: Response): Promise<UserGameCreditDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGameCreditDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserGameCreditDto>(null as any);
      }
  
      /**
       * upload csv to batch add
       * @param fileUpload (optional) 
       * @return Success
       */
      uploadCsvToBatchAdd(fileUpload: FileParameter | undefined): Promise<UploadCsvToBatchAddResultDto> {
          let url_ = this.baseUrl + "/game-credit/upload-csv-to-batch-add";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = new FormData();
          if (fileUpload === null || fileUpload === undefined)
              throw new Error("The parameter 'fileUpload' cannot be null.");
          else
              content_.append("fileUpload", fileUpload.data, fileUpload.fileName ? fileUpload.fileName : "fileUpload");
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUploadCsvToBatchAdd(_response);
          });
      }
  
      protected processUploadCsvToBatchAdd(response: Response): Promise<UploadCsvToBatchAddResultDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploadCsvToBatchAddResultDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UploadCsvToBatchAddResultDto>(null as any);
      }
  
      /**
       * get game credits user list
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @return Success
       */
      getUserGameCredits(pageNumber: number, pageSize: number, sortField: UserGameCreditListSortField | undefined, sortOrder: SortOrder | undefined): Promise<UserGameCreditListDtoPagedResult> {
          let url_ = this.baseUrl + "/game-credit/user-list?";
          if (pageNumber === undefined || pageNumber === null)
              throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
          else
              url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserGameCredits(_response);
          });
      }
  
      protected processGetUserGameCredits(response: Response): Promise<UserGameCreditListDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGameCreditListDtoPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserGameCreditListDtoPagedResult>(null as any);
      }
  
      /**
       * Redeem a Game Credit
       * @param body (optional) 
       * @return No Content
       */
      redeeemGameCredit(body: RedeemGameCreditRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/game-credit/redeem";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRedeeemGameCredit(_response);
          });
      }
  
      protected processRedeeemGameCredit(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * create an invite to a game
       * @param body (optional) 
       * @return Success
       */
      createInvite(body: CreateGameInviteRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/game-invite/create";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateInvite(_response);
          });
      }
  
      protected processCreateInvite(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Launch details for a game a user was invited to
       * @return Success
       */
      launchDetails(gameInviteId: number): Promise<string> {
          let url_ = this.baseUrl + "/game-invite/launch-details/{gameInviteId}";
          if (gameInviteId === undefined || gameInviteId === null)
              throw new Error("The parameter 'gameInviteId' must be defined.");
          url_ = url_.replace("{gameInviteId}", encodeURIComponent("" + gameInviteId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processLaunchDetails(_response);
          });
      }
  
      protected processLaunchDetails(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * check if the code is the any game redemption code
       * @param code (optional) 
       * @return Success
       */
      checkCodeIsForAnyGame(code: string | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/games/redemption-codes/checkCodeIsForAnyGame?";
          if (code === null)
              throw new Error("The parameter 'code' cannot be null.");
          else if (code !== undefined)
              url_ += "code=" + encodeURIComponent("" + code) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCheckCodeIsForAnyGame(_response);
          });
      }
  
      protected processCheckCodeIsForAnyGame(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Redeem a Any Game Code
       * @param body (optional) 
       * @return Success
       */
      redeeemcodesForAnyGame(body: RedeemAnyGameRedemptionCodeRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/games/redemption-codes/redeem";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRedeeemcodesForAnyGame(_response);
          });
      }
  
      protected processRedeeemcodesForAnyGame(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Return the any game redemption code if the user can redeem the code
       * @return No Content
       */
      getAvailableAnyGameCode(code: string): Promise<void> {
          let url_ = this.baseUrl + "/games/redemption-codes/{code}/available";
          if (code === undefined || code === null)
              throw new Error("The parameter 'code' must be defined.");
          url_ = url_.replace("{code}", encodeURIComponent("" + code));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAvailableAnyGameCode(_response);
          });
      }
  
      protected processGetAvailableAnyGameCode(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get game redemption codes
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getRedemptionCodesForGame(sortField: GameRedemptionCodeSortField | undefined, sortOrder: SortOrder | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<GameRedemptionCodeDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/games/redemption-codes?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetRedemptionCodesForGame(_response);
          });
      }
  
      protected processGetRedemptionCodesForGame(response: Response): Promise<GameRedemptionCodeDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GameRedemptionCodeDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<GameRedemptionCodeDtoPagedResult>(null as any);
      }
  
      /**
       * Generate redemption codes
       * @param body (optional) 
       * @return Success
       */
      generateRedemptionCodesForGame(body: GenerateGameRedemptionCodesRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/games/redemption-codes";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGenerateRedemptionCodesForGame(_response);
          });
      }
  
      protected processGenerateRedemptionCodesForGame(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Delete redemption codes
       * @param ids (optional) 
       * @return Success
       */
      deleteRedemptionCodesForGame(ids: number[] | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/games/redemption-codes?";
          if (ids === null)
              throw new Error("The parameter 'ids' cannot be null.");
          else if (ids !== undefined)
              ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteRedemptionCodesForGame(_response);
          });
      }
  
      protected processDeleteRedemptionCodesForGame(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Export redemption codes for game
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param exportType (optional) 
       * @return Success
       */
      exportRedemptionCodesForGame(sortField: GameRedemptionCodeSortField | undefined, sortOrder: SortOrder | undefined, exportType: ExportType | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/admin/games/redemption-codes/export?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (exportType === null)
              throw new Error("The parameter 'exportType' cannot be null.");
          else if (exportType !== undefined)
              url_ += "ExportType=" + encodeURIComponent("" + exportType) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportRedemptionCodesForGame(_response);
          });
      }
  
      protected processExportRedemptionCodesForGame(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Record the start of a game session
       * @param body (optional) 
       * @return Success
       */
      startGameSession(body: StartGameSessionRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/game-session/start";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processStartGameSession(_response);
          });
      }
  
      protected processStartGameSession(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Record the stop of a game session
       * @param body (optional) 
       * @return Success
       */
      stopGameSession(body: StopGameSessionRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/game-session/stop";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processStopGameSession(_response);
          });
      }
  
      protected processStopGameSession(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Record partial update of a game session (step count only)
       * @param body (optional) 
       * @return Success
       */
      updateGameSession(body: UpdateGameSessionRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/game-session/update";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateGameSession(_response);
          });
      }
  
      protected processUpdateGameSession(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Create a game stat
       * @param body (optional) 
       * @return Success
       */
      createGameStat(body: CreateGameStatsRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/game-stats";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateGameStat(_response);
          });
      }
  
      protected processCreateGameStat(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * updates a gameStat
       * @param body (optional) 
       * @return Success
       */
      updateGameStat(body: GameStatDto | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/game-stats";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateGameStat(_response);
          });
      }
  
      protected processUpdateGameStat(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * returns the game stat
       * @return Success
       */
      getGameStat(productId: string, apiName: string): Promise<GameStatDto> {
          let url_ = this.baseUrl + "/game-stats/{productId}/{apiName}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (apiName === undefined || apiName === null)
              throw new Error("The parameter 'apiName' must be defined.");
          url_ = url_.replace("{apiName}", encodeURIComponent("" + apiName));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetGameStat(_response);
          });
      }
  
      protected processGetGameStat(response: Response): Promise<GameStatDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GameStatDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<GameStatDto>(null as any);
      }
  
      /**
       * returns the game stats for a product
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getGameStats(productId: string, pageNumber: number | undefined, pageSize: number | undefined): Promise<GameStatDtoPagedResult> {
          let url_ = this.baseUrl + "/game-stats/{productId}?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetGameStats(_response);
          });
      }
  
      protected processGetGameStats(response: Response): Promise<GameStatDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GameStatDtoPagedResult;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<GameStatDtoPagedResult>(null as any);
      }
  
      /**
       * deletes a gameStat
       * @return Success
       */
      deleteGameStat(apiName: string): Promise<boolean> {
          let url_ = this.baseUrl + "/game-stats/{apiName}";
          if (apiName === undefined || apiName === null)
              throw new Error("The parameter 'apiName' must be defined.");
          url_ = url_.replace("{apiName}", encodeURIComponent("" + apiName));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteGameStat(_response);
          });
      }
  
      protected processDeleteGameStat(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Validates the given ApiName
       * @param body (optional) 
       * @return Success
       */
      validApiName(body: ValidateGameStatApiNameRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/game-stats/valid-api-name";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processValidApiName(_response);
          });
      }
  
      protected processValidApiName(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Number of active users
       * @return Success
       */
      activeUsers(productId: string): Promise<number> {
          let url_ = this.baseUrl + "/gameplay-analytics/{productId}/active-user-count";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processActiveUsers(_response);
          });
      }
  
      protected processActiveUsers(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Number of total all time sessions
       * @return Success
       */
      totalAllTimeSessions(productId: string): Promise<number> {
          let url_ = this.baseUrl + "/gameplay-analytics/{productId}/total-all-time-sessions";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalAllTimeSessions(_response);
          });
      }
  
      protected processTotalAllTimeSessions(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Number of total seconds played all time
       * @return Success
       */
      totalAllTimeSeconds(productId: string): Promise<number> {
          let url_ = this.baseUrl + "/gameplay-analytics/{productId}/total-all-time-seconds";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalAllTimeSeconds(_response);
          });
      }
  
      protected processTotalAllTimeSeconds(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Number of all time steps, calories, and miles
       * @return Success
       */
      totalAllTimeHealth(productId: string): Promise<HealthDto> {
          let url_ = this.baseUrl + "/gameplay-analytics/{productId}/total-all-time-health";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalAllTimeHealth(_response);
          });
      }
  
      protected processTotalAllTimeHealth(response: Response): Promise<HealthDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HealthDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<HealthDto>(null as any);
      }
  
      /**
       * Average all time seconds
       * @return Success
       */
      averageAllTimeSeconds(productId: string): Promise<number> {
          let url_ = this.baseUrl + "/gameplay-analytics/{productId}/average-all-time-seconds";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAverageAllTimeSeconds(_response);
          });
      }
  
      protected processAverageAllTimeSeconds(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Get Gameplay statistics for each day this month (except today)
       * @return Success
       */
      gameplayHoursMonthly(productId: string): Promise<GameplayHours[]> {
          let url_ = this.baseUrl + "/gameplay-analytics/{productId}/gameplay_hours_monthly";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGameplayHoursMonthly(_response);
          });
      }
  
      protected processGameplayHoursMonthly(response: Response): Promise<GameplayHours[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GameplayHours[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<GameplayHours[]>(null as any);
      }
  
      /**
       * Get Gameplay statistics for each month this year
       * @return Success
       */
      gameplayHoursYearly(productId: string): Promise<GameplayHours[]> {
          let url_ = this.baseUrl + "/gameplay-analytics/{productId}/gameplay_hours_yearly";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGameplayHoursYearly(_response);
          });
      }
  
      protected processGameplayHoursYearly(response: Response): Promise<GameplayHours[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GameplayHours[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<GameplayHours[]>(null as any);
      }
  
      /**
       * Top ten players by playtime
       * @return Success
       */
      topTenPlayersByPlayTime(productId: string): Promise<PlayersWithPlaytime[]> {
          let url_ = this.baseUrl + "/gameplay-analytics/{productId}/top-ten-players-by-playtime";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTopTenPlayersByPlayTime(_response);
          });
      }
  
      protected processTopTenPlayersByPlayTime(response: Response): Promise<PlayersWithPlaytime[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PlayersWithPlaytime[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<PlayersWithPlaytime[]>(null as any);
      }
  
      /**
       * Top ten games by playtime in last ninety days
       * @return Success
       */
      topTenGamesByPlayTimeInLastNinetyDays(): Promise<GamesWithPlaytime[]> {
          let url_ = this.baseUrl + "/gameplay-analytics/top-ten-games-by-playtime-in-last-ninety-days";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTopTenGamesByPlayTimeInLastNinetyDays(_response);
          });
      }
  
      protected processTopTenGamesByPlayTimeInLastNinetyDays(response: Response): Promise<GamesWithPlaytime[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GamesWithPlaytime[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<GamesWithPlaytime[]>(null as any);
      }
  
      /**
       * Top ten games by playtime in all times
       * @return Success
       */
      topTenGamesByPlayTimeInAlltimes(): Promise<GamesWithPlaytime[]> {
          let url_ = this.baseUrl + "/gameplay-analytics/top-ten-games-by-playtime-in-all-times";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTopTenGamesByPlayTimeInAlltimes(_response);
          });
      }
  
      protected processTopTenGamesByPlayTimeInAlltimes(response: Response): Promise<GamesWithPlaytime[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GamesWithPlaytime[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<GamesWithPlaytime[]>(null as any);
      }
  
      /**
       * Top users by playtime in last ninety days
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      topUsersByPlayTimeInLastNinetyDays(pageNumber: number | undefined, pageSize: number | undefined): Promise<UsersWithPlayTimePagedResult> {
          let url_ = this.baseUrl + "/gameplay-analytics/top-users-by-playtime-in-last-ninety-days?";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTopUsersByPlayTimeInLastNinetyDays(_response);
          });
      }
  
      protected processTopUsersByPlayTimeInLastNinetyDays(response: Response): Promise<UsersWithPlayTimePagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UsersWithPlayTimePagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UsersWithPlayTimePagedResult>(null as any);
      }
  
      /**
       * Top users by playtime in all times
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      topUsersByPlayTimeInAllTimes(pageNumber: number | undefined, pageSize: number | undefined): Promise<UsersWithPlayTimePagedResult> {
          let url_ = this.baseUrl + "/gameplay-analytics/top-users-by-playtime-in-all-times?";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTopUsersByPlayTimeInAllTimes(_response);
          });
      }
  
      protected processTopUsersByPlayTimeInAllTimes(response: Response): Promise<UsersWithPlayTimePagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UsersWithPlayTimePagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UsersWithPlayTimePagedResult>(null as any);
      }
  
      /**
       * Gets health statistics for this game for the user
       * @return Success
       */
      userHealthStatistics(productId: string): Promise<UserGameHealthStatistics> {
          let url_ = this.baseUrl + "/gameplay-analytics/{productId}/user-health-statistics";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUserHealthStatistics(_response);
          });
      }
  
      protected processUserHealthStatistics(response: Response): Promise<UserGameHealthStatistics> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGameHealthStatistics;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserGameHealthStatistics>(null as any);
      }
  
      /**
       * Gets health statistics for this game for the user
       * @return Success
       */
      userHealthStatistics2(productId: string, userId: string): Promise<UserGameHealthStatistics> {
          let url_ = this.baseUrl + "/gameplay-analytics/{productId}/user-health-statistics/{userId}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUserHealthStatistics2(_response);
          });
      }
  
      protected processUserHealthStatistics2(response: Response): Promise<UserGameHealthStatistics> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGameHealthStatistics;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserGameHealthStatistics>(null as any);
      }
  
      /**
       * Gets health statistics for all users
       * @return Success
       */
      totalHealthStatistics(): Promise<TotalGameHealthStatistics> {
          let url_ = this.baseUrl + "/gameplay-analytics/total-health-statistics";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalHealthStatistics(_response);
          });
      }
  
      protected processTotalHealthStatistics(response: Response): Promise<TotalGameHealthStatistics> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TotalGameHealthStatistics;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<TotalGameHealthStatistics>(null as any);
      }
  
      /**
       * Gets average number of games played per vr session over last ninety days
       * @return Success
       */
      averageNumberOfGamesPlayedPerVRSessionOverLastNinetyDays(): Promise<number> {
          let url_ = this.baseUrl + "/gameplay-analytics/average-number-of-games-played-per-vr-session-over-last-ninety-days";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAverageNumberOfGamesPlayedPerVRSessionOverLastNinetyDays(_response);
          });
      }
  
      protected processAverageNumberOfGamesPlayedPerVRSessionOverLastNinetyDays(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Gets vr hours in last thirty days
       * @return Success
       */
      vrHoursInLastThirtyDays(): Promise<VRplayHours[]> {
          let url_ = this.baseUrl + "/gameplay-analytics/vr-hours-in-last-thirty-days";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processVrHoursInLastThirtyDays(_response);
          });
      }
  
      protected processVrHoursInLastThirtyDays(response: Response): Promise<VRplayHours[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VRplayHours[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<VRplayHours[]>(null as any);
      }
  
      /**
       * Export vr hours in last thirty days
       * @return Success
       */
      exportVRHoursInLastThirtyDays(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/gameplay-analytics/vr-hours-in-last-thirty-days/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportVRHoursInLastThirtyDays(_response);
          });
      }
  
      protected processExportVRHoursInLastThirtyDays(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Gets vr hours in last twelve months
       * @return Success
       */
      vrHoursInLastTwelveMonths(): Promise<VRplayHours[]> {
          let url_ = this.baseUrl + "/gameplay-analytics/vr-hours-in-last-twelve-months";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processVrHoursInLastTwelveMonths(_response);
          });
      }
  
      protected processVrHoursInLastTwelveMonths(response: Response): Promise<VRplayHours[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VRplayHours[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<VRplayHours[]>(null as any);
      }
  
      /**
       * Export vr hours in last twelve months
       * @return Success
       */
      exportVRHoursInLastTwelveMonths(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/gameplay-analytics/vr-hours-in-last-twelve-months/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportVRHoursInLastTwelveMonths(_response);
          });
      }
  
      protected processExportVRHoursInLastTwelveMonths(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Gets vr hours per active user in last twelve months
       * @return Success
       */
      vrHoursPerActivUserInLastTwelveMonths(): Promise<VRplayMinutesPerActivUser[]> {
          let url_ = this.baseUrl + "/gameplay-analytics/vr-hours-per-active-user-in-last-twelve-months";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processVrHoursPerActivUserInLastTwelveMonths(_response);
          });
      }
  
      protected processVrHoursPerActivUserInLastTwelveMonths(response: Response): Promise<VRplayMinutesPerActivUser[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VRplayMinutesPerActivUser[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<VRplayMinutesPerActivUser[]>(null as any);
      }
  
      /**
       * Export vr hours per active user in last twelve months
       * @return Success
       */
      exportVrHoursPerActivUserInLastTwelveMonths(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/gameplay-analytics/vr-hours-per-active-user-in-last-twelve-months/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportVrHoursPerActivUserInLastTwelveMonths(_response);
          });
      }
  
      protected processExportVrHoursPerActivUserInLastTwelveMonths(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get times played per week per user
       * @return Success
       */
      getWeeklyAvgTimesPlayedPerUser(): Promise<number> {
          let url_ = this.baseUrl + "/gameplay-analytics/weekly-times-played-per-user";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetWeeklyAvgTimesPlayedPerUser(_response);
          });
      }
  
      protected processGetWeeklyAvgTimesPlayedPerUser(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * health statistics for the logged in user
       * @return Success
       */
      userHealthStatistics3(): Promise<UserHealthStatisticsDto> {
          let url_ = this.baseUrl + "/home-screen/user-health-statistics";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUserHealthStatistics3(_response);
          });
      }
  
      protected processUserHealthStatistics3(response: Response): Promise<UserHealthStatisticsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserHealthStatisticsDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserHealthStatisticsDto>(null as any);
      }
  
      /**
       * events for client
       * @return Success
       */
      eventsForClient(): Promise<HomescreenEventListItem[]> {
          let url_ = this.baseUrl + "/home-screen/events-for-client";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processEventsForClient(_response);
          });
      }
  
      protected processEventsForClient(response: Response): Promise<HomescreenEventListItem[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomescreenEventListItem[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<HomescreenEventListItem[]>(null as any);
      }
  
      /**
       * Get featured items for home screen
       * @return Success
       */
      getHomeScreenFeaturedItems(): Promise<FeaturedItemIEnumerableResult> {
          let url_ = this.baseUrl + "/home-screen/featured-items";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHomeScreenFeaturedItems(_response);
          });
      }
  
      protected processGetHomeScreenFeaturedItems(response: Response): Promise<FeaturedItemIEnumerableResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeaturedItemIEnumerableResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FeaturedItemIEnumerableResult>(null as any);
      }
  
      /**
       * Get products and events available for featured items
       * @return Success
       */
      getHomescreenItems(): Promise<HomescreenItemDtoIEnumerableResult> {
          let url_ = this.baseUrl + "/home-screen/items";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHomescreenItems(_response);
          });
      }
  
      protected processGetHomescreenItems(response: Response): Promise<HomescreenItemDtoIEnumerableResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomescreenItemDtoIEnumerableResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<HomescreenItemDtoIEnumerableResult>(null as any);
      }
  
      /**
       * Get events for home screen
       * @param searchTerm (optional) 
       * @param startDateAfter (optional) 
       * @return Success
       */
      getHomeScreenEvents(pageNum: number, pageSize: number, sortField: EventTableSortField, sortOrder: SortOrder, searchTerm: string | undefined, startDateAfter: string | undefined): Promise<HomescreenEventListItemPagedResult> {
          let url_ = this.baseUrl + "/home-screen/events?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (startDateAfter === null)
              throw new Error("The parameter 'startDateAfter' cannot be null.");
          else if (startDateAfter !== undefined)
              url_ += "StartDateAfter=" + encodeURIComponent("" + startDateAfter) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHomeScreenEvents(_response);
          });
      }
  
      protected processGetHomeScreenEvents(response: Response): Promise<HomescreenEventListItemPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomescreenEventListItemPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<HomescreenEventListItemPagedResult>(null as any);
      }
  
      /**
       * Get single event for the home screen with the related party information
       * @return Success
       */
      getHomeScreenEvent(id: string): Promise<HomescreenEventDto> {
          let url_ = this.baseUrl + "/home-screen/events/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHomeScreenEvent(_response);
          });
      }
  
      protected processGetHomeScreenEvent(response: Response): Promise<HomescreenEventDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomescreenEventDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<HomescreenEventDto>(null as any);
      }
  
      /**
       * Get modules for home screen
       * @return Success
       */
      getHomeScreenModules(): Promise<HomeScreenModuleDtoResult> {
          let url_ = this.baseUrl + "/home-screen/module";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHomeScreenModules(_response);
          });
      }
  
      protected processGetHomeScreenModules(response: Response): Promise<HomeScreenModuleDtoResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomeScreenModuleDtoResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<HomeScreenModuleDtoResult>(null as any);
      }
  
      /**
       * Get featured items for home screen
       * @return Success
       */
      getHomeScreenFeaturedItems2(): Promise<FeaturedItemIEnumerableResult> {
          let url_ = this.baseUrl + "/admin/home-screen/featured-items";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHomeScreenFeaturedItems2(_response);
          });
      }
  
      protected processGetHomeScreenFeaturedItems2(response: Response): Promise<FeaturedItemIEnumerableResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeaturedItemIEnumerableResult;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FeaturedItemIEnumerableResult>(null as any);
      }
  
      /**
       * Update featured items for home screen
       * @param body (optional) 
       * @return Success
       */
      updateHomeScreenFeaturedItems(body: UpdateFeaturedItemsCommand | undefined): Promise<FeaturedItem[]> {
          let url_ = this.baseUrl + "/admin/home-screen/featured-items";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateHomeScreenFeaturedItems(_response);
          });
      }
  
      protected processUpdateHomeScreenFeaturedItems(response: Response): Promise<FeaturedItem[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeaturedItem[];
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FeaturedItem[]>(null as any);
      }
  
      /**
       * Get products and events available for featured items
       * @return Success
       */
      getHomescreenItems2(): Promise<HomescreenItemDtoIEnumerableResult> {
          let url_ = this.baseUrl + "/admin/home-screen/items";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHomescreenItems2(_response);
          });
      }
  
      protected processGetHomescreenItems2(response: Response): Promise<HomescreenItemDtoIEnumerableResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomescreenItemDtoIEnumerableResult;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<HomescreenItemDtoIEnumerableResult>(null as any);
      }
  
      /**
       * Get events for home screen
       * @param searchTerm (optional) 
       * @param startDateAfter (optional) 
       * @return Success
       */
      getHomeScreenEvents2(pageNum: number, pageSize: number, sortField: EventTableSortField, sortOrder: SortOrder, searchTerm: string | undefined, startDateAfter: string | undefined): Promise<HomescreenEventListItemPagedResult> {
          let url_ = this.baseUrl + "/admin/home-screen/events?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (startDateAfter === null)
              throw new Error("The parameter 'startDateAfter' cannot be null.");
          else if (startDateAfter !== undefined)
              url_ += "StartDateAfter=" + encodeURIComponent("" + startDateAfter) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHomeScreenEvents2(_response);
          });
      }
  
      protected processGetHomeScreenEvents2(response: Response): Promise<HomescreenEventListItemPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomescreenEventListItemPagedResult;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<HomescreenEventListItemPagedResult>(null as any);
      }
  
      /**
       * Creates events for home screen
       * @param body (optional) 
       * @return No Content
       */
      createHomeScreenEvent(body: CreateHomescreenEventCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/home-screen/events";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateHomeScreenEvent(_response);
          });
      }
  
      protected processCreateHomeScreenEvent(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get single event for the home screen with the related party information
       * @return Success
       */
      getHomeScreenEvent2(id: string): Promise<HomescreenEventDto> {
          let url_ = this.baseUrl + "/admin/home-screen/events/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHomeScreenEvent2(_response);
          });
      }
  
      protected processGetHomeScreenEvent2(response: Response): Promise<HomescreenEventDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomescreenEventDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<HomescreenEventDto>(null as any);
      }
  
      /**
       * Update events
       * @param body (optional) 
       * @return No Content
       */
      updateHomescreenEvent(id: string, body: UpdateHomescreenEventCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/home-screen/events/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateHomescreenEvent(_response);
          });
      }
  
      protected processUpdateHomescreenEvent(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Delete events
       * @return Success
       */
      deleteHomescreenEvent(id: string): Promise<Result> {
          let url_ = this.baseUrl + "/admin/home-screen/events/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteHomescreenEvent(_response);
          });
      }
  
      protected processDeleteHomescreenEvent(response: Response): Promise<Result> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
              return result200;
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return throwException("No Content", status, _responseText, _headers);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Result>(null as any);
      }
  
      /**
       * Query feature item based on event
       * @return Success
       */
      queryFeatureItemBasedOnEvent(id: string): Promise<FeaturedItemIEnumerableResult> {
          let url_ = this.baseUrl + "/admin/home-screen/events/query-feature-item-based-on-event/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processQueryFeatureItemBasedOnEvent(_response);
          });
      }
  
      protected processQueryFeatureItemBasedOnEvent(response: Response): Promise<FeaturedItemIEnumerableResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeaturedItemIEnumerableResult;
              return result200;
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return throwException("No Content", status, _responseText, _headers);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FeaturedItemIEnumerableResult>(null as any);
      }
  
      /**
       * Get modules for home screen
       * @return Success
       */
      getHomeScreenModules2(): Promise<HomeScreenModuleDtoResult> {
          let url_ = this.baseUrl + "/admin/home-screen/module";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHomeScreenModules2(_response);
          });
      }
  
      protected processGetHomeScreenModules2(response: Response): Promise<HomeScreenModuleDtoResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomeScreenModuleDtoResult;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<HomeScreenModuleDtoResult>(null as any);
      }
  
      /**
       * Update module for home screen
       * @param body (optional) 
       * @return Success
       */
      updateHomescreenModule(body: UpdateHomesceenModuleCommand | undefined): Promise<number> {
          let url_ = this.baseUrl + "/admin/home-screen/module";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateHomescreenModule(_response);
          });
      }
  
      protected processUpdateHomescreenModule(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Create or modify a leaderboard
       * @param body (optional) 
       * @return No Content
       */
      upsertLeaderboard(productId: string, body: UpsertLeaderboardRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/leaderboards/v2/{productId}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpsertLeaderboard(_response);
          });
      }
  
      protected processUpsertLeaderboard(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * get leaderboards list
       * @param body (optional) 
       * @return Success
       */
      getLeaderBoardsList(body: GetAllLeaderboardsRequest | undefined): Promise<ListLeaderboardsV2DtoPagedResult> {
          let url_ = this.baseUrl + "/leaderboards/v2/get-leaderboards-list";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLeaderBoardsList(_response);
          });
      }
  
      protected processGetLeaderBoardsList(response: Response): Promise<ListLeaderboardsV2DtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListLeaderboardsV2DtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ListLeaderboardsV2DtoPagedResult>(null as any);
      }
  
      /**
       * get a leaderboards details
       * @param body (optional) 
       * @return Success
       */
      getLeaderboardDetails(body: GetLeaderboardDetailsRequest | undefined): Promise<LeaderboardV2Dto> {
          let url_ = this.baseUrl + "/leaderboards/v2/get-leaderboard-details";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLeaderboardDetails(_response);
          });
      }
  
      protected processGetLeaderboardDetails(response: Response): Promise<LeaderboardV2Dto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaderboardV2Dto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<LeaderboardV2Dto>(null as any);
      }
  
      /**
       * Delete a leaderboard
       * @return Success
       */
      deleteLeaderboard(id: number): Promise<Result> {
          let url_ = this.baseUrl + "/leaderboards/v2/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteLeaderboard(_response);
          });
      }
  
      protected processDeleteLeaderboard(response: Response): Promise<Result> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Result>(null as any);
      }
  
      /**
       * Validates the leaderboardV2's ApiName
       * @param body (optional) 
       * @return Success
       */
      validateLeaderboardV2ApiName(body: ValidateLeaderboardV2ApiNameRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/leaderboards/v2/valid-api-name";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processValidateLeaderboardV2ApiName(_response);
          });
      }
  
      protected processValidateLeaderboardV2ApiName(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Gets the information for a specified leaderboard.
       * @param body (optional) 
       * @return Success
       */
      getLeaderboard(productId: string, body: GetLeaderboardRequest | undefined): Promise<LeaderboardPagedResponseListMessage> {
          let url_ = this.baseUrl + "/leaderboards/v2/{productId}/get";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLeaderboard(_response);
          });
      }
  
      protected processGetLeaderboard(response: Response): Promise<LeaderboardPagedResponseListMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaderboardPagedResponseListMessage;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<LeaderboardPagedResponseListMessage>(null as any);
      }
  
      /**
       * Writes an entry to a leaderboard.
       * @param body (optional) 
       * @return Success
       */
      writeEntry(productId: string, body: WriteEntryRequest | undefined): Promise<BooleanMessage> {
          let url_ = this.baseUrl + "/leaderboards/v2/{productId}/write-entry";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processWriteEntry(_response);
          });
      }
  
      protected processWriteEntry(response: Response): Promise<BooleanMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanMessage;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<BooleanMessage>(null as any);
      }
  
      /**
       * Writes an entry to a leaderboard with supplementary metric.
       * @param body (optional) 
       * @return Success
       */
      writeEntryWithSupplementaryMetric(productId: string, body: WriteEntryWithSupplementaryMetricRequest | undefined): Promise<BooleanMessage> {
          let url_ = this.baseUrl + "/leaderboards/v2/{productId}/write-entry-with-supplementary-metric";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processWriteEntryWithSupplementaryMetric(_response);
          });
      }
  
      protected processWriteEntryWithSupplementaryMetric(response: Response): Promise<BooleanMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BooleanMessage;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<BooleanMessage>(null as any);
      }
  
      /**
       * Gets a list of entries.
       * @param body (optional) 
       * @return Success
       */
      getEntries(productId: string, body: GetEntriesRequest | undefined): Promise<LeaderboardEntryPagedResponseListMessage> {
          let url_ = this.baseUrl + "/leaderboards/v2/{productId}/get-entries";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetEntries(_response);
          });
      }
  
      protected processGetEntries(response: Response): Promise<LeaderboardEntryPagedResponseListMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaderboardEntryPagedResponseListMessage;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<LeaderboardEntryPagedResponseListMessage>(null as any);
      }
  
      /**
       * Gets a list of entries after a specified rank.
       * @param body (optional) 
       * @return Success
       */
      getEntriesAfterRank(productId: string, body: GetEntriesAfterRankRequest | undefined): Promise<LeaderboardEntryPagedResponseListMessage> {
          let url_ = this.baseUrl + "/leaderboards/v2/{productId}/get-entries-after-rank";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetEntriesAfterRank(_response);
          });
      }
  
      protected processGetEntriesAfterRank(response: Response): Promise<LeaderboardEntryPagedResponseListMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaderboardEntryPagedResponseListMessage;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<LeaderboardEntryPagedResponseListMessage>(null as any);
      }
  
      /**
       * Gets a list of entries for specified users.
       * @param body (optional) 
       * @return Success
       */
      getEntriesById(productId: string, body: GetEntriesByIdsRequest | undefined): Promise<LeaderboardEntryPagedResponseListMessage> {
          let url_ = this.baseUrl + "/leaderboards/v2/{productId}/get-entries-by-id";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetEntriesById(_response);
          });
      }
  
      protected processGetEntriesById(response: Response): Promise<LeaderboardEntryPagedResponseListMessage> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaderboardEntryPagedResponseListMessage;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<LeaderboardEntryPagedResponseListMessage>(null as any);
      }
  
      /**
       * Create a leaderboard
       * @param body (optional) 
       * @return No Content
       */
      createLeaderboard(body: CreateLeaderboardRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/leaderboards/definition";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateLeaderboard(_response);
          });
      }
  
      protected processCreateLeaderboard(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get the definition of a leaderboard
       * @return Success
       */
      getLeaderboardDefinition(productId: string, apiName: string): Promise<LeaderboardDto> {
          let url_ = this.baseUrl + "/leaderboards/definition/{productId}/{apiName}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (apiName === undefined || apiName === null)
              throw new Error("The parameter 'apiName' must be defined.");
          url_ = url_.replace("{apiName}", encodeURIComponent("" + apiName));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLeaderboardDefinition(_response);
          });
      }
  
      protected processGetLeaderboardDefinition(response: Response): Promise<LeaderboardDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaderboardDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<LeaderboardDto>(null as any);
      }
  
      /**
       * Delete a leaderboard
       * @return No Content
       */
      deleteLeaderboardDefinition(productId: string, apiName: string): Promise<void> {
          let url_ = this.baseUrl + "/leaderboards/definition/{productId}/{apiName}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (apiName === undefined || apiName === null)
              throw new Error("The parameter 'apiName' must be defined.");
          url_ = url_.replace("{apiName}", encodeURIComponent("" + apiName));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteLeaderboardDefinition(_response);
          });
      }
  
      protected processDeleteLeaderboardDefinition(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Update the leaderboard definition
       * @param body (optional) 
       * @return Success
       */
      updateLeaderboardDefinition(productId: string, apiName: string, body: LeaderboardDto | undefined): Promise<void> {
          let url_ = this.baseUrl + "/leaderboards/definition/{productId}/{apiName}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (apiName === undefined || apiName === null)
              throw new Error("The parameter 'apiName' must be defined.");
          url_ = url_.replace("{apiName}", encodeURIComponent("" + apiName));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateLeaderboardDefinition(_response);
          });
      }
  
      protected processUpdateLeaderboardDefinition(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get the user positions on a leaderboard
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @param afterRank (optional) 
       * @return Success
       */
      getLeaderboardValues(productId: string, apiName: string, releaseChannel: ReleaseChannel, pageNumber: number | undefined, pageSize: number | undefined, afterRank: number | undefined): Promise<LeaderboardValuesDtoPagedResult> {
          let url_ = this.baseUrl + "/leaderboards/{productId}/{apiName}/{releaseChannel}?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (apiName === undefined || apiName === null)
              throw new Error("The parameter 'apiName' must be defined.");
          url_ = url_.replace("{apiName}", encodeURIComponent("" + apiName));
          if (releaseChannel === undefined || releaseChannel === null)
              throw new Error("The parameter 'releaseChannel' must be defined.");
          url_ = url_.replace("{releaseChannel}", encodeURIComponent("" + releaseChannel));
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (afterRank === null)
              throw new Error("The parameter 'afterRank' cannot be null.");
          else if (afterRank !== undefined)
              url_ += "afterRank=" + encodeURIComponent("" + afterRank) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLeaderboardValues(_response);
          });
      }
  
      protected processGetLeaderboardValues(response: Response): Promise<LeaderboardValuesDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaderboardValuesDtoPagedResult;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<LeaderboardValuesDtoPagedResult>(null as any);
      }
  
      /**
       * Get the leaderboards list for product
       * @param sortOrder (optional) 
       * @param sortField (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getLeaderboardsList(projectId: number, sortOrder: SortOrder | undefined, sortField: LeaderboardSortField | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<ListLeaderboardsDtoPagedResult> {
          let url_ = this.baseUrl + "/leaderboards/{projectId}?";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLeaderboardsList(_response);
          });
      }
  
      protected processGetLeaderboardsList(response: Response): Promise<ListLeaderboardsDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListLeaderboardsDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ListLeaderboardsDtoPagedResult>(null as any);
      }
  
      /**
       * Get logged in users position on the leaderboard
       * @return Success
       */
      getUserLeaderboardPosition(productId: string, releaseChannel: ReleaseChannel, apiName: string): Promise<LeaderboardValuesDto> {
          let url_ = this.baseUrl + "/leaderboards/user-position/{productId}/{apiName}/{releaseChannel}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (releaseChannel === undefined || releaseChannel === null)
              throw new Error("The parameter 'releaseChannel' must be defined.");
          url_ = url_.replace("{releaseChannel}", encodeURIComponent("" + releaseChannel));
          if (apiName === undefined || apiName === null)
              throw new Error("The parameter 'apiName' must be defined.");
          url_ = url_.replace("{apiName}", encodeURIComponent("" + apiName));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserLeaderboardPosition(_response);
          });
      }
  
      protected processGetUserLeaderboardPosition(response: Response): Promise<LeaderboardValuesDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaderboardValuesDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<LeaderboardValuesDto>(null as any);
      }
  
      /**
       * Validates the given ApiName
       * @param body (optional) 
       * @return Success
       */
      validApiName2(body: ValidateLeaderboardApiNameRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/leaderboards/valid-api-name";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processValidApiName2(_response);
          });
      }
  
      protected processValidApiName2(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Get paged user library items
       * @param galleryItemType (optional) 
       * @param galleryItemGroup (optional) 
       * @param sortField (optional) 
       * @param status (optional) 
       * @param userId (optional) 
       * @return Success
       */
      getUserLibrary(galleryItemType: string | undefined, galleryItemGroup: string | undefined, pageNum: number, pageSize: number, sortField: LibrarySortField | undefined, sortOrder: SortOrder, status: UserProductStatus | undefined, userId: string | undefined): Promise<ProductListItemDtoPagedResult> {
          let url_ = this.baseUrl + "/library?";
          if (galleryItemType === null)
              throw new Error("The parameter 'galleryItemType' cannot be null.");
          else if (galleryItemType !== undefined)
              url_ += "GalleryItemType=" + encodeURIComponent("" + galleryItemType) + "&";
          if (galleryItemGroup === null)
              throw new Error("The parameter 'galleryItemGroup' cannot be null.");
          else if (galleryItemGroup !== undefined)
              url_ += "GalleryItemGroup=" + encodeURIComponent("" + galleryItemGroup) + "&";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (status === null)
              throw new Error("The parameter 'status' cannot be null.");
          else if (status !== undefined)
              url_ += "Status=" + encodeURIComponent("" + status) + "&";
          if (userId === null)
              throw new Error("The parameter 'userId' cannot be null.");
          else if (userId !== undefined)
              url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserLibrary(_response);
          });
      }
  
      protected processGetUserLibrary(response: Response): Promise<ProductListItemDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductListItemDtoPagedResult;
              return result200;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductListItemDtoPagedResult>(null as any);
      }
  
      /**
       * Get library product details
       * @return Success
       */
      getLibraryProductDetails(id: string): Promise<ProductDetailsDto> {
          let url_ = this.baseUrl + "/library/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLibraryProductDetails(_response);
          });
      }
  
      protected processGetLibraryProductDetails(response: Response): Promise<ProductDetailsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductDetailsDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductDetailsDto>(null as any);
      }
  
      /**
       * Get Monthly codes configurations
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getMonthlyCodesConfigs(sortField: MgCodeMonthlyConfigsSortField | undefined, sortOrder: SortOrder | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<MgCodeMonthlyConfigDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/mg-codes/monthly-configs?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetMonthlyCodesConfigs(_response);
          });
      }
  
      protected processGetMonthlyCodesConfigs(response: Response): Promise<MgCodeMonthlyConfigDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MgCodeMonthlyConfigDtoPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<MgCodeMonthlyConfigDtoPagedResult>(null as any);
      }
  
      /**
       * Generate upfront minimum guaranteed codes
       * @param body (optional) 
       * @return No Content
       */
      generateUpfrontMgCodes(body: CreateUpfrontMgCodesRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/mg-codes/upfront-codes";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGenerateUpfrontMgCodes(_response);
          });
      }
  
      protected processGenerateUpfrontMgCodes(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Create or update existing monthly codes generate configuration
       * @param body (optional) 
       * @return No Content
       */
      upsertMonthlyMgCodesGenConfig(body: UpsertMonthlyMgCodesGenConfigRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/mg-codes/monthly-codes-gen-config";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpsertMonthlyMgCodesGenConfig(_response);
          });
      }
  
      protected processUpsertMonthlyMgCodesGenConfig(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * get monthly codes generate configuration for a product
       * @return Success
       */
      getMgCodeMonthlyGenConfig(productId: string): Promise<MgCodeMonthlyGenConfig> {
          let url_ = this.baseUrl + "/admin/mg-codes/monthly-codes-gen-config?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "productId=" + encodeURIComponent("" + productId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetMgCodeMonthlyGenConfig(_response);
          });
      }
  
      protected processGetMgCodeMonthlyGenConfig(response: Response): Promise<MgCodeMonthlyGenConfig> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MgCodeMonthlyGenConfig;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<MgCodeMonthlyGenConfig>(null as any);
      }
  
      /**
       * An Admin can query minimum guaranteed codes with pagination
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param redeemed (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      queryMgCodesByAdmin(sortField: MgCodeListSortField | undefined, sortOrder: SortOrder | undefined, productId: string, redeemed: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<MgCodeDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/mg-codes?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (redeemed === null)
              throw new Error("The parameter 'redeemed' cannot be null.");
          else if (redeemed !== undefined)
              url_ += "Redeemed=" + encodeURIComponent("" + redeemed) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processQueryMgCodesByAdmin(_response);
          });
      }
  
      protected processQueryMgCodesByAdmin(response: Response): Promise<MgCodeDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MgCodeDtoPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<MgCodeDtoPagedResult>(null as any);
      }
  
      /**
       * Delete minimum guaranteed codes
       * @param ids (optional) 
       * @return Success
       */
      deleteMgCodes(ids: number[] | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/mg-codes?";
          if (ids === null)
              throw new Error("The parameter 'ids' cannot be null.");
          else if (ids !== undefined)
              ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteMgCodes(_response);
          });
      }
  
      protected processDeleteMgCodes(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * An admin can export minimum guaranteed codes
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param redeemed (optional) 
       * @return Success
       */
      exportMgCodesByAdmin(sortField: MgCodeListSortField | undefined, sortOrder: SortOrder | undefined, productId: string, redeemed: boolean | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/admin/mg-codes/export?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (redeemed === null)
              throw new Error("The parameter 'redeemed' cannot be null.");
          else if (redeemed !== undefined)
              url_ += "Redeemed=" + encodeURIComponent("" + redeemed) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportMgCodesByAdmin(_response);
          });
      }
  
      protected processExportMgCodesByAdmin(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Reserve minimum guaranteed codes
       * @param ids (optional) 
       * @return Success
       */
      reserveMgCodes(ids: number[] | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/mg-codes/reserve?";
          if (ids === null)
              throw new Error("The parameter 'ids' cannot be null.");
          else if (ids !== undefined)
              ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "PUT",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processReserveMgCodes(_response);
          });
      }
  
      protected processReserveMgCodes(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Unreserve reserved minimum guaranteed codes
       * @param ids (optional) 
       * @return Success
       */
      unreserveMgCodes(ids: number[] | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/mg-codes/unreserve?";
          if (ids === null)
              throw new Error("The parameter 'ids' cannot be null.");
          else if (ids !== undefined)
              ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "PUT",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUnreserveMgCodes(_response);
          });
      }
  
      protected processUnreserveMgCodes(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Export MG codes configs
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param exportType (optional) 
       * @return Success
       */
      exportMgCodesConfigs(sortField: MgCodeMonthlyConfigsSortField | undefined, sortOrder: SortOrder | undefined, exportType: ExportType | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/admin/mg-codes/monthly-configs/export?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (exportType === null)
              throw new Error("The parameter 'exportType' cannot be null.");
          else if (exportType !== undefined)
              url_ += "ExportType=" + encodeURIComponent("" + exportType) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportMgCodesConfigs(_response);
          });
      }
  
      protected processExportMgCodesConfigs(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * A content provider can query minimum guaranteed codes with pagination for a product
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param redeemed (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      queryMgCodesByContentProvider(sortField: MgCodeListSortField | undefined, sortOrder: SortOrder | undefined, productId: string, redeemed: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<MgCodeDtoPagedResult> {
          let url_ = this.baseUrl + "/content-provider/mg-codes?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (redeemed === null)
              throw new Error("The parameter 'redeemed' cannot be null.");
          else if (redeemed !== undefined)
              url_ += "Redeemed=" + encodeURIComponent("" + redeemed) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processQueryMgCodesByContentProvider(_response);
          });
      }
  
      protected processQueryMgCodesByContentProvider(response: Response): Promise<MgCodeDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MgCodeDtoPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<MgCodeDtoPagedResult>(null as any);
      }
  
      /**
       * A content provider can export minimum guaranteed codes for a product
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param redeemed (optional) 
       * @return Success
       */
      exportMgCodesByContentProvider(sortField: MgCodeListSortField | undefined, sortOrder: SortOrder | undefined, productId: string, redeemed: boolean | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/content-provider/mg-codes/export?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (redeemed === null)
              throw new Error("The parameter 'redeemed' cannot be null.");
          else if (redeemed !== undefined)
              url_ += "Redeemed=" + encodeURIComponent("" + redeemed) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportMgCodesByContentProvider(_response);
          });
      }
  
      protected processExportMgCodesByContentProvider(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get order details
       * @return Success
       */
      getOrderDetails(): Promise<OrderDetailDto[]> {
          let url_ = this.baseUrl + "/orders";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetOrderDetails(_response);
          });
      }
  
      protected processGetOrderDetails(response: Response): Promise<OrderDetailDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderDetailDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<OrderDetailDto[]>(null as any);
      }
  
      /**
       * create a party owned by the logged in user
       * @return Success
       */
      create(): Promise<number> {
          let url_ = this.baseUrl + "/party/create";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreate(_response);
          });
      }
  
      protected processCreate(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * allows a party creator to remove a user from the party
       * @param body (optional) 
       * @return Success
       */
      kickUser(body: KickUserRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/party/kick-user";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processKickUser(_response);
          });
      }
  
      protected processKickUser(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Invites the provided userId to the party that the logged in user owns
       * @param body (optional) 
       * @return Success
       */
      invite(body: InviteRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/party/invite";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processInvite(_response);
          });
      }
  
      protected processInvite(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * logged in user leaves the party
       * @param body (optional) 
       * @return Success
       */
      leaveParty(body: LeavePartyRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/party/leave";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processLeaveParty(_response);
          });
      }
  
      protected processLeaveParty(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * the current owner can promote another party member to owner
       * @param body (optional) 
       * @return Success
       */
      promoteToOwner(body: PromoteToOwnerRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/party/promote-to-owner";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processPromoteToOwner(_response);
          });
      }
  
      protected processPromoteToOwner(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Returns the members of the party the logged in user is a member of, including the status (Member = 0, Leader = 1, Pending = 2)
       * @return Success
       */
      partyMembers(partyId: number): Promise<PartyMemberDto[]> {
          let url_ = this.baseUrl + "/party/members/{partyId}";
          if (partyId === undefined || partyId === null)
              throw new Error("The parameter 'partyId' must be defined.");
          url_ = url_.replace("{partyId}", encodeURIComponent("" + partyId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processPartyMembers(_response);
          });
      }
  
      protected processPartyMembers(response: Response): Promise<PartyMemberDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartyMemberDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<PartyMemberDto[]>(null as any);
      }
  
      /**
       * Returns the members of the party the logged in user is a member of, including the status (Member = 0, Leader = 1, Pending = 2)
       * @return Success
       */
      partyMembersWithoutId(): Promise<PartyMemberDto[]> {
          let url_ = this.baseUrl + "/party/members";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processPartyMembersWithoutId(_response);
          });
      }
  
      protected processPartyMembersWithoutId(response: Response): Promise<PartyMemberDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartyMemberDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<PartyMemberDto[]>(null as any);
      }
  
      /**
       * Accept party invite
       * @param body (optional) 
       * @return Success
       */
      acceptInvite(body: ManageInviteRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/party/invite/accept";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAcceptInvite(_response);
          });
      }
  
      protected processAcceptInvite(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Reject party invite
       * @param body (optional) 
       * @return Success
       */
      rejectInvite(body: ManageInviteRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/party/invite/reject";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRejectInvite(_response);
          });
      }
  
      protected processRejectInvite(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Process a Stripe Payout
       * @param payoutIdentifier (optional) 
       * @return Success
       */
      processStripePayout(payoutIdentifier: number | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/payments/process-payout?";
          if (payoutIdentifier === null)
              throw new Error("The parameter 'payoutIdentifier' cannot be null.");
          else if (payoutIdentifier !== undefined)
              url_ += "payoutIdentifier=" + encodeURIComponent("" + payoutIdentifier) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processProcessStripePayout(_response);
          });
      }
  
      protected processProcessStripePayout(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Get list of statements for a project
       * @param projectId (optional) 
       * @return Success
       */
      getProjectStatements(pageNum: number, pageSize: number, sortField: StatementsSortField, sortOrder: SortOrder, projectId: number | undefined): Promise<StripeBalanceDtoPagedResult> {
          let url_ = this.baseUrl + "/payments/statements?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (projectId === null)
              throw new Error("The parameter 'projectId' cannot be null.");
          else if (projectId !== undefined)
              url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProjectStatements(_response);
          });
      }
  
      protected processGetProjectStatements(response: Response): Promise<StripeBalanceDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripeBalanceDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StripeBalanceDtoPagedResult>(null as any);
      }
  
      /**
       * Get the result of the last statement job
       * @return Success
       */
      getLatestStatementJobStatus(): Promise<StatementResult> {
          let url_ = this.baseUrl + "/payments/statements-status";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLatestStatementJobStatus(_response);
          });
      }
  
      protected processGetLatestStatementJobStatus(response: Response): Promise<StatementResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StatementResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StatementResult>(null as any);
      }
  
      /**
       * Get user payment methods list
       * @param limit (optional) 
       * @param startingAfter (optional) 
       * @param endingBefore (optional) 
       * @return Success
       */
      getUserPaymentMethodList(limit: number | undefined, startingAfter: string | undefined, endingBefore: string | undefined): Promise<StripePaymentMethodListDto> {
          let url_ = this.baseUrl + "/payments/methods?";
          if (limit === null)
              throw new Error("The parameter 'limit' cannot be null.");
          else if (limit !== undefined)
              url_ += "limit=" + encodeURIComponent("" + limit) + "&";
          if (startingAfter === null)
              throw new Error("The parameter 'startingAfter' cannot be null.");
          else if (startingAfter !== undefined)
              url_ += "startingAfter=" + encodeURIComponent("" + startingAfter) + "&";
          if (endingBefore === null)
              throw new Error("The parameter 'endingBefore' cannot be null.");
          else if (endingBefore !== undefined)
              url_ += "endingBefore=" + encodeURIComponent("" + endingBefore) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserPaymentMethodList(_response);
          });
      }
  
      protected processGetUserPaymentMethodList(response: Response): Promise<StripePaymentMethodListDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripePaymentMethodListDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StripePaymentMethodListDto>(null as any);
      }
  
      /**
       * Get user payment method by setup intent id
       * @return Success
       */
      getUserPaymentMethodBySetupIntentId(setupIntentId: string): Promise<StripePaymentMethodDto> {
          let url_ = this.baseUrl + "/payments/methods/{setupIntentId}";
          if (setupIntentId === undefined || setupIntentId === null)
              throw new Error("The parameter 'setupIntentId' must be defined.");
          url_ = url_.replace("{setupIntentId}", encodeURIComponent("" + setupIntentId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserPaymentMethodBySetupIntentId(_response);
          });
      }
  
      protected processGetUserPaymentMethodBySetupIntentId(response: Response): Promise<StripePaymentMethodDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripePaymentMethodDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StripePaymentMethodDto>(null as any);
      }
  
      /**
       * Create SetupIntent
       * @return Success
       */
      createSetupIntent(): Promise<StripeSetupIntentDto> {
          let url_ = this.baseUrl + "/payments/intents/setup";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateSetupIntent(_response);
          });
      }
  
      protected processCreateSetupIntent(response: Response): Promise<StripeSetupIntentDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripeSetupIntentDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StripeSetupIntentDto>(null as any);
      }
  
      /**
       * Confirm payment intent
       * @return Success
       */
      confirmPaymentIntent(paymentIntentId: string): Promise<StripePaymentIntentConfirmDto> {
          let url_ = this.baseUrl + "/payments/intents/payment/{paymentIntentId}/confirm";
          if (paymentIntentId === undefined || paymentIntentId === null)
              throw new Error("The parameter 'paymentIntentId' must be defined.");
          url_ = url_.replace("{paymentIntentId}", encodeURIComponent("" + paymentIntentId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processConfirmPaymentIntent(_response);
          });
      }
  
      protected processConfirmPaymentIntent(response: Response): Promise<StripePaymentIntentConfirmDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripePaymentIntentConfirmDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StripePaymentIntentConfirmDto>(null as any);
      }
  
      /**
       * Set user default payment method by SetupIntent
       * @return Success
       */
      setUserDefaultPaymentMethodBySetupintent(setupIntentId: string): Promise<void> {
          let url_ = this.baseUrl + "/payments/intents/setup/{setupIntentId}/default";
          if (setupIntentId === undefined || setupIntentId === null)
              throw new Error("The parameter 'setupIntentId' must be defined.");
          url_ = url_.replace("{setupIntentId}", encodeURIComponent("" + setupIntentId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetUserDefaultPaymentMethodBySetupintent(_response);
          });
      }
  
      protected processSetUserDefaultPaymentMethodBySetupintent(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Set user default payment method
       * @return Success
       */
      setUserDefaultPaymentMethod(paymentMethodId: string): Promise<void> {
          let url_ = this.baseUrl + "/payments/methods/{paymentMethodId}/default";
          if (paymentMethodId === undefined || paymentMethodId === null)
              throw new Error("The parameter 'paymentMethodId' must be defined.");
          url_ = url_.replace("{paymentMethodId}", encodeURIComponent("" + paymentMethodId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetUserDefaultPaymentMethod(_response);
          });
      }
  
      protected processSetUserDefaultPaymentMethod(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Delete user payment method
       * @return No Content
       */
      deleteUserPaymentMethod(paymentMethodId: string): Promise<void> {
          let url_ = this.baseUrl + "/payments/methods/{paymentMethodId}";
          if (paymentMethodId === undefined || paymentMethodId === null)
              throw new Error("The parameter 'paymentMethodId' must be defined.");
          url_ = url_.replace("{paymentMethodId}", encodeURIComponent("" + paymentMethodId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteUserPaymentMethod(_response);
          });
      }
  
      protected processDeleteUserPaymentMethod(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Create order for free to play products
       * @param body (optional) 
       * @return Success
       */
      checkoutFreeProduct(body: CreateFreeOrderCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/payments/checkout";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCheckoutFreeProduct(_response);
          });
      }
  
      protected processCheckoutFreeProduct(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Try to add free product to library
       * @param body (optional) 
       * @return No Content
       */
      acquireProduct(body: CreateStripePaymentIntentCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/payments/acquire";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAcquireProduct(_response);
          });
      }
  
      protected processAcquireProduct(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get purchase price for a product calculated by specific payment method
       * @param paymentMethodId (optional) 
       * @return Success
       */
      getPurchasePrice(productId: string, paymentMethodId: string | undefined): Promise<Payment> {
          let url_ = this.baseUrl + "/payments/purchase/price?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "productId=" + encodeURIComponent("" + productId) + "&";
          if (paymentMethodId === null)
              throw new Error("The parameter 'paymentMethodId' cannot be null.");
          else if (paymentMethodId !== undefined)
              url_ += "paymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetPurchasePrice(_response);
          });
      }
  
      protected processGetPurchasePrice(response: Response): Promise<Payment> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Payment;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Payment>(null as any);
      }
  
      /**
       * Create payment intent for a product
       * @param body (optional) 
       * @return Success
       */
      purchaseProduct(body: CreateStripePaymentIntentCommand | undefined): Promise<ProductPurchaseIntentDto> {
          let url_ = this.baseUrl + "/payments/purchase";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processPurchaseProduct(_response);
          });
      }
  
      protected processPurchaseProduct(response: Response): Promise<ProductPurchaseIntentDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductPurchaseIntentDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductPurchaseIntentDtoErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductPurchaseIntentDto>(null as any);
      }
  
      /**
       * Purchase a product with a given payment method
       * @param body (optional) 
       * @return Success
       */
      purchaseProductv2(body: CreateStripePaymentIntentCommand | undefined): Promise<StripePaymentIntentConfirmDto> {
          let url_ = this.baseUrl + "/payments/purchase/v2";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processPurchaseProductv2(_response);
          });
      }
  
      protected processPurchaseProductv2(response: Response): Promise<StripePaymentIntentConfirmDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripePaymentIntentConfirmDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StripePaymentIntentConfirmDto>(null as any);
      }
  
      /**
       * Gets games ranking by revenues to virtuix in all time
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      gamesByRevenuesInAllTime(pageNumber: number | undefined, pageSize: number | undefined): Promise<GameRankingByRevenuePagedResult> {
          let url_ = this.baseUrl + "/payments/games-ranking-by-revenues-in-all-times?";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGamesByRevenuesInAllTime(_response);
          });
      }
  
      protected processGamesByRevenuesInAllTime(response: Response): Promise<GameRankingByRevenuePagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GameRankingByRevenuePagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<GameRankingByRevenuePagedResult>(null as any);
      }
  
      /**
       * Export top 10 games ranking by revenues to virtuix in all time
       * @return Success
       */
      exportTopThirtyGamesByRevenuesInAllTime(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/payments/games-ranking-by-revenues-in-all-times/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportTopThirtyGamesByRevenuesInAllTime(_response);
          });
      }
  
      protected processExportTopThirtyGamesByRevenuesInAllTime(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Gets games ranking by revenues to virtuix in last ninety days
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      gamesByRevenuesInLastNinetyDays(pageNumber: number | undefined, pageSize: number | undefined): Promise<GameRankingByRevenuePagedResult> {
          let url_ = this.baseUrl + "/payments/games-ranking-by-revenues-in-last-ninety-days?";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGamesByRevenuesInLastNinetyDays(_response);
          });
      }
  
      protected processGamesByRevenuesInLastNinetyDays(response: Response): Promise<GameRankingByRevenuePagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GameRankingByRevenuePagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<GameRankingByRevenuePagedResult>(null as any);
      }
  
      /**
       * Export top 10 games ranking by revenues to virtuix in last ninety days
       * @return Success
       */
      exportTopThirtyGamesByRevenuesInLastNinetyDays(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/payments/games-ranking-by-revenues-in-last-ninety-days/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportTopThirtyGamesByRevenuesInLastNinetyDays(_response);
          });
      }
  
      protected processExportTopThirtyGamesByRevenuesInLastNinetyDays(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Gets users ranking by revenues to virtuix in all time
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      usersByRevenuesInAllTime(pageNumber: number | undefined, pageSize: number | undefined): Promise<UserRankingByRevenuePagedResult> {
          let url_ = this.baseUrl + "/payments/users-ranking-by-revenues-in-all-times?";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUsersByRevenuesInAllTime(_response);
          });
      }
  
      protected processUsersByRevenuesInAllTime(response: Response): Promise<UserRankingByRevenuePagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserRankingByRevenuePagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserRankingByRevenuePagedResult>(null as any);
      }
  
      /**
       * Export top 30 users ranking by revenues to virtuix in all time
       * @return Success
       */
      exportTopThirtyUsersByRevenuesInAllTime(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/payments/users-ranking-by-revenues-in-all-times/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportTopThirtyUsersByRevenuesInAllTime(_response);
          });
      }
  
      protected processExportTopThirtyUsersByRevenuesInAllTime(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Gets users ranking by revenues to virtuix in last ninety days
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      usersByRevenuesInLastNinetyDays(pageNumber: number | undefined, pageSize: number | undefined): Promise<UserRankingByRevenuePagedResult> {
          let url_ = this.baseUrl + "/payments/users-ranking-by-revenues-in-last-ninety-days?";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUsersByRevenuesInLastNinetyDays(_response);
          });
      }
  
      protected processUsersByRevenuesInLastNinetyDays(response: Response): Promise<UserRankingByRevenuePagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserRankingByRevenuePagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserRankingByRevenuePagedResult>(null as any);
      }
  
      /**
       * Export top 30 users ranking by revenues to virtuix in last ninety days
       * @return Success
       */
      exportTopThirtyUsersByRevenuesInLastNinetyDays(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/payments/users-ranking-by-revenues-in-last-ninety-days/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportTopThirtyUsersByRevenuesInLastNinetyDays(_response);
          });
      }
  
      protected processExportTopThirtyUsersByRevenuesInLastNinetyDays(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get Payments for Project
       * @param startDate (optional) 
       * @param endDate (optional) 
       * @param getAll (optional) 
       * @param excludeRedemptionCodes (optional) 
       * @param excludePaymentWithMgCode (optional) 
       * @return Success
       */
      getProjectPayments(projectId: number, startDate: Date | undefined, endDate: Date | undefined, getAll: boolean | undefined, excludeRedemptionCodes: boolean | undefined, excludePaymentWithMgCode: boolean | undefined, pageSize: number, offset: number): Promise<PaymentPagedResult> {
          let url_ = this.baseUrl + "/payments/{projectId}?";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          if (startDate === null)
              throw new Error("The parameter 'startDate' cannot be null.");
          else if (startDate !== undefined)
              url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
          if (endDate === null)
              throw new Error("The parameter 'endDate' cannot be null.");
          else if (endDate !== undefined)
              url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
          if (getAll === null)
              throw new Error("The parameter 'getAll' cannot be null.");
          else if (getAll !== undefined)
              url_ += "GetAll=" + encodeURIComponent("" + getAll) + "&";
          if (excludeRedemptionCodes === null)
              throw new Error("The parameter 'excludeRedemptionCodes' cannot be null.");
          else if (excludeRedemptionCodes !== undefined)
              url_ += "ExcludeRedemptionCodes=" + encodeURIComponent("" + excludeRedemptionCodes) + "&";
          if (excludePaymentWithMgCode === null)
              throw new Error("The parameter 'excludePaymentWithMgCode' cannot be null.");
          else if (excludePaymentWithMgCode !== undefined)
              url_ += "ExcludePaymentWithMgCode=" + encodeURIComponent("" + excludePaymentWithMgCode) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (offset === undefined || offset === null)
              throw new Error("The parameter 'offset' must be defined and cannot be null.");
          else
              url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProjectPayments(_response);
          });
      }
  
      protected processGetProjectPayments(response: Response): Promise<PaymentPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<PaymentPagedResult>(null as any);
      }
  
      /**
       * Export Payments for Project
       * @param startDate (optional) 
       * @param endDate (optional) 
       * @param getAll (optional) 
       * @param excludeRedemptionCodes (optional) 
       * @param excludePaymentWithMgCode (optional) 
       * @return Success
       */
      exportProjectPayments(projectId: number, startDate: Date | undefined, endDate: Date | undefined, getAll: boolean | undefined, excludeRedemptionCodes: boolean | undefined, excludePaymentWithMgCode: boolean | undefined, pageSize: number, offset: number): Promise<FileResponse> {
          let url_ = this.baseUrl + "/payments/{projectId}/export?";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          if (startDate === null)
              throw new Error("The parameter 'startDate' cannot be null.");
          else if (startDate !== undefined)
              url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
          if (endDate === null)
              throw new Error("The parameter 'endDate' cannot be null.");
          else if (endDate !== undefined)
              url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
          if (getAll === null)
              throw new Error("The parameter 'getAll' cannot be null.");
          else if (getAll !== undefined)
              url_ += "GetAll=" + encodeURIComponent("" + getAll) + "&";
          if (excludeRedemptionCodes === null)
              throw new Error("The parameter 'excludeRedemptionCodes' cannot be null.");
          else if (excludeRedemptionCodes !== undefined)
              url_ += "ExcludeRedemptionCodes=" + encodeURIComponent("" + excludeRedemptionCodes) + "&";
          if (excludePaymentWithMgCode === null)
              throw new Error("The parameter 'excludePaymentWithMgCode' cannot be null.");
          else if (excludePaymentWithMgCode !== undefined)
              url_ += "ExcludePaymentWithMgCode=" + encodeURIComponent("" + excludePaymentWithMgCode) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (offset === undefined || offset === null)
              throw new Error("The parameter 'offset' must be defined and cannot be null.");
          else
              url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportProjectPayments(_response);
          });
      }
  
      protected processExportProjectPayments(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get total number of user account
       * @return Success
       */
      totalNumberOfUserAccount(): Promise<number> {
          let url_ = this.baseUrl + "/platform-user-analytics/total-number-of-user-account";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalNumberOfUserAccount(_response);
          });
      }
  
      protected processTotalNumberOfUserAccount(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Get total number of active users in last 30 days
       * @return Success
       */
      totalNumberOfActiveUsersInLastThirtyDays(): Promise<number> {
          let url_ = this.baseUrl + "/platform-user-analytics/total-number-of-active-users-in-last-thirty-days";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalNumberOfActiveUsersInLastThirtyDays(_response);
          });
      }
  
      protected processTotalNumberOfActiveUsersInLastThirtyDays(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Get total number of active users in last 90 days
       * @return Success
       */
      totalNumberOfActiveUsersInLastNinetyDays(): Promise<number> {
          let url_ = this.baseUrl + "/platform-user-analytics/total-number-of-active-users-in-last-ninety-days";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalNumberOfActiveUsersInLastNinetyDays(_response);
          });
      }
  
      protected processTotalNumberOfActiveUsersInLastNinetyDays(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Get total number of inactive users in last 90 days
       * @return Success
       */
      totalNumberOfInactiveUsersInLastNinetyDays(): Promise<number> {
          let url_ = this.baseUrl + "/platform-user-analytics/total-number-of-inactive-users-in-last-ninety-days";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalNumberOfInactiveUsersInLastNinetyDays(_response);
          });
      }
  
      protected processTotalNumberOfInactiveUsersInLastNinetyDays(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Get total number of lapsed users
       * @return Success
       */
      totalNumberOfLapsedUsers(): Promise<number> {
          let url_ = this.baseUrl + "/platform-user-analytics/total-number-of-lapsed-users";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalNumberOfLapsedUsers(_response);
          });
      }
  
      protected processTotalNumberOfLapsedUsers(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Get total number of new users
       * @return Success
       */
      totalNumberOfNewUsers(): Promise<number> {
          let url_ = this.baseUrl + "/platform-user-analytics/total-number-of-new-users";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalNumberOfNewUsers(_response);
          });
      }
  
      protected processTotalNumberOfNewUsers(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Get total number of Omni online subcribers
       * @return Success
       */
      totalNumberOfOmniOnlineSubscribers(): Promise<number> {
          let url_ = this.baseUrl + "/platform-user-analytics/total-number-of-omni-online-subscribers";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalNumberOfOmniOnlineSubscribers(_response);
          });
      }
  
      protected processTotalNumberOfOmniOnlineSubscribers(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Get total number of various users in the last thirty days
       * @return Success
       */
      totalNumberOfVariousUsersInTheLastThirtyDays(): Promise<UserActivity[]> {
          let url_ = this.baseUrl + "/platform-user-analytics/total-number-of-various-users-in-the-last-thirty-days";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalNumberOfVariousUsersInTheLastThirtyDays(_response);
          });
      }
  
      protected processTotalNumberOfVariousUsersInTheLastThirtyDays(response: Response): Promise<UserActivity[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserActivity[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserActivity[]>(null as any);
      }
  
      /**
       * Export total number of various users in the last thirty days
       * @return Success
       */
      exportTotalNumberOfVariousUsersInTheLastThirtyDays(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/platform-user-analytics/total-number-of-various-users-in-the-last-thirty-days/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportTotalNumberOfVariousUsersInTheLastThirtyDays(_response);
          });
      }
  
      protected processExportTotalNumberOfVariousUsersInTheLastThirtyDays(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get total number of various users in the last twelve months
       * @return Success
       */
      totalNumberOfVariousUsersInTheLastTwelveMonths(): Promise<UserActivity[]> {
          let url_ = this.baseUrl + "/platform-user-analytics/total-number-of-various-users-in-the-last-twelve-months";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalNumberOfVariousUsersInTheLastTwelveMonths(_response);
          });
      }
  
      protected processTotalNumberOfVariousUsersInTheLastTwelveMonths(response: Response): Promise<UserActivity[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserActivity[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserActivity[]>(null as any);
      }
  
      /**
       * Export total number of various users in the last twelve months
       * @return Success
       */
      exportVariousUsersInTheLastTwelveMonths(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/platform-user-analytics/total-number-of-various-users-in-the-last-twelve-months/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportVariousUsersInTheLastTwelveMonths(_response);
          });
      }
  
      protected processExportVariousUsersInTheLastTwelveMonths(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get total activity churn in the last twelve months
       * @return Success
       */
      getTotalActivityChurn(): Promise<UserChurn[]> {
          let url_ = this.baseUrl + "/platform-user-analytics/activity-churn";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetTotalActivityChurn(_response);
          });
      }
  
      protected processGetTotalActivityChurn(response: Response): Promise<UserChurn[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserChurn[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserChurn[]>(null as any);
      }
  
      /**
       * Export total activity churn in the last twelve months
       * @return Success
       */
      exportTotalActivityChurn(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/platform-user-analytics/activity-churn/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportTotalActivityChurn(_response);
          });
      }
  
      protected processExportTotalActivityChurn(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get total activity resurrection in the last twelve months
       * @return Success
       */
      getTotalActivityResurrection(): Promise<UserChurn[]> {
          let url_ = this.baseUrl + "/platform-user-analytics/activity-resurrection";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetTotalActivityResurrection(_response);
          });
      }
  
      protected processGetTotalActivityResurrection(response: Response): Promise<UserChurn[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserChurn[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserChurn[]>(null as any);
      }
  
      /**
       * Export total activity resurrection in the last twelve months
       * @return Success
       */
      exportTotalActivityResurrection(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/platform-user-analytics/activity-resurrection/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportTotalActivityResurrection(_response);
          });
      }
  
      protected processExportTotalActivityResurrection(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get total omni online churn in the last twelve months
       * @return Success
       */
      getTotalOmniOnlineChurn(): Promise<UserChurn[]> {
          let url_ = this.baseUrl + "/platform-user-analytics/omni-online-churn";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetTotalOmniOnlineChurn(_response);
          });
      }
  
      protected processGetTotalOmniOnlineChurn(response: Response): Promise<UserChurn[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserChurn[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserChurn[]>(null as any);
      }
  
      /**
       * Export total omni online churn in the last twelve months
       * @return Success
       */
      exportTotalOmniOnlineChurn(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/platform-user-analytics/omni-online-churn/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportTotalOmniOnlineChurn(_response);
          });
      }
  
      protected processExportTotalOmniOnlineChurn(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get total omni online resurrection in the last twelve months
       * @return Success
       */
      getTotalOmniOnlineResurrections(): Promise<UserChurn[]> {
          let url_ = this.baseUrl + "/platform-user-analytics/omni-online-resurrection";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetTotalOmniOnlineResurrections(_response);
          });
      }
  
      protected processGetTotalOmniOnlineResurrections(response: Response): Promise<UserChurn[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserChurn[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserChurn[]>(null as any);
      }
  
      /**
       * Export total omni online resurrection in the last twelve months
       * @return Success
       */
      exportTotalOmniOnlineResurrection(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/platform-user-analytics/omni-online-resurrection/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportTotalOmniOnlineResurrection(_response);
          });
      }
  
      protected processExportTotalOmniOnlineResurrection(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get maximum and average number of concurrent users in the last thirty days
       * @return Success
       */
      maximumAndAverageNumberOfConcurrentUsersInTheLastThirtyDays(): Promise<ConcurrentUser> {
          let url_ = this.baseUrl + "/platform-user-analytics/maximum-and-average-number-of-concurrent-users-in-the-last-thirty-days";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processMaximumAndAverageNumberOfConcurrentUsersInTheLastThirtyDays(_response);
          });
      }
  
      protected processMaximumAndAverageNumberOfConcurrentUsersInTheLastThirtyDays(response: Response): Promise<ConcurrentUser> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConcurrentUser;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ConcurrentUser>(null as any);
      }
  
      /**
       * Get monthly churn rate of omni online
       * @return Success
       */
      getMonthlyChurnRateOfOmniOnline(): Promise<number> {
          let url_ = this.baseUrl + "/platform-user-analytics/monthly-churn-rate-of-omni-online";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetMonthlyChurnRateOfOmniOnline(_response);
          });
      }
  
      protected processGetMonthlyChurnRateOfOmniOnline(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Get count of active omni online
       * @return Success
       */
      getCountOfActiveOmniOnline(): Promise<number> {
          let url_ = this.baseUrl + "/platform-user-analytics/count-of-active-omni-online";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetCountOfActiveOmniOnline(_response);
          });
      }
  
      protected processGetCountOfActiveOmniOnline(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Current users privacy settings
       * @return Success
       */
      getPrivacySettings(): Promise<PrivacySettingsDto> {
          let url_ = this.baseUrl + "/privacy-settings";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetPrivacySettings(_response);
          });
      }
  
      protected processGetPrivacySettings(response: Response): Promise<PrivacySettingsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrivacySettingsDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<PrivacySettingsDto>(null as any);
      }
  
      /**
       * Update current users privacy settings
       * @param body (optional) 
       * @return Success
       */
      updatePrivacySettings(body: PrivacySettingsDto | undefined): Promise<void> {
          let url_ = this.baseUrl + "/privacy-settings";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdatePrivacySettings(_response);
          });
      }
  
      protected processUpdatePrivacySettings(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get reviews with pagination for a game
       * @param keywords (optional) 
       * @param plaintext (optional) 
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getProductUserReviews(productId: string, keywords: string | undefined, plaintext: boolean | undefined, sortField: QueryProductUserReviewSortField | undefined, sortOrder: SortOrder | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<ProductUserReviewListItemDtoPagedResult> {
          let url_ = this.baseUrl + "/products/{productId}/reviews?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (keywords === null)
              throw new Error("The parameter 'keywords' cannot be null.");
          else if (keywords !== undefined)
              url_ += "Keywords=" + encodeURIComponent("" + keywords) + "&";
          if (plaintext === null)
              throw new Error("The parameter 'plaintext' cannot be null.");
          else if (plaintext !== undefined)
              url_ += "Plaintext=" + encodeURIComponent("" + plaintext) + "&";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProductUserReviews(_response);
          });
      }
  
      protected processGetProductUserReviews(response: Response): Promise<ProductUserReviewListItemDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductUserReviewListItemDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductUserReviewListItemDtoPagedResult>(null as any);
      }
  
      /**
       * Review a Game
       * @param body (optional) 
       * @return No Content
       */
      createProductUserReview(productId: string, body: CreateProductUserReviewRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/products/{productId}/reviews/create";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateProductUserReview(_response);
          });
      }
  
      protected processCreateProductUserReview(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get a review summary for a game
       * @return Success
       */
      getProductUserReviewSummary(productId: string): Promise<ProductRatingSummaryDto> {
          let url_ = this.baseUrl + "/products/{productId}/reviews-summary";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProductUserReviewSummary(_response);
          });
      }
  
      protected processGetProductUserReviewSummary(response: Response): Promise<ProductRatingSummaryDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductRatingSummaryDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductRatingSummaryDto>(null as any);
      }
  
      /**
       * Get the review for a game submitted by me
       * @return Success
       */
      getMyProductUserReview(productId: string): Promise<ProductUserReviewDto> {
          let url_ = this.baseUrl + "/products/{productId}/my-review";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetMyProductUserReview(_response);
          });
      }
  
      protected processGetMyProductUserReview(response: Response): Promise<ProductUserReviewDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductUserReviewDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductUserReviewDto>(null as any);
      }
  
      /**
       * Add review feedback
       * @param body (optional) 
       * @return No Content
       */
      addReviewFeedback(productId: string, reviewId: number, body: CreateReviewFeedbackRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/products/{productId}/reviews/{reviewId}/feedback";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (reviewId === undefined || reviewId === null)
              throw new Error("The parameter 'reviewId' must be defined.");
          url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAddReviewFeedback(_response);
          });
      }
  
      protected processAddReviewFeedback(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Remove review feedback
       * @return No Content
       */
      removeReviewFeedback(productId: string, reviewId: number): Promise<void> {
          let url_ = this.baseUrl + "/products/{productId}/reviews/{reviewId}/feedback";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          if (reviewId === undefined || reviewId === null)
              throw new Error("The parameter 'reviewId' must be defined.");
          url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRemoveReviewFeedback(_response);
          });
      }
  
      protected processRemoveReviewFeedback(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get list of reviews for reviewing
       * @param productUserReviewStatus (optional) 
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param searchTerm (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getAllProdcutReviewsForReviewing(productUserReviewStatus: ProductUserReviewStatus[] | undefined, sortField: ProductUserReviewForReviewingSortField | undefined, sortOrder: SortOrder | undefined, searchTerm: string | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<ProductUserReviewForReviewingDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/store/reviews?";
          if (productUserReviewStatus === null)
              throw new Error("The parameter 'productUserReviewStatus' cannot be null.");
          else if (productUserReviewStatus !== undefined)
              productUserReviewStatus && productUserReviewStatus.forEach(item => { url_ += "ProductUserReviewStatus=" + encodeURIComponent("" + item) + "&"; });
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAllProdcutReviewsForReviewing(_response);
          });
      }
  
      protected processGetAllProdcutReviewsForReviewing(response: Response): Promise<ProductUserReviewForReviewingDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductUserReviewForReviewingDtoPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductUserReviewForReviewingDtoPagedResult>(null as any);
      }
  
      /**
       * Get summary of all reviews
       * @return Success
       */
      getSummaryOfAllReviews(): Promise<SummaryOfAllReviewsDto> {
          let url_ = this.baseUrl + "/admin/store/reviews/summary";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetSummaryOfAllReviews(_response);
          });
      }
  
      protected processGetSummaryOfAllReviews(response: Response): Promise<SummaryOfAllReviewsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryOfAllReviewsDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SummaryOfAllReviewsDto>(null as any);
      }
  
      /**
       * Update review status by review id
       * @param body (optional) 
       * @return No Content
       */
      updateReviewStatus(reviewId: number, body: UpdateReviewStatusRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/store/reviews/{reviewId}/status";
          if (reviewId === undefined || reviewId === null)
              throw new Error("The parameter 'reviewId' must be defined.");
          url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateReviewStatus(_response);
          });
      }
  
      protected processUpdateReviewStatus(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Admin can warn player by sending an email
       * @return No Content
       */
      warnPlayer(reviewId: number): Promise<void> {
          let url_ = this.baseUrl + "/admin/store/reviews/{reviewId}/warn";
          if (reviewId === undefined || reviewId === null)
              throw new Error("The parameter 'reviewId' must be defined.");
          url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processWarnPlayer(_response);
          });
      }
  
      protected processWarnPlayer(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get product paged list
       * @param searchTerm (optional) 
       * @param userId (optional) 
       * @return Success
       */
      getProducts(pageNum: number, pageSize: number, searchTerm: string | undefined, userId: string | undefined): Promise<ProductListItemDtoPagedResult> {
          let url_ = this.baseUrl + "/products?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (userId === null)
              throw new Error("The parameter 'userId' cannot be null.");
          else if (userId !== undefined)
              url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProducts(_response);
          });
      }
  
      protected processGetProducts(response: Response): Promise<ProductListItemDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductListItemDtoPagedResult;
              return result200;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductListItemDtoPagedResult>(null as any);
      }
  
      /**
       * Get product details
       * @return Success
       */
      getProductDetails(id: string): Promise<ProductDetailsDto> {
          let url_ = this.baseUrl + "/products/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProductDetails(_response);
          });
      }
  
      protected processGetProductDetails(response: Response): Promise<ProductDetailsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductDetailsDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductDetailsDto>(null as any);
      }
  
      /**
       * Return the default applications
       * @return Success
       */
      getDefaultApplications(): Promise<DefaultApplicationDto[]> {
          let url_ = this.baseUrl + "/products/default-applications";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetDefaultApplications(_response);
          });
      }
  
      protected processGetDefaultApplications(response: Response): Promise<DefaultApplicationDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DefaultApplicationDto[];
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<DefaultApplicationDto[]>(null as any);
      }
  
      /**
       * @return Success
       */
      progress(operationId: string): Promise<number> {
          let url_ = this.baseUrl + "/progress/{operationId}";
          if (operationId === undefined || operationId === null)
              throw new Error("The parameter 'operationId' must be defined.");
          url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processProgress(_response);
          });
      }
  
      protected processProgress(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              let result500: any = null;
              result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Server Error", status, _responseText, _headers, result500);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Get projects
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @return Success
       */
      getProjects(sortField: GetAllProjectsQuerySortField | undefined, sortOrder: SortOrder | undefined): Promise<ProjectDtoPagedResult> {
          let url_ = this.baseUrl + "/content-provider/projects?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProjects(_response);
          });
      }
  
      protected processGetProjects(response: Response): Promise<ProjectDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProjectDtoPagedResult>(null as any);
      }
  
      /**
       * Init Project
       * @param body (optional) 
       * @return Success
       */
      initProject(body: InitProjectCommand | undefined): Promise<number> {
          let url_ = this.baseUrl + "/content-provider/projects";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processInitProject(_response);
          });
      }
  
      protected processInitProject(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Create a server key for a project
       * @return Success
       */
      generateServerKey(projectId: number): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/projects/{projectId}/server-key";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "PUT",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGenerateServerKey(_response);
          });
      }
  
      protected processGenerateServerKey(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get project info
       * @return Success
       */
      getProjectInfo(projectId: number): Promise<Project> {
          let url_ = this.baseUrl + "/content-provider/projects/{projectId}";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProjectInfo(_response);
          });
      }
  
      protected processGetProjectInfo(response: Response): Promise<Project> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Project;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Project>(null as any);
      }
  
      /**
       * Get the project status
       * @return Success
       */
      getProjectStatus(projectId: number): Promise<ProjectStatusDto> {
          let url_ = this.baseUrl + "/content-provider/projects/{projectId}/status";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProjectStatus(_response);
          });
      }
  
      protected processGetProjectStatus(response: Response): Promise<ProjectStatusDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatusDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProjectStatusDto>(null as any);
      }
  
      /**
       * Get product from project
       * @return Success
       */
      getProjectProduct(projectId: number): Promise<ProjectProductDetailsDto> {
          let url_ = this.baseUrl + "/content-provider/projects/{projectId}/store-details";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProjectProduct(_response);
          });
      }
  
      protected processGetProjectProduct(response: Response): Promise<ProjectProductDetailsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectProductDetailsDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProjectProductDetailsDto>(null as any);
      }
  
      /**
       * Update a projects store details
       * @param body (optional) 
       * @return Success
       */
      updateProjectStoreDetails(projectId: number, body: UpdateProjectStoreDetailsCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/projects/{projectId}/store-details";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateProjectStoreDetails(_response);
          });
      }
  
      protected processUpdateProjectStoreDetails(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Update a project name
       * @param body (optional) 
       * @return Success
       */
      updateProjectName(projectId: number, body: UpdateProjectNameCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/projects/{projectId}/name";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateProjectName(_response);
          });
      }
  
      protected processUpdateProjectName(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Submit project for review
       * @return Success
       */
      submitProjectForReview(projectId: number): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/projects/{projectId}/submit";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSubmitProjectForReview(_response);
          });
      }
  
      protected processSubmitProjectForReview(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Release project on the Omni Store
       * @return Success
       */
      releaseProjectOnStore(projectId: number): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/projects/{projectId}/release-on-store";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "PUT",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processReleaseProjectOnStore(_response);
          });
      }
  
      protected processReleaseProjectOnStore(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get list of published content
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param includedStatuses (optional) 
       * @param search (optional) 
       * @return Success
       */
      getPublishedContent(pageNumber: number | undefined, pageSize: number | undefined, sortField: PublishContentListSortField | undefined, sortOrder: SortOrder | undefined, includedStatuses: ProductStatus[] | undefined, search: string | undefined): Promise<PublishedContentDtoPagedResult> {
          let url_ = this.baseUrl + "/published-content?";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (includedStatuses === null)
              throw new Error("The parameter 'includedStatuses' cannot be null.");
          else if (includedStatuses !== undefined)
              includedStatuses && includedStatuses.forEach(item => { url_ += "includedStatuses=" + encodeURIComponent("" + item) + "&"; });
          if (search === null)
              throw new Error("The parameter 'search' cannot be null.");
          else if (search !== undefined)
              url_ += "search=" + encodeURIComponent("" + search) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetPublishedContent(_response);
          });
      }
  
      protected processGetPublishedContent(response: Response): Promise<PublishedContentDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublishedContentDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<PublishedContentDtoPagedResult>(null as any);
      }
  
      /**
       * Get the publishing requirement records for a product
       * @return Success
       */
      getProductPublishingRequirements(productId: string): Promise<ProductPublishingRequirementRecordDto[]> {
          let url_ = this.baseUrl + "/products/{productId}/publishing-requirements";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProductPublishingRequirements(_response);
          });
      }
  
      protected processGetProductPublishingRequirements(response: Response): Promise<ProductPublishingRequirementRecordDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductPublishingRequirementRecordDto[];
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductPublishingRequirementRecordDto[]>(null as any);
      }
  
      /**
       * Submit the publishing requirement records for a product
       * @param body (optional) 
       * @return No Content
       */
      upsertProductPublishingRequirements(productId: string, body: UpsertProductPublishingRequirementRecordsRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/products/{productId}/publishing-requirements";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpsertProductPublishingRequirements(_response);
          });
      }
  
      protected processUpsertProductPublishingRequirements(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Returns messages for logged in client and updates online status
       * @param mobile (optional) 
       * @param omniSerialNumber (optional) 
       * @param headsetId (optional) 
       * @return Success
       */
      getRealtimeMessages(lastUpdateId: number, mobile: boolean | undefined, omniSerialNumber: string | undefined, headsetId: string | undefined): Promise<RealtimeMessageDto[]> {
          let url_ = this.baseUrl + "/realtime-message/{lastUpdateId}?";
          if (lastUpdateId === undefined || lastUpdateId === null)
              throw new Error("The parameter 'lastUpdateId' must be defined.");
          url_ = url_.replace("{lastUpdateId}", encodeURIComponent("" + lastUpdateId));
          if (mobile === null)
              throw new Error("The parameter 'mobile' cannot be null.");
          else if (mobile !== undefined)
              url_ += "mobile=" + encodeURIComponent("" + mobile) + "&";
          if (omniSerialNumber === null)
              throw new Error("The parameter 'omniSerialNumber' cannot be null.");
          else if (omniSerialNumber !== undefined)
              url_ += "omniSerialNumber=" + encodeURIComponent("" + omniSerialNumber) + "&";
          if (headsetId === null)
              throw new Error("The parameter 'headsetId' cannot be null.");
          else if (headsetId !== undefined)
              url_ += "headsetId=" + encodeURIComponent("" + headsetId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetRealtimeMessages(_response);
          });
      }
  
      protected processGetRealtimeMessages(response: Response): Promise<RealtimeMessageDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RealtimeMessageDto[];
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<RealtimeMessageDto[]>(null as any);
      }
  
      /**
       * Redeem a Code
       * @param body (optional) 
       * @return Success
       */
      redeemCode(body: RedeemCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/redemption-codes/redeem";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRedeemCode(_response);
          });
      }
  
      protected processRedeemCode(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Return the redemption code if the user can redeem the code
       * @return Success
       */
      getAvailableCode(code: string): Promise<RedemptionCodeDto> {
          let url_ = this.baseUrl + "/redemption-codes/{code}/available";
          if (code === undefined || code === null)
              throw new Error("The parameter 'code' must be defined.");
          url_ = url_.replace("{code}", encodeURIComponent("" + code));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAvailableCode(_response);
          });
      }
  
      protected processGetAvailableCode(response: Response): Promise<RedemptionCodeDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RedemptionCodeDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<RedemptionCodeDto>(null as any);
      }
  
      /**
       * Get project redemption codes
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getProjectRedemptionCodes(projectId: number, sortField: RedemptionCodeListSortField | undefined, sortOrder: SortOrder | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<RedemptionCodeDtoPagedResult> {
          let url_ = this.baseUrl + "/content-provider/redemption-codes/{projectId}?";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProjectRedemptionCodes(_response);
          });
      }
  
      protected processGetProjectRedemptionCodes(response: Response): Promise<RedemptionCodeDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RedemptionCodeDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<RedemptionCodeDtoPagedResult>(null as any);
      }
  
      /**
       * Generate redemption codes
       * @param body (optional) 
       * @return Success
       */
      generateRedemptionCodes(projectId: number, body: GenerateRedemptionCodesCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/redemption-codes/{projectId}";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGenerateRedemptionCodes(_response);
          });
      }
  
      protected processGenerateRedemptionCodes(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Delete redemption codes
       * @param ids (optional) 
       * @return Success
       */
      deleteRedemptionCodes(projectId: number, ids: number[] | undefined): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/redemption-codes/{projectId}?";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          if (ids === null)
              throw new Error("The parameter 'ids' cannot be null.");
          else if (ids !== undefined)
              ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteRedemptionCodes(_response);
          });
      }
  
      protected processDeleteRedemptionCodes(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Export redemption code list
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param exportType (optional) 
       * @return Success
       */
      exportRedemptionCodes(projectId: number, sortField: RedemptionCodeListSortField | undefined, sortOrder: SortOrder | undefined, exportType: ExportType | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/content-provider/redemption-codes/{projectId}/export?";
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (exportType === null)
              throw new Error("The parameter 'exportType' cannot be null.");
          else if (exportType !== undefined)
              url_ += "ExportType=" + encodeURIComponent("" + exportType) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportRedemptionCodes(_response);
          });
      }
  
      protected processExportRedemptionCodes(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get list of releases
       * @param currentVersion (optional) 
       * @param picoVersion (optional) 
       * @return Success
       */
      getReleases(pageNum: number, pageSize: number, currentVersion: string | undefined, picoVersion: PicoVersion | undefined): Promise<ReleaseDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/releases?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (currentVersion === null)
              throw new Error("The parameter 'currentVersion' cannot be null.");
          else if (currentVersion !== undefined)
              url_ += "CurrentVersion=" + encodeURIComponent("" + currentVersion) + "&";
          if (picoVersion === null)
              throw new Error("The parameter 'picoVersion' cannot be null.");
          else if (picoVersion !== undefined)
              url_ += "PicoVersion=" + encodeURIComponent("" + picoVersion) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetReleases(_response);
          });
      }
  
      protected processGetReleases(response: Response): Promise<ReleaseDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleaseDtoPagedResult;
              return result200;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ReleaseDtoPagedResult>(null as any);
      }
  
      /**
       * Create new release
       * @param body (optional) 
       * @return Success
       */
      createRelease(body: CreateReleaseCommand | undefined): Promise<Result> {
          let url_ = this.baseUrl + "/admin/releases";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateRelease(_response);
          });
      }
  
      protected processCreateRelease(response: Response): Promise<Result> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
              return result200;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Result>(null as any);
      }
  
      /**
       * Delete latest release
       */
      deleteLatestRelease(): Promise<void> {
          let url_ = this.baseUrl + "/admin/releases";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteLatestRelease(_response);
          });
      }
  
      protected processDeleteLatestRelease(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get latest release
       * @param currentVersion (optional) 
       * @param picoVersion (optional) 
       * @return Success
       */
      getLatest(currentVersion: string | undefined, picoVersion: PicoVersion | undefined): Promise<ReleaseDto> {
          let url_ = this.baseUrl + "/releases/latest?";
          if (currentVersion === null)
              throw new Error("The parameter 'currentVersion' cannot be null.");
          else if (currentVersion !== undefined)
              url_ += "currentVersion=" + encodeURIComponent("" + currentVersion) + "&";
          if (picoVersion === null)
              throw new Error("The parameter 'picoVersion' cannot be null.");
          else if (picoVersion !== undefined)
              url_ += "picoVersion=" + encodeURIComponent("" + picoVersion) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLatest(_response);
          });
      }
  
      protected processGetLatest(response: Response): Promise<ReleaseDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleaseDto;
              return result200;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ReleaseDto>(null as any);
      }
  
      /**
       * Gets summary of revenue related transactions
       * @return Success
       */
      transactionSummary(): Promise<RevenueTransactionSummaryDto> {
          let url_ = this.baseUrl + "/revenue-analytics/transaction-summary";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTransactionSummary(_response);
          });
      }
  
      protected processTransactionSummary(response: Response): Promise<RevenueTransactionSummaryDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RevenueTransactionSummaryDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<RevenueTransactionSummaryDto>(null as any);
      }
  
      /**
       * Gets summary of revenue related transactions by productId
       * @return Success
       */
      transactionSummaryByProductId(productId: string): Promise<RevenueTransactionSummaryDto> {
          let url_ = this.baseUrl + "/revenue-analytics/transaction-summary/{productId}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTransactionSummaryByProductId(_response);
          });
      }
  
      protected processTransactionSummaryByProductId(response: Response): Promise<RevenueTransactionSummaryDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RevenueTransactionSummaryDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<RevenueTransactionSummaryDto>(null as any);
      }
  
      /**
       * Gets game revenues
       * @param groupBy Group revenues by month or year. 0 = month || 1 = year
       * @return Success
       */
      getGameRevenues(groupBy: RevenuePeriod): Promise<GameRevenues[]> {
          let url_ = this.baseUrl + "/revenue-analytics/game-revenues?";
          if (groupBy === undefined || groupBy === null)
              throw new Error("The parameter 'groupBy' must be defined and cannot be null.");
          else
              url_ += "groupBy=" + encodeURIComponent("" + groupBy) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetGameRevenues(_response);
          });
      }
  
      protected processGetGameRevenues(response: Response): Promise<GameRevenues[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GameRevenues[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<GameRevenues[]>(null as any);
      }
  
      /**
       * Gets omni online revenue
       * @return Success
       */
      getOmniOnlineRevenue(): Promise<OmniOnlineStatsAllTimeDto> {
          let url_ = this.baseUrl + "/revenue-analytics/omni-online-revenues";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetOmniOnlineRevenue(_response);
          });
      }
  
      protected processGetOmniOnlineRevenue(response: Response): Promise<OmniOnlineStatsAllTimeDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OmniOnlineStatsAllTimeDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<OmniOnlineStatsAllTimeDto>(null as any);
      }
  
      /**
       * Gets average revenue from games for users
       * @return Success
       */
      getAverageRevenuePerUser(): Promise<RevenuePerUserDto[]> {
          let url_ = this.baseUrl + "/revenue-analytics/user-game-revenues";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAverageRevenuePerUser(_response);
          });
      }
  
      protected processGetAverageRevenuePerUser(response: Response): Promise<RevenuePerUserDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RevenuePerUserDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<RevenuePerUserDto[]>(null as any);
      }
  
      /**
       * Gets revenues stats
       * @return Success
       */
      getRevenuesStats(productId: string): Promise<TimeSeriesGraphDto> {
          let url_ = this.baseUrl + "/revenue-analytics/revenues-stats/{productId}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetRevenuesStats(_response);
          });
      }
  
      protected processGetRevenuesStats(response: Response): Promise<TimeSeriesGraphDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimeSeriesGraphDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<TimeSeriesGraphDto>(null as any);
      }
  
      /**
       * Gets payment by productId
       * @param productId (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @param dateStart (optional) 
       * @param dateEnd (optional) 
       * @return Success
       */
      getPaymentByProductId(productId: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, dateStart: Date | undefined, dateEnd: Date | undefined): Promise<ProductPaymentDtoPagedResult> {
          let url_ = this.baseUrl + "/revenue-analytics/payment-by-productId?";
          if (productId === null)
              throw new Error("The parameter 'productId' cannot be null.");
          else if (productId !== undefined)
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (dateStart === null)
              throw new Error("The parameter 'dateStart' cannot be null.");
          else if (dateStart !== undefined)
              url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
          if (dateEnd === null)
              throw new Error("The parameter 'dateEnd' cannot be null.");
          else if (dateEnd !== undefined)
              url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetPaymentByProductId(_response);
          });
      }
  
      protected processGetPaymentByProductId(response: Response): Promise<ProductPaymentDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductPaymentDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductPaymentDtoPagedResult>(null as any);
      }
  
      /**
       * Export payment by productId
       * @param productId (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @param dateStart (optional) 
       * @param dateEnd (optional) 
       * @return Success
       */
      exportPaymentByProductId(productId: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, dateStart: Date | undefined, dateEnd: Date | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/revenue-analytics/payment-by-productId/export?";
          if (productId === null)
              throw new Error("The parameter 'productId' cannot be null.");
          else if (productId !== undefined)
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (dateStart === null)
              throw new Error("The parameter 'dateStart' cannot be null.");
          else if (dateStart !== undefined)
              url_ += "DateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
          if (dateEnd === null)
              throw new Error("The parameter 'dateEnd' cannot be null.");
          else if (dateEnd !== undefined)
              url_ += "DateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportPaymentByProductId(_response);
          });
      }
  
      protected processExportPaymentByProductId(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Get monthly avg spent per user
       * @return Success
       */
      getMonthlyAvgSpentPerUser(): Promise<number> {
          let url_ = this.baseUrl + "/revenue-analytics/monthly-avg-spent-per-user";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetMonthlyAvgSpentPerUser(_response);
          });
      }
  
      protected processGetMonthlyAvgSpentPerUser(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Export average revenue from games for users
       * @return Success
       */
      exportAverageRevenuePerUser(): Promise<FileResponse> {
          let url_ = this.baseUrl + "/revenue-analytics/user-game-revenues/export";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportAverageRevenuePerUser(_response);
          });
      }
  
      protected processExportAverageRevenuePerUser(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Export game revenues
       * @param period Group revenues by month or year. 0 = month || 1 = year
       * @return Success
       */
      exportGameRevenues(period: RevenuePeriod): Promise<FileResponse> {
          let url_ = this.baseUrl + "/revenue-analytics/game-revenues/export?";
          if (period === undefined || period === null)
              throw new Error("The parameter 'period' must be defined and cannot be null.");
          else
              url_ += "period=" + encodeURIComponent("" + period) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportGameRevenues(_response);
          });
      }
  
      protected processExportGameRevenues(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Blocks the provided user from interacting with the logged in user
       * @param body (optional) 
       * @return Success
       */
      blockUser(body: SocialRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/social/block-user";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processBlockUser(_response);
          });
      }
  
      protected processBlockUser(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * unblocks the provided user from interacting with the logged in user
       * @param body (optional) 
       * @return Success
       */
      unblockUser(body: SocialRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/social/unblock-user";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUnblockUser(_response);
          });
      }
  
      protected processUnblockUser(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * get the users that the logged in user has blocked
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getBlockedUsers(pageNumber: number | undefined, pageSize: number | undefined): Promise<FriendDtoPagedResult> {
          let url_ = this.baseUrl + "/social/blocked-users?";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetBlockedUsers(_response);
          });
      }
  
      protected processGetBlockedUsers(response: Response): Promise<FriendDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FriendDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FriendDtoPagedResult>(null as any);
      }
  
      /**
       * Search accounts by username
       * @param body (optional) 
       * @return Success
       */
      searchAccount(body: SearchAccount | undefined): Promise<UserSearchResultDtoPagedResult> {
          let url_ = this.baseUrl + "/social/search";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSearchAccount(_response);
          });
      }
  
      protected processSearchAccount(response: Response): Promise<UserSearchResultDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSearchResultDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserSearchResultDtoPagedResult>(null as any);
      }
  
      /**
       * Search account by given user id
       * @return Success
       */
      searchAccountById(userId: string): Promise<UserSearchResultDto> {
          let url_ = this.baseUrl + "/social/search/{userId}";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSearchAccountById(_response);
          });
      }
  
      protected processSearchAccountById(response: Response): Promise<UserSearchResultDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSearchResultDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserSearchResultDto>(null as any);
      }
  
      /**
       * Search online accounts by username
       * @param body (optional) 
       * @return Success
       */
      searchOnlineAccounts(body: SearchAccount | undefined): Promise<UserSearchResultDtoPagedResult> {
          let url_ = this.baseUrl + "/social/online-search";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSearchOnlineAccounts(_response);
          });
      }
  
      protected processSearchOnlineAccounts(response: Response): Promise<UserSearchResultDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSearchResultDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserSearchResultDtoPagedResult>(null as any);
      }
  
      /**
       * Invite userId to become your friend
       * @param body (optional) 
       * @return Success
       */
      inviteFriend(body: SocialRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/social/friend/invite";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processInviteFriend(_response);
          });
      }
  
      protected processInviteFriend(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * ignore request from the userId
       * @param body (optional) 
       * @return Success
       */
      ignoreFriend(body: SocialRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/social/friend/ignore";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processIgnoreFriend(_response);
          });
      }
  
      protected processIgnoreFriend(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Accept request from the userId
       * @param body (optional) 
       * @return Success
       */
      acceptFriend(body: SocialRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/social/friend/accept";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAcceptFriend(_response);
          });
      }
  
      protected processAcceptFriend(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Unfriend the provided user id
       * @param body (optional) 
       * @return Success
       */
      unfriend(body: UnfriendRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/social/friend/unfriend";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUnfriend(_response);
          });
      }
  
      protected processUnfriend(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Make the userid provided a favorite friend
       * @param body (optional) 
       * @return Success
       */
      createFavoriteFriend(body: CreateFavoriteFriendRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/social/friend/favorite-friend";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateFavoriteFriend(_response);
          });
      }
  
      protected processCreateFavoriteFriend(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Make the userid provided no longer a favorite friend
       * @return Success
       */
      deleteFavoriteFriend(userId: string): Promise<boolean> {
          let url_ = this.baseUrl + "/social/friend/favorite-friend/{userId}";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteFavoriteFriend(_response);
          });
      }
  
      protected processDeleteFavoriteFriend(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * get current user's pending friend requests
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      pendingFriendRequests(pageNumber: number | undefined, pageSize: number | undefined): Promise<UserSearchResultDtoPagedResult> {
          let url_ = this.baseUrl + "/social/friend/pending?";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processPendingFriendRequests(_response);
          });
      }
  
      protected processPendingFriendRequests(response: Response): Promise<UserSearchResultDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSearchResultDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserSearchResultDtoPagedResult>(null as any);
      }
  
      /**
       * get current user's friends
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getFriends(pageNumber: number | undefined, pageSize: number | undefined): Promise<FriendDtoPagedResult> {
          let url_ = this.baseUrl + "/social/friend?";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetFriends(_response);
          });
      }
  
      protected processGetFriends(response: Response): Promise<FriendDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FriendDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FriendDtoPagedResult>(null as any);
      }
  
      /**
       * Get the provided user's friends.
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getFriendsForUserId(userId: string, pageNumber: number | undefined, pageSize: number | undefined): Promise<FriendDtoPagedResult> {
          let url_ = this.baseUrl + "/social/friend/{userId}?";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetFriendsForUserId(_response);
          });
      }
  
      protected processGetFriendsForUserId(response: Response): Promise<FriendDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FriendDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FriendDtoPagedResult>(null as any);
      }
  
      /**
       * get the requests to become friends with another user made by the logged in user
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getFriendRequestsMadeByUser(pageNumber: number | undefined, pageSize: number | undefined): Promise<FriendDtoPagedResult> {
          let url_ = this.baseUrl + "/social/friend-requests-made-by-user?";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetFriendRequestsMadeByUser(_response);
          });
      }
  
      protected processGetFriendRequestsMadeByUser(response: Response): Promise<FriendDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FriendDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FriendDtoPagedResult>(null as any);
      }
  
      /**
       * Gets the relationship between the current user and other users.
       * @param body (optional) 
       * @return Success
       */
      getUserRelations(body: GetUserRelationsRequest | undefined): Promise<{ [key: string]: UserRelationType; }> {
          let url_ = this.baseUrl + "/social/get-user-relations";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserRelations(_response);
          });
      }
  
      protected processGetUserRelations(response: Response): Promise<{ [key: string]: UserRelationType; }> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: UserRelationType; };
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<{ [key: string]: UserRelationType; }>(null as any);
      }
  
      /**
       * Get friends who own a game
       * @return Success
       */
      getFriendsWhoOwnAGame(productId: string, pageNumber: number, pageSize: number): Promise<FriendsWhoOwnAGameDtoPagedResult> {
          let url_ = this.baseUrl + "/social/friends-own-a-game?";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined and cannot be null.");
          else
              url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
          if (pageNumber === undefined || pageNumber === null)
              throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
          else
              url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetFriendsWhoOwnAGame(_response);
          });
      }
  
      protected processGetFriendsWhoOwnAGame(response: Response): Promise<FriendsWhoOwnAGameDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FriendsWhoOwnAGameDtoPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FriendsWhoOwnAGameDtoPagedResult>(null as any);
      }
  
      /**
       * Get System Status
       * @return Success
       */
      getStatus(): Promise<boolean> {
          let url_ = this.baseUrl + "/status";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetStatus(_response);
          });
      }
  
      protected processGetStatus(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Get System Version
       * @return Success
       */
      getVersion(): Promise<string> {
          let url_ = this.baseUrl + "/status/version";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetVersion(_response);
          });
      }
  
      protected processGetVersion(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Get store management products paged list
       * @param status (optional) 
       * @param search (optional) 
       * @return Success
       */
      getStoreManagementProducts(pageNum: number, pageSize: number, sortField: ProductTableSortField, sortOrder: SortOrder, status: ProductStatus | undefined, search: string | undefined): Promise<StoreManagementProductListItemDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/store/products?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (status === null)
              throw new Error("The parameter 'status' cannot be null.");
          else if (status !== undefined)
              url_ += "Status=" + encodeURIComponent("" + status) + "&";
          if (search === null)
              throw new Error("The parameter 'search' cannot be null.");
          else if (search !== undefined)
              url_ += "Search=" + encodeURIComponent("" + search) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetStoreManagementProducts(_response);
          });
      }
  
      protected processGetStoreManagementProducts(response: Response): Promise<StoreManagementProductListItemDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StoreManagementProductListItemDtoPagedResult;
              return result200;
              });
          } else if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StoreManagementProductListItemDtoPagedResult>(null as any);
      }
  
      /**
       * Get store management product details
       * @return Success
       */
      getStoreManagementProductDetails(id: string): Promise<StoreManagementProductDetailsDto> {
          let url_ = this.baseUrl + "/admin/store/products/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetStoreManagementProductDetails(_response);
          });
      }
  
      protected processGetStoreManagementProductDetails(response: Response): Promise<StoreManagementProductDetailsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StoreManagementProductDetailsDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StoreManagementProductDetailsDto>(null as any);
      }
  
      /**
       * Updates existed products
       * @param body (optional) 
       * @return No Content
       */
      updateStoreManagementProduct(id: string, body: UpdateStoreManagementProductCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/store/products/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateStoreManagementProduct(_response);
          });
      }
  
      protected processUpdateStoreManagementProduct(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get product price history
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @return Success
       */
      getProductPriceHistory(id: string, sortField: ProductPriceSortField | undefined, sortOrder: SortOrder | undefined): Promise<ProductPriceDto[]> {
          let url_ = this.baseUrl + "/admin/store/products/{id}/price-history?";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProductPriceHistory(_response);
          });
      }
  
      protected processGetProductPriceHistory(response: Response): Promise<ProductPriceDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductPriceDto[];
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductPriceDto[]>(null as any);
      }
  
      /**
       * Set the date for schedule game publishing
       * @param body (optional) 
       * @return Success
       */
      setDateForScheduleGamePublishing(body: SetDateForScheduleGamePublishingRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/store/products/set-date-for-schedule-game-publishing";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetDateForScheduleGamePublishing(_response);
          });
      }
  
      protected processSetDateForScheduleGamePublishing(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Set the date for schedule game publishing
       * @param body (optional) 
       * @return Success
       */
      setDateForScheduleGamePublishing2(id: string, body: CreateProductStatementsToMonthRequest | undefined): Promise<AggregatedStatementInfo> {
          let url_ = this.baseUrl + "/admin/store/products/{id}/statements";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetDateForScheduleGamePublishing2(_response);
          });
      }
  
      protected processSetDateForScheduleGamePublishing2(response: Response): Promise<AggregatedStatementInfo> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AggregatedStatementInfo;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<AggregatedStatementInfo>(null as any);
      }
  
      /**
       * Redeem a Code
       * @param body (optional) 
       * @return Success
       */
      redemptionCodesForSubscription(body: RedeemRedemptionCodeRequest | undefined): Promise<RedeemRedemptionCodeResponse> {
          let url_ = this.baseUrl + "/subscriptions/redemption-codes/redeem";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRedemptionCodesForSubscription(_response);
          });
      }
  
      protected processRedemptionCodesForSubscription(response: Response): Promise<RedeemRedemptionCodeResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RedeemRedemptionCodeResponse;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<RedeemRedemptionCodeResponse>(null as any);
      }
  
      /**
       * get one by omni one serial number
       * @return Success
       */
      getSubscriptionRedemptionCodeByOmniOneSerialNumber(omniOneSerialNumber: string): Promise<SubscriptionRedemptionCode> {
          let url_ = this.baseUrl + "/subscriptions/redemption-codes/get-by-omni-one-serial-number/{omniOneSerialNumber}";
          if (omniOneSerialNumber === undefined || omniOneSerialNumber === null)
              throw new Error("The parameter 'omniOneSerialNumber' must be defined.");
          url_ = url_.replace("{omniOneSerialNumber}", encodeURIComponent("" + omniOneSerialNumber));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetSubscriptionRedemptionCodeByOmniOneSerialNumber(_response);
          });
      }
  
      protected processGetSubscriptionRedemptionCodeByOmniOneSerialNumber(response: Response): Promise<SubscriptionRedemptionCode> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionRedemptionCode;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionRedemptionCode>(null as any);
      }
  
      /**
       * get the available code and serial number for a user
       * @return Success
       */
      getForUser(): Promise<SubscriptionRedemptionCodeForHeadset> {
          let url_ = this.baseUrl + "/subscriptions/redemption-codes/get-for-user";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetForUser(_response);
          });
      }
  
      protected processGetForUser(response: Response): Promise<SubscriptionRedemptionCodeForHeadset> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionRedemptionCodeForHeadset;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionRedemptionCodeForHeadset>(null as any);
      }
  
      /**
       * Generate redemption codes by omni one serial number
       * @param body (optional) 
       * @return Success
       */
      createRedemptionCodesForSubscriptionByOmniOneSerialNumber(body: GenerateRedemptionCodesRequestByOmniOneSerialNumber | undefined): Promise<CreateRedeemRedemptionCodeResponse> {
          let url_ = this.baseUrl + "/subscriptions/redemption-codes/create-by-omni-one-serial-number";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateRedemptionCodesForSubscriptionByOmniOneSerialNumber(_response);
          });
      }
  
      protected processCreateRedemptionCodesForSubscriptionByOmniOneSerialNumber(response: Response): Promise<CreateRedeemRedemptionCodeResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateRedeemRedemptionCodeResponse;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<CreateRedeemRedemptionCodeResponse>(null as any);
      }
  
      /**
       * Checkt if users can redeem code
       * @param body (optional) 
       * @return Success
       */
      checkIfUserCanRedeemCode(body: RedeemRedemptionCodeRequest | undefined): Promise<SubscriptionRedemptionCode> {
          let url_ = this.baseUrl + "/subscriptions/redemption-codes/check-if-user-can-redeem-code";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCheckIfUserCanRedeemCode(_response);
          });
      }
  
      protected processCheckIfUserCanRedeemCode(response: Response): Promise<SubscriptionRedemptionCode> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionRedemptionCode;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionRedemptionCode>(null as any);
      }
  
      /**
       * Get subscription redemption codes
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getRedemptionCodesForSubscription(sortField: SubscriptionRedemptionCodeSortField | undefined, sortOrder: SortOrder | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<SubscriptionRedemptionCodeDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/subscriptions/redemption-codes?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetRedemptionCodesForSubscription(_response);
          });
      }
  
      protected processGetRedemptionCodesForSubscription(response: Response): Promise<SubscriptionRedemptionCodeDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionRedemptionCodeDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionRedemptionCodeDtoPagedResult>(null as any);
      }
  
      /**
       * Generate redemption codes
       * @param body (optional) 
       * @return Success
       */
      generateRedemptionCodesForSubscription(body: GenerateRedemptionCodesRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/subscriptions/redemption-codes";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGenerateRedemptionCodesForSubscription(_response);
          });
      }
  
      protected processGenerateRedemptionCodesForSubscription(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Delete redemption codes
       * @param ids (optional) 
       * @return Success
       */
      deleteRedemptionCodesForSubscription(ids: number[] | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/subscriptions/redemption-codes?";
          if (ids === null)
              throw new Error("The parameter 'ids' cannot be null.");
          else if (ids !== undefined)
              ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteRedemptionCodesForSubscription(_response);
          });
      }
  
      protected processDeleteRedemptionCodesForSubscription(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Export redemption codes for subscription
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param exportType (optional) 
       * @return Success
       */
      exportRedemptionCodesForSubscription(sortField: SubscriptionRedemptionCodeSortField | undefined, sortOrder: SortOrder | undefined, exportType: ExportType | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/admin/subscriptions/redemption-codes/export?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (exportType === null)
              throw new Error("The parameter 'exportType' cannot be null.");
          else if (exportType !== undefined)
              url_ += "ExportType=" + encodeURIComponent("" + exportType) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportRedemptionCodesForSubscription(_response);
          });
      }
  
      protected processExportRedemptionCodesForSubscription(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * initalize all of the two subscription plans, one for monthly and one for yearly. This is a one time operation
       * @return Success
       */
      initalizeAllPlans(): Promise<SubscriptionPlanDto[]> {
          let url_ = this.baseUrl + "/admin/subscriptions/plans/initialize";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processInitalizeAllPlans(_response);
          });
      }
  
      protected processInitalizeAllPlans(response: Response): Promise<SubscriptionPlanDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionPlanDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionPlanDto[]>(null as any);
      }
  
      /**
       * Returns all time subscription stats
       * @return Success
       */
      getOmniOnlineStatsAllTime(): Promise<OmniOnlineStatsAllTimeDto> {
          let url_ = this.baseUrl + "/admin/subscriptions/stats/alltime";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetOmniOnlineStatsAllTime(_response);
          });
      }
  
      protected processGetOmniOnlineStatsAllTime(response: Response): Promise<OmniOnlineStatsAllTimeDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OmniOnlineStatsAllTimeDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<OmniOnlineStatsAllTimeDto>(null as any);
      }
  
      /**
       * Returns subscription stats last 30 days
       * @return Success
       */
      getOmniOnlineStatsLast30Days(): Promise<OmniOnlineStatsDto[]> {
          let url_ = this.baseUrl + "/admin/subscriptions/stats/daily";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetOmniOnlineStatsLast30Days(_response);
          });
      }
  
      protected processGetOmniOnlineStatsLast30Days(response: Response): Promise<OmniOnlineStatsDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OmniOnlineStatsDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<OmniOnlineStatsDto[]>(null as any);
      }
  
      /**
       * Export subscription stats last 30 days
       * @param exportContent (optional) 
       * @return Success
       */
      exportOmniOnlineStatsLast30Days(exportContent: ExportProjection | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/admin/subscriptions/stats/daily/export?";
          if (exportContent === null)
              throw new Error("The parameter 'exportContent' cannot be null.");
          else if (exportContent !== undefined)
              url_ += "exportContent=" + encodeURIComponent("" + exportContent) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportOmniOnlineStatsLast30Days(_response);
          });
      }
  
      protected processExportOmniOnlineStatsLast30Days(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Returns subscription stats last 12 months
       * @return Success
       */
      getOmniOnlineStatsLast12Months(): Promise<OmniOnlineStatsDto[]> {
          let url_ = this.baseUrl + "/admin/subscriptions/stats/monthly";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetOmniOnlineStatsLast12Months(_response);
          });
      }
  
      protected processGetOmniOnlineStatsLast12Months(response: Response): Promise<OmniOnlineStatsDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OmniOnlineStatsDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<OmniOnlineStatsDto[]>(null as any);
      }
  
      /**
       * Export subscription stats last 12 months
       * @param exportContent (optional) 
       * @return Success
       */
      exportOmniOnlineStatsLast12Months(exportContent: ExportProjection | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/admin/subscriptions/stats/monthly/export?";
          if (exportContent === null)
              throw new Error("The parameter 'exportContent' cannot be null.");
          else if (exportContent !== undefined)
              url_ += "exportContent=" + encodeURIComponent("" + exportContent) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportOmniOnlineStatsLast12Months(_response);
          });
      }
  
      protected processExportOmniOnlineStatsLast12Months(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * lists all available subscription plans
       * @return Success
       */
      listAllPlans(): Promise<SubscriptionPlanDto[]> {
          let url_ = this.baseUrl + "/subscriptions/plans";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processListAllPlans(_response);
          });
      }
  
      protected processListAllPlans(response: Response): Promise<SubscriptionPlanDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionPlanDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionPlanDto[]>(null as any);
      }
  
      /**
       * get current user's subscription detail
       * @return Success
       */
      getCurrentUserSubscription(): Promise<SubscriptionDto> {
          let url_ = this.baseUrl + "/subscriptions";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetCurrentUserSubscription(_response);
          });
      }
  
      protected processGetCurrentUserSubscription(response: Response): Promise<SubscriptionDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionDto>(null as any);
      }
  
      /**
       * cancel current user's subscription at the end of current billing period
       * @return Success
       */
      cancelSubscription(): Promise<SubscriptionDto> {
          let url_ = this.baseUrl + "/subscriptions";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCancelSubscription(_response);
          });
      }
  
      protected processCancelSubscription(response: Response): Promise<SubscriptionDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionDto>(null as any);
      }
  
      /**
       * create a subscription payment intent
       * @param body (optional) 
       * @return Success
       */
      createSubscriptionPaymentIntent(body: CreatePaymentIntentCommand | undefined): Promise<StripePaymentIntentDto> {
          let url_ = this.baseUrl + "/subscriptions/payment-intent";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateSubscriptionPaymentIntent(_response);
          });
      }
  
      protected processCreateSubscriptionPaymentIntent(response: Response): Promise<StripePaymentIntentDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripePaymentIntentDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StripePaymentIntentDto>(null as any);
      }
  
      /**
       * set up subscription's automatic renewal
       * @param body (optional) 
       * @return Success
       */
      setupSubscriptionRenewal(body: SetupSubscriptionRenewalCommand | undefined): Promise<SubscriptionDto> {
          let url_ = this.baseUrl + "/subscriptions/setup-renewal";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetupSubscriptionRenewal(_response);
          });
      }
  
      protected processSetupSubscriptionRenewal(response: Response): Promise<SubscriptionDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionDto>(null as any);
      }
  
      /**
       * update user's subscription default payment method
       * @param body (optional) 
       * @return Success
       */
      updateSubscriptionDefaultPaymentmMethod(body: UpdateDefaultPaymentmMethodCommand | undefined): Promise<SubscriptionDto> {
          let url_ = this.baseUrl + "/subscriptions/default-payment-method";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateSubscriptionDefaultPaymentmMethod(_response);
          });
      }
  
      protected processUpdateSubscriptionDefaultPaymentmMethod(response: Response): Promise<SubscriptionDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionDto>(null as any);
      }
  
      /**
       * update user's subscription plan
       * @param body (optional) 
       * @return Success
       */
      updateSubscriptionPlan(body: UpdateSubscriptionPlanCommand | undefined): Promise<SubscriptionDto> {
          let url_ = this.baseUrl + "/subscriptions/subscription-plan";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateSubscriptionPlan(_response);
          });
      }
  
      protected processUpdateSubscriptionPlan(response: Response): Promise<SubscriptionDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionDto>(null as any);
      }
  
      /**
       * reactivate current subscription with a new plan before subscription expires
       * @param body (optional) 
       * @return Success
       */
      reactivateBeforeExpiration(body: ReactivateBeforeExpirationCommand | undefined): Promise<SubscriptionDto> {
          let url_ = this.baseUrl + "/subscriptions/reactivate";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processReactivateBeforeExpiration(_response);
          });
      }
  
      protected processReactivateBeforeExpiration(response: Response): Promise<SubscriptionDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionDto>(null as any);
      }
  
      /**
       * cancel current user's subscription
       * @return Success
       */
      cancelSubscriptionImmediately(): Promise<SubscriptionDto> {
          let url_ = this.baseUrl + "/subscriptions/immediately";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCancelSubscriptionImmediately(_response);
          });
      }
  
      protected processCancelSubscriptionImmediately(response: Response): Promise<SubscriptionDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionDto>(null as any);
      }
  
      /**
       * lists all available subscription plans
       * @return Success
       */
      listAllPlansV2(): Promise<SubscriptionPlans> {
          let url_ = this.baseUrl + "/subscriptions/v2/plans";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processListAllPlansV2(_response);
          });
      }
  
      protected processListAllPlansV2(response: Response): Promise<SubscriptionPlans> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionPlans;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionPlans>(null as any);
      }
  
      /**
       * get current user's subscription detail
       * @return Success
       */
      getCurrentUserSubscription2(): Promise<Subscription> {
          let url_ = this.baseUrl + "/subscriptions/v2";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetCurrentUserSubscription2(_response);
          });
      }
  
      protected processGetCurrentUserSubscription2(response: Response): Promise<Subscription> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subscription;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Subscription>(null as any);
      }
  
      /**
       * cancel current user's subscription at the end of current billing period
       * @return No Content
       */
      cancelSubscription2(): Promise<Subscription> {
          let url_ = this.baseUrl + "/subscriptions/v2";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCancelSubscription2(_response);
          });
      }
  
      protected processCancelSubscription2(response: Response): Promise<Subscription> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              let result204: any = null;
              result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subscription;
              return result204;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Subscription>(null as any);
      }
  
      /**
       * estimate the price of a subscription plan and renewal plan
       * @return Success
       */
      estimatePrice(planId: string, paymentMethodId: string): Promise<SubscriptionPriceResult> {
          let url_ = this.baseUrl + "/subscriptions/v2/estimate-price?";
          if (planId === undefined || planId === null)
              throw new Error("The parameter 'planId' must be defined and cannot be null.");
          else
              url_ += "PlanId=" + encodeURIComponent("" + planId) + "&";
          if (paymentMethodId === undefined || paymentMethodId === null)
              throw new Error("The parameter 'paymentMethodId' must be defined and cannot be null.");
          else
              url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processEstimatePrice(_response);
          });
      }
  
      protected processEstimatePrice(response: Response): Promise<SubscriptionPriceResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionPriceResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SubscriptionPriceResult>(null as any);
      }
  
      /**
       * purchase a subscription plan
       * @param body (optional) 
       * @return Success
       */
      purchase(body: CreatePaymentIntentCommand | undefined): Promise<StripePaymentIntentConfirmDto> {
          let url_ = this.baseUrl + "/subscriptions/v2/purchase";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processPurchase(_response);
          });
      }
  
      protected processPurchase(response: Response): Promise<StripePaymentIntentConfirmDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StripePaymentIntentConfirmDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<StripePaymentIntentConfirmDto>(null as any);
      }
  
      /**
       * set up subscription's automatic renewal
       * @param body (optional) 
       * @return No Content
       */
      setupSubscriptionRenewal2(body: SetupSubscriptionRenewalCommand | undefined): Promise<Subscription> {
          let url_ = this.baseUrl + "/subscriptions/v2/setup-renewal";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetupSubscriptionRenewal2(_response);
          });
      }
  
      protected processSetupSubscriptionRenewal2(response: Response): Promise<Subscription> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              let result204: any = null;
              result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subscription;
              return result204;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Subscription>(null as any);
      }
  
      /**
       * update user's subscription default payment method
       * @param body (optional) 
       * @return No Content
       */
      updateSubscriptionDefaultPaymentmMethod2(body: UpdateDefaultPaymentmMethodCommand | undefined): Promise<Subscription> {
          let url_ = this.baseUrl + "/subscriptions/v2/default-payment-method";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateSubscriptionDefaultPaymentmMethod2(_response);
          });
      }
  
      protected processUpdateSubscriptionDefaultPaymentmMethod2(response: Response): Promise<Subscription> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              let result204: any = null;
              result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subscription;
              return result204;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Subscription>(null as any);
      }
  
      /**
       * update user's subscription plan
       * @param body (optional) 
       * @return No Content
       */
      updateSubscriptionPlan2(body: UpdateSubscriptionPlanCommand | undefined): Promise<Subscription> {
          let url_ = this.baseUrl + "/subscriptions/v2/subscription-plan";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateSubscriptionPlan2(_response);
          });
      }
  
      protected processUpdateSubscriptionPlan2(response: Response): Promise<Subscription> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              let result204: any = null;
              result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subscription;
              return result204;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Subscription>(null as any);
      }
  
      /**
       * reactivate current subscription with a new plan before subscription expires
       * @param body (optional) 
       * @return No Content
       */
      reactivateBeforeExpiration2(body: ReactivateBeforeExpirationCommand | undefined): Promise<Subscription> {
          let url_ = this.baseUrl + "/subscriptions/v2/reactivate";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processReactivateBeforeExpiration2(_response);
          });
      }
  
      protected processReactivateBeforeExpiration2(response: Response): Promise<Subscription> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              let result204: any = null;
              result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subscription;
              return result204;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Subscription>(null as any);
      }
  
      /**
       * cancel current user's subscription
       * @return No Content
       */
      cancelSubscriptionImmediately2(): Promise<Subscription> {
          let url_ = this.baseUrl + "/subscriptions/v2/immediately";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCancelSubscriptionImmediately2(_response);
          });
      }
  
      protected processCancelSubscriptionImmediately2(response: Response): Promise<Subscription> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              let result204: any = null;
              result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subscription;
              return result204;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<Subscription>(null as any);
      }
  
      /**
       * Returns latest terms and conditions
       * @param plainText (optional) 
       * @return Success
       */
      getLatestTermsAndConditions(plainText: boolean | undefined): Promise<TermsAndConditionsDto> {
          let url_ = this.baseUrl + "/terms-and-conditions?";
          if (plainText === null)
              throw new Error("The parameter 'plainText' cannot be null.");
          else if (plainText !== undefined)
              url_ += "plainText=" + encodeURIComponent("" + plainText) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetLatestTermsAndConditions(_response);
          });
      }
  
      protected processGetLatestTermsAndConditions(response: Response): Promise<TermsAndConditionsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TermsAndConditionsDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<TermsAndConditionsDto>(null as any);
      }
  
      /**
       * Get all records of terms and conditions
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getAllTermsAndConditionsRecords(sortField: TermsAndConditionsRecordsSortField | undefined, sortOrder: SortOrder | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<TermsAndConditionsRecordsDtoPagedResult> {
          let url_ = this.baseUrl + "/terms-and-conditions/records?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAllTermsAndConditionsRecords(_response);
          });
      }
  
      protected processGetAllTermsAndConditionsRecords(response: Response): Promise<TermsAndConditionsRecordsDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TermsAndConditionsRecordsDtoPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<TermsAndConditionsRecordsDtoPagedResult>(null as any);
      }
  
      /**
       * Get terms and conditions by id
       * @return Success
       */
      getTermsAndConditionsById(id: number): Promise<TermsAndConditionsRecordsDto> {
          let url_ = this.baseUrl + "/terms-and-conditions/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetTermsAndConditionsById(_response);
          });
      }
  
      protected processGetTermsAndConditionsById(response: Response): Promise<TermsAndConditionsRecordsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TermsAndConditionsRecordsDto;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<TermsAndConditionsRecordsDto>(null as any);
      }
  
      /**
       * Get all user acceptance history
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @param version (optional) 
       * @param searchTerm (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getAllUserAcceptanceHistory(sortField: UserAcceptanceHistorySortField | undefined, sortOrder: SortOrder | undefined, version: string | undefined, searchTerm: string | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<UserAcceptanceHistoryDtoPagedResult> {
          let url_ = this.baseUrl + "/terms-and-conditions/user-acceptance-history?";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          if (version === null)
              throw new Error("The parameter 'version' cannot be null.");
          else if (version !== undefined)
              url_ += "Version=" + encodeURIComponent("" + version) + "&";
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAllUserAcceptanceHistory(_response);
          });
      }
  
      protected processGetAllUserAcceptanceHistory(response: Response): Promise<UserAcceptanceHistoryDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAcceptanceHistoryDtoPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserAcceptanceHistoryDtoPagedResult>(null as any);
      }
  
      /**
       * update terms and conditions
       * @param body (optional) 
       * @return No Content
       */
      updateTermsAndConditions(body: UpdateTermsAndConditionsRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/terms-and-conditions/update";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateTermsAndConditions(_response);
          });
      }
  
      protected processUpdateTermsAndConditions(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Accepts terms and conditions
       * @param version (optional) 
       * @return No Content
       */
      acceptTermsAndConditions(version: string | undefined): Promise<void> {
          let url_ = this.baseUrl + "/terms-and-conditions/accept?";
          if (version === null)
              throw new Error("The parameter 'version' cannot be null.");
          else if (version !== undefined)
              url_ += "version=" + encodeURIComponent("" + version) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAcceptTermsAndConditions(_response);
          });
      }
  
      protected processAcceptTermsAndConditions(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get project test users
       * @param projectId (optional) 
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      getProjectTestUsers(projectId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<TestUserDtoPagedResult> {
          let url_ = this.baseUrl + "/content-provider/test-users?";
          if (projectId === null)
              throw new Error("The parameter 'projectId' cannot be null.");
          else if (projectId !== undefined)
              url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetProjectTestUsers(_response);
          });
      }
  
      protected processGetProjectTestUsers(response: Response): Promise<TestUserDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestUserDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<TestUserDtoPagedResult>(null as any);
      }
  
      /**
       * Delete project test user
       * @return Success
       */
      deleteProjectTestUser(id: number, projectId: number): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/test-users/{projectId}/remove/{id}";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          if (projectId === undefined || projectId === null)
              throw new Error("The parameter 'projectId' must be defined.");
          url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDeleteProjectTestUser(_response);
          });
      }
  
      protected processDeleteProjectTestUser(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Invite project test users
       * @param body (optional) 
       * @return Success
       */
      inviteProjectTestUsers(body: InviteTestUserCommand | undefined): Promise<string[]> {
          let url_ = this.baseUrl + "/content-provider/test-users/invite";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processInviteProjectTestUsers(_response);
          });
      }
  
      protected processInviteProjectTestUsers(response: Response): Promise<string[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string[]>(null as any);
      }
  
      /**
       * Accept project invitation
       * @return Success
       */
      acceptTestInvitation(inviteId: number): Promise<void> {
          let url_ = this.baseUrl + "/content-provider/test-users/invite/{inviteId}/accept";
          if (inviteId === undefined || inviteId === null)
              throw new Error("The parameter 'inviteId' must be defined.");
          url_ = url_.replace("{inviteId}", encodeURIComponent("" + inviteId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAcceptTestInvitation(_response);
          });
      }
  
      protected processAcceptTestInvitation(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get treadmill summary information, including activated units in all time and last ninety days
       * @return Success
       */
      getTreadmillSummary(): Promise<TreadmillSummary> {
          let url_ = this.baseUrl + "/admin/treadmills/summary";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetTreadmillSummary(_response);
          });
      }
  
      protected processGetTreadmillSummary(response: Response): Promise<TreadmillSummary> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TreadmillSummary;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<TreadmillSummary>(null as any);
      }
  
      /**
       * Upload steps threshold spreadsheet for treadmill
       * @param body (optional) 
       * @return Success
       */
      uploadStepsThresholdSpreadsheet(body: UploadStepsThreshold | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/treadmills/safety-shutoff";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUploadStepsThresholdSpreadsheet(_response);
          });
      }
  
      protected processUploadStepsThresholdSpreadsheet(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Gets safety shutoff table
       * @param pageNum (optional) 
       * @param pageSize (optional) 
       * @param sortOrder (optional) 
       * @return Success
       */
      getSafetyShutoffTable(pageNum: number | undefined, pageSize: number | undefined, sortOrder: SortOrder | undefined): Promise<TreadmillThresholdDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/treadmills/safety-shutoff?";
          if (pageNum === null)
              throw new Error("The parameter 'pageNum' cannot be null.");
          else if (pageNum !== undefined)
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetSafetyShutoffTable(_response);
          });
      }
  
      protected processGetSafetyShutoffTable(response: Response): Promise<TreadmillThresholdDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TreadmillThresholdDtoPagedResult;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<TreadmillThresholdDtoPagedResult>(null as any);
      }
  
      /**
       * Get user audits
       * @param searchTerm (optional) 
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @return Success
       */
      getUserAudits(pageNumber: number, pageSize: number, includedActions: UserAuditAction[], searchTerm: string | undefined, sortField: QueryUserAuditSortField | undefined, sortOrder: SortOrder | undefined): Promise<UserAuditListItemDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/user-audit-logs?";
          if (pageNumber === undefined || pageNumber === null)
              throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
          else
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (includedActions === undefined || includedActions === null)
              throw new Error("The parameter 'includedActions' must be defined and cannot be null.");
          else
              includedActions && includedActions.forEach(item => { url_ += "IncludedActions=" + encodeURIComponent("" + item) + "&"; });
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserAudits(_response);
          });
      }
  
      protected processGetUserAudits(response: Response): Promise<UserAuditListItemDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAuditListItemDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserAuditListItemDtoPagedResult>(null as any);
      }
  
      /**
       * Export user audits
       * @param searchTerm (optional) 
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @return Success
       */
      exportUserAudits(includedActions: UserAuditAction[], searchTerm: string | undefined, sortField: QueryUserAuditSortField | undefined, sortOrder: SortOrder | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/admin/user-audit-logs/export?";
          if (includedActions === undefined || includedActions === null)
              throw new Error("The parameter 'includedActions' must be defined and cannot be null.");
          else
              includedActions && includedActions.forEach(item => { url_ += "IncludedActions=" + encodeURIComponent("" + item) + "&"; });
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportUserAudits(_response);
          });
      }
  
      protected processExportUserAudits(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Update a users progress for a game stat
       * @param body (optional) 
       * @return Success
       */
      updateUserGameStat(body: UpdateUserGameStatRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/user-game-stats";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateUserGameStat(_response);
          });
      }
  
      protected processUpdateUserGameStat(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Update a users progress for a many game stats
       * @param body (optional) 
       * @return Success
       */
      updateUserGameStats(body: UpdateUserGameStatsRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/user-game-stats/batch-update";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateUserGameStats(_response);
          });
      }
  
      protected processUpdateUserGameStats(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * get a users progress for a game stat
       * @return Success
       */
      getUserGameStat(productId: string, apiName: string, releaseChannel: ReleaseChannel, hasServerRole: boolean): Promise<UserGameStatDto> {
          let url_ = this.baseUrl + "/user-game-stats/{productId}/{apiName}/{releaseChannel}";
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{ProductId}", encodeURIComponent("" + productId));
          if (apiName === undefined || apiName === null)
              throw new Error("The parameter 'apiName' must be defined.");
          url_ = url_.replace("{ApiName}", encodeURIComponent("" + apiName));
          if (releaseChannel === undefined || releaseChannel === null)
              throw new Error("The parameter 'releaseChannel' must be defined.");
          url_ = url_.replace("{ReleaseChannel}", encodeURIComponent("" + releaseChannel));
          if (hasServerRole === undefined || hasServerRole === null)
              throw new Error("The parameter 'hasServerRole' must be defined.");
          url_ = url_.replace("{HasServerRole}", encodeURIComponent("" + hasServerRole));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserGameStat(_response);
          });
      }
  
      protected processGetUserGameStat(response: Response): Promise<UserGameStatDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGameStatDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserGameStatDto>(null as any);
      }
  
      /**
       * Sync headset basic information with user linked
       * @param body (optional) 
       * @return No Content
       */
      syncHeadsetInfomation(body: SyncHeadsetInfomationRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/users/headset";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSyncHeadsetInfomation(_response);
          });
      }
  
      protected processSyncHeadsetInfomation(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get headset basic information by user id
       * @return Success
       */
      getHeadsetInfomation(): Promise<HeadsetInfomationDto> {
          let url_ = this.baseUrl + "/users/headset";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHeadsetInfomation(_response);
          });
      }
  
      protected processGetHeadsetInfomation(response: Response): Promise<HeadsetInfomationDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HeadsetInfomationDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<HeadsetInfomationDto>(null as any);
      }
  
      /**
       * Returns paginated users table
       * @param searchTerm (optional) 
       * @return Success
       */
      getAllUsers(pageNum: number, pageSize: number, searchTerm: string | undefined, sortField: UserSortField, sortOrder: SortOrder): Promise<UserManagementUserListItemDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/users?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAllUsers(_response);
          });
      }
  
      protected processGetAllUsers(response: Response): Promise<UserManagementUserListItemDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserManagementUserListItemDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserManagementUserListItemDtoPagedResult>(null as any);
      }
  
      /**
       * Returns paginated developers table
       * @param searchTerm (optional) 
       * @return Success
       */
      getAllDevelopers(pageNum: number, pageSize: number, searchTerm: string | undefined, sortField: DeveloperSortField, sortOrder: AuthZeroSortOrder): Promise<UserManagementDeveloperListItemDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/users/developers?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetAllDevelopers(_response);
          });
      }
  
      protected processGetAllDevelopers(response: Response): Promise<UserManagementDeveloperListItemDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserManagementDeveloperListItemDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserManagementDeveloperListItemDtoPagedResult>(null as any);
      }
  
      /**
       * @return Success
       */
      getUser(userId: string): Promise<UserDto> {
          let url_ = this.baseUrl + "/admin/users/{userId}";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUser(_response);
          });
      }
  
      protected processGetUser(response: Response): Promise<UserDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserDto>(null as any);
      }
  
      /**
       * Updates user details
       * @param body (optional) 
       * @return No Content
       */
      updateUserDetails(userId: string, body: UpdateUserCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/{userId}";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateUserDetails(_response);
          });
      }
  
      protected processUpdateUserDetails(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * @return No Content
       */
      delete2(userId: string): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/{userId}";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "DELETE",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDelete2(_response);
          });
      }
  
      protected processDelete2(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get User extended profile
       * @return Success
       */
      getUserExtendedProfile(userId: string): Promise<ExtendedProfileDto> {
          let url_ = this.baseUrl + "/admin/users/{userId}/extended";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserExtendedProfile(_response);
          });
      }
  
      protected processGetUserExtendedProfile(response: Response): Promise<ExtendedProfileDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendedProfileDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ExtendedProfileDto>(null as any);
      }
  
      /**
       * Allows admin to reset user password
       * @return No Content
       */
      userManagementResetPassword(userId: string): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/{userId}/password";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "PUT",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUserManagementResetPassword(_response);
          });
      }
  
      protected processUserManagementResetPassword(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Returns all acquired products for specific user
       * @return Success
       */
      getUserProductsForAdmin(userId: string, pageNum: number, pageSize: number, sortField: ProductBuildListSortField, sortOrder: SortOrder): Promise<ProductBuildListItemDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/users/{userId}/products?";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "pageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserProductsForAdmin(_response);
          });
      }
  
      protected processGetUserProductsForAdmin(response: Response): Promise<ProductBuildListItemDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductBuildListItemDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductBuildListItemDtoPagedResult>(null as any);
      }
  
      /**
       * Returns user orders
       * @return Success
       */
      getUserManagementUserOrders(userId: string, sortField: OrderSortField, sortOrder: SortOrder): Promise<UserManagementUserOrderListItemDto[]> {
          let url_ = this.baseUrl + "/admin/users/{userId}/orders?";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          if (sortField === undefined || sortField === null)
              throw new Error("The parameter 'sortField' must be defined and cannot be null.");
          else
              url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === undefined || sortOrder === null)
              throw new Error("The parameter 'sortOrder' must be defined and cannot be null.");
          else
              url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserManagementUserOrders(_response);
          });
      }
  
      protected processGetUserManagementUserOrders(response: Response): Promise<UserManagementUserOrderListItemDto[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserManagementUserOrderListItemDto[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserManagementUserOrderListItemDto[]>(null as any);
      }
  
      /**
       * Remove user product
       * @param body (optional) 
       * @return No Content
       */
      removeUserProduct(userId: string, productId: string, body: RemoveUserProductCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/{userId}/remove-product/{productId}";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRemoveUserProduct(_response);
          });
      }
  
      protected processRemoveUserProduct(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Admin can assign a product to a user library
       * @param body (optional) 
       * @return No Content
       */
      assignProductToUserLibrary(userId: string, productId: string, body: AddUserProductCommandCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/{userId}/assign-product/{productId}";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          if (productId === undefined || productId === null)
              throw new Error("The parameter 'productId' must be defined.");
          url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAssignProductToUserLibrary(_response);
          });
      }
  
      protected processAssignProductToUserLibrary(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Export users list
       * @param body (optional) 
       * @return Success
       */
      exportUsers(body: ExportUsersCommand | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/admin/users/export";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportUsers(_response);
          });
      }
  
      protected processExportUsers(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Export developers list
       * @param body (optional) 
       * @return Success
       */
      exportDevelopers(body: ExportDevelopersCommand | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/admin/users/developers/export";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportDevelopers(_response);
          });
      }
  
      protected processExportDevelopers(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Returns user daily gameplay minutes last 30 days
       * @return Success
       */
      getUserDailyGameplayMins(userId: string): Promise<UserGameplayMinutes[]> {
          let url_ = this.baseUrl + "/admin/users/{userId}/gameplay_mins_daily";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserDailyGameplayMins(_response);
          });
      }
  
      protected processGetUserDailyGameplayMins(response: Response): Promise<UserGameplayMinutes[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGameplayMinutes[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserGameplayMinutes[]>(null as any);
      }
  
      /**
       * Returns user monthly gameplay minutes last 12 months
       * @return Success
       */
      getUserMonthlyGameplayMins(userId: string): Promise<UserGameplayMinutes[]> {
          let url_ = this.baseUrl + "/admin/users/{userId}/gameplay_mins_monthly";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserMonthlyGameplayMins(_response);
          });
      }
  
      protected processGetUserMonthlyGameplayMins(response: Response): Promise<UserGameplayMinutes[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGameplayMinutes[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserGameplayMinutes[]>(null as any);
      }
  
      /**
       * health statistics for the passed in user
       * @return Success
       */
      getUserHealthStatisticsForAdmin(userId: string): Promise<UserHealthStatisticsDto> {
          let url_ = this.baseUrl + "/admin/users/{userId}/user-health-statistics";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserHealthStatisticsForAdmin(_response);
          });
      }
  
      protected processGetUserHealthStatisticsForAdmin(response: Response): Promise<UserHealthStatisticsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserHealthStatisticsDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserHealthStatisticsDto>(null as any);
      }
  
      /**
       * Admin can warn a user by sending a warning email
       * @param body (optional) 
       * @return No Content
       */
      warnUser(userId: string, body: UserActionRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/{userId}/warn";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processWarnUser(_response);
          });
      }
  
      protected processWarnUser(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Admin can inactivate a player's subscription for a period of time
       * @param body (optional) 
       * @return No Content
       */
      suspendUser(userId: string, body: UserActionRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/{userId}/suspend";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSuspendUser(_response);
          });
      }
  
      protected processSuspendUser(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Admin can inactivate a player's subscription permanently
       * @param body (optional) 
       * @return No Content
       */
      banUser(userId: string, body: UserActionRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/{userId}/ban";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processBanUser(_response);
          });
      }
  
      protected processBanUser(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Admin can unsuspend a suspended user
       * @param body (optional) 
       * @return No Content
       */
      unsuspendUser(userId: string, body: UserActionRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/{userId}/unsuspend";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUnsuspendUser(_response);
          });
      }
  
      protected processUnsuspendUser(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Admin can unban a banned user
       * @param body (optional) 
       * @return No Content
       */
      unbanUser(userId: string, body: UserActionRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/{userId}/unban";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUnbanUser(_response);
          });
      }
  
      protected processUnbanUser(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Refreshes the omni online status for all users
       * @return No Content
       */
      refreshOmniOnlineStatus(): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/omni-online/refresh";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "PUT",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRefreshOmniOnlineStatus(_response);
          });
      }
  
      protected processRefreshOmniOnlineStatus(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Syncs all users first name, last name and email from Auth0. This is a one time operation.
       * @return No Content
       */
      syncEmailAndNames(): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/sync-email-and-names";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "PUT",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSyncEmailAndNames(_response);
          });
      }
  
      protected processSyncEmailAndNames(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * @return No Content
       */
      assignProductsFromShopify(): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/assign-products-from-shopify";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAssignProductsFromShopify(_response);
          });
      }
  
      protected processAssignProductsFromShopify(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * @param body (optional) 
       * @return No Content
       */
      assignProductFromShopify(body: AssignProductFromShopifyCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/assign-product-from-shopify";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAssignProductFromShopify(_response);
          });
      }
  
      protected processAssignProductFromShopify(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Returns all user tags
       * @return Success
       */
      getUserTags(): Promise<string[]> {
          let url_ = this.baseUrl + "/admin/users/tags";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserTags(_response);
          });
      }
  
      protected processGetUserTags(response: Response): Promise<string[]> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string[]>(null as any);
      }
  
      /**
       * Sets user tags
       * @param body (optional) 
       * @return No Content
       */
      setUserTags(userId: string, body: string[] | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/users/{userId}/tags";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetUserTags(_response);
          });
      }
  
      protected processSetUserTags(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 400) {
              return response.text().then((_responseText) => {
              let result400: any = null;
              result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Bad Request", status, _responseText, _headers, result400);
              });
          } else if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Submit a user report
       * @param body (optional) 
       * @return No Content
       */
      createUserReport(body: CreateUserReportRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/user-reports";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateUserReport(_response);
          });
      }
  
      protected processCreateUserReport(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get user reports
       * @param reportedUserId (optional) 
       * @param searchTerm (optional) 
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @return Success
       */
      getUserReports(pageNumber: number, pageSize: number, includedStatus: UserReportStatus[], reportedUserId: string | undefined, searchTerm: string | undefined, sortField: QueryUserReportSortField | undefined, sortOrder: SortOrder | undefined): Promise<UserReportListItemDtoPagedResult> {
          let url_ = this.baseUrl + "/admin/user-reports?";
          if (pageNumber === undefined || pageNumber === null)
              throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
          else
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (includedStatus === undefined || includedStatus === null)
              throw new Error("The parameter 'includedStatus' must be defined and cannot be null.");
          else
              includedStatus && includedStatus.forEach(item => { url_ += "IncludedStatus=" + encodeURIComponent("" + item) + "&"; });
          if (reportedUserId === null)
              throw new Error("The parameter 'reportedUserId' cannot be null.");
          else if (reportedUserId !== undefined)
              url_ += "ReportedUserId=" + encodeURIComponent("" + reportedUserId) + "&";
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetUserReports(_response);
          });
      }
  
      protected processGetUserReports(response: Response): Promise<UserReportListItemDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserReportListItemDtoPagedResult;
              return result200;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserReportListItemDtoPagedResult>(null as any);
      }
  
      /**
       * Export user reports
       * @param reportedUserId (optional) 
       * @param searchTerm (optional) 
       * @param sortField (optional) 
       * @param sortOrder (optional) 
       * @return Success
       */
      exportUserReports(includedStatus: UserReportStatus[], reportedUserId: string | undefined, searchTerm: string | undefined, sortField: QueryUserReportSortField | undefined, sortOrder: SortOrder | undefined): Promise<FileResponse> {
          let url_ = this.baseUrl + "/admin/user-reports/export?";
          if (includedStatus === undefined || includedStatus === null)
              throw new Error("The parameter 'includedStatus' must be defined and cannot be null.");
          else
              includedStatus && includedStatus.forEach(item => { url_ += "IncludedStatus=" + encodeURIComponent("" + item) + "&"; });
          if (reportedUserId === null)
              throw new Error("The parameter 'reportedUserId' cannot be null.");
          else if (reportedUserId !== undefined)
              url_ += "ReportedUserId=" + encodeURIComponent("" + reportedUserId) + "&";
          if (searchTerm === null)
              throw new Error("The parameter 'searchTerm' cannot be null.");
          else if (searchTerm !== undefined)
              url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
          if (sortField === null)
              throw new Error("The parameter 'sortField' cannot be null.");
          else if (sortField !== undefined)
              url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
          if (sortOrder === null)
              throw new Error("The parameter 'sortOrder' cannot be null.");
          else if (sortOrder !== undefined)
              url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processExportUserReports(_response);
          });
      }
  
      protected processExportUserReports(response: Response): Promise<FileResponse> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200 || status === 206) {
              const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
              let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
              let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
              if (fileName) {
                  fileName = decodeURIComponent(fileName);
              } else {
                  fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                  fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
              }
              return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<FileResponse>(null as any);
      }
  
      /**
       * Dismiss user report
       * @param body (optional) 
       * @return No Content
       */
      dismiss(id: number, body: UseReportActionRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/user-reports/{id}/dismiss";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processDismiss(_response);
          });
      }
  
      protected processDismiss(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Admin can warn player by sending an email and update report status
       * @param body (optional) 
       * @return No Content
       */
      warn(id: number, body: UseReportActionRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/user-reports/{id}/warn";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processWarn(_response);
          });
      }
  
      protected processWarn(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Admin can inactivate a player's subscription for a period of time
       * @param body (optional) 
       * @return No Content
       */
      suspend(id: number, body: UseReportActionRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/user-reports/{id}/suspend";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSuspend(_response);
          });
      }
  
      protected processSuspend(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Admin can inactivate a player's subscription permanently
       * @param body (optional) 
       * @return No Content
       */
      ban(id: number, body: UseReportActionRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/admin/user-reports/{id}/ban";
          if (id === undefined || id === null)
              throw new Error("The parameter 'id' must be defined.");
          url_ = url_.replace("{id}", encodeURIComponent("" + id));
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processBan(_response);
          });
      }
  
      protected processBan(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Sync treadmill basic information with user linked
       * @param body (optional) 
       * @return No Content
       */
      syncTreadmillInfomation(body: SyncTreadmillInfomationRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/users/treadmill";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSyncTreadmillInfomation(_response);
          });
      }
  
      protected processSyncTreadmillInfomation(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status === 422) {
              return response.text().then((_responseText) => {
              let result422: any = null;
              result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResult;
              return throwException("Client Error", status, _responseText, _headers, result422);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get treadmill basic information by user id
       * @return Success
       */
      getTreadmillInfomation(): Promise<TreadmillInfomationDto> {
          let url_ = this.baseUrl + "/users/treadmill";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetTreadmillInfomation(_response);
          });
      }
  
      protected processGetTreadmillInfomation(response: Response): Promise<TreadmillInfomationDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TreadmillInfomationDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<TreadmillInfomationDto>(null as any);
      }
  
      /**
       * Get treadmill health check by treadmill id
       * @param id (optional) 
       * @return Success
       */
      getTreadmillHealthCheck(id: string | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/users/treadmill/is-healthy?";
          if (id === null)
              throw new Error("The parameter 'id' cannot be null.");
          else if (id !== undefined)
              url_ += "id=" + encodeURIComponent("" + id) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetTreadmillHealthCheck(_response);
          });
      }
  
      protected processGetTreadmillHealthCheck(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Recently played games for the provided user id
       * @param pageNumber (optional) 
       * @param pageSize (optional) 
       * @return Success
       */
      recentlyPlayed(userId: string, pageNumber: number | undefined, pageSize: number | undefined): Promise<RecentlyPlayedDtoPagedResult> {
          let url_ = this.baseUrl + "/users/{userId}/recently-played?";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          if (pageNumber === null)
              throw new Error("The parameter 'pageNumber' cannot be null.");
          else if (pageNumber !== undefined)
              url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
          if (pageSize === null)
              throw new Error("The parameter 'pageSize' cannot be null.");
          else if (pageSize !== undefined)
              url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processRecentlyPlayed(_response);
          });
      }
  
      protected processRecentlyPlayed(response: Response): Promise<RecentlyPlayedDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecentlyPlayedDtoPagedResult;
              return result200;
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<RecentlyPlayedDtoPagedResult>(null as any);
      }
  
      /**
       * Extended profile for the provided user id
       * @return Success
       */
      profile(profileUserId: string): Promise<ExtendedProfileDto> {
          let url_ = this.baseUrl + "/users/{profileUserId}/profile";
          if (profileUserId === undefined || profileUserId === null)
              throw new Error("The parameter 'profileUserId' must be defined.");
          url_ = url_.replace("{profileUserId}", encodeURIComponent("" + profileUserId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processProfile(_response);
          });
      }
  
      protected processProfile(response: Response): Promise<ExtendedProfileDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendedProfileDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ExtendedProfileDto>(null as any);
      }
  
      /**
       * Limited user profile information for the provided user id
       * @return Success
       */
      simpleProfile(profileUserId: string): Promise<SimpleProfileDto> {
          let url_ = this.baseUrl + "/users/{profileUserId}/data";
          if (profileUserId === undefined || profileUserId === null)
              throw new Error("The parameter 'profileUserId' must be defined.");
          url_ = url_.replace("{profileUserId}", encodeURIComponent("" + profileUserId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSimpleProfile(_response);
          });
      }
  
      protected processSimpleProfile(response: Response): Promise<SimpleProfileDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleProfileDto;
              return result200;
              });
          } else if (status === 404) {
              return response.text().then((_responseText) => {
              let result404: any = null;
              result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Not Found", status, _responseText, _headers, result404);
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<SimpleProfileDto>(null as any);
      }
  
      /**
       * health statistics for the passed in user
       * @param utcOffsetMinutes (optional) 
       * @return Success
       */
      userHealthStatistics4(userId: string, utcOffsetMinutes: number | undefined): Promise<UserHealthStatisticsDto> {
          let url_ = this.baseUrl + "/users/{userId}/user-health-statistics?";
          if (userId === undefined || userId === null)
              throw new Error("The parameter 'userId' must be defined.");
          url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
          if (utcOffsetMinutes === null)
              throw new Error("The parameter 'utcOffsetMinutes' cannot be null.");
          else if (utcOffsetMinutes !== undefined)
              url_ += "utcOffsetMinutes=" + encodeURIComponent("" + utcOffsetMinutes) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUserHealthStatistics4(_response);
          });
      }
  
      protected processUserHealthStatistics4(response: Response): Promise<UserHealthStatisticsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserHealthStatisticsDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<UserHealthStatisticsDto>(null as any);
      }
  
      /**
       * Privacy visibilities for the provided user id
       * @return Success
       */
      privacyVisibilities(profileUserId: string): Promise<PrivacyVisibilitiesDto> {
          let url_ = this.baseUrl + "/users/{profileUserId}/privacy-visibilities";
          if (profileUserId === undefined || profileUserId === null)
              throw new Error("The parameter 'profileUserId' must be defined.");
          url_ = url_.replace("{profileUserId}", encodeURIComponent("" + profileUserId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processPrivacyVisibilities(_response);
          });
      }
  
      protected processPrivacyVisibilities(response: Response): Promise<PrivacyVisibilitiesDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrivacyVisibilitiesDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<PrivacyVisibilitiesDto>(null as any);
      }
  
      /**
       * Privacy settings for the provided user id
       * @return Success
       */
      settings(profileUserId: string): Promise<PrivacySettingsDto> {
          let url_ = this.baseUrl + "/users/{profileUserId}/privacy-settings";
          if (profileUserId === undefined || profileUserId === null)
              throw new Error("The parameter 'profileUserId' must be defined.");
          url_ = url_.replace("{profileUserId}", encodeURIComponent("" + profileUserId));
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSettings(_response);
          });
      }
  
      protected processSettings(response: Response): Promise<PrivacySettingsDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrivacySettingsDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<PrivacySettingsDto>(null as any);
      }
  
      /**
       * Sets weight for user
       * @param weight (optional) 
       * @return Success
       */
      setWeight(weight: number | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/users/weight?";
          if (weight === null)
              throw new Error("The parameter 'weight' cannot be null.");
          else if (weight !== undefined)
              url_ += "weight=" + encodeURIComponent("" + weight) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetWeight(_response);
          });
      }
  
      protected processSetWeight(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Gets weight for user
       * @return Success
       */
      getWeight(): Promise<number> {
          let url_ = this.baseUrl + "/users/weight";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetWeight(_response);
          });
      }
  
      protected processGetWeight(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Sets ready player me avatar id for user
       * @param readyPlayerMeAvatarId (optional) 
       * @return Success
       */
      setReadyPlayerMeAvatarId(readyPlayerMeAvatarId: string | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/users/ready-player-me-avatar-id?";
          if (readyPlayerMeAvatarId === null)
              throw new Error("The parameter 'readyPlayerMeAvatarId' cannot be null.");
          else if (readyPlayerMeAvatarId !== undefined)
              url_ += "readyPlayerMeAvatarId=" + encodeURIComponent("" + readyPlayerMeAvatarId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetReadyPlayerMeAvatarId(_response);
          });
      }
  
      protected processSetReadyPlayerMeAvatarId(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Sets online visibility status setting for user
       * @param body (optional) 
       * @return Success
       */
      setShowOffline(body: ShowOfflineRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/users/show-offline";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetShowOffline(_response);
          });
      }
  
      protected processSetShowOffline(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Gets status setting for user
       * @return Success
       */
      getShowOffline(): Promise<boolean> {
          let url_ = this.baseUrl + "/users/show-offline";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetShowOffline(_response);
          });
      }
  
      protected processGetShowOffline(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Sets the do not disturb status setting for user
       * @param body (optional) 
       * @return Success
       */
      setDoNotDisturb(body: DoNotDisturbRequest | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/users/do-not-disturb";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetDoNotDisturb(_response);
          });
      }
  
      protected processSetDoNotDisturb(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Gets status setting for user
       * @return Success
       */
      getDoNotDisturb(): Promise<boolean> {
          let url_ = this.baseUrl + "/users/do-not-disturb";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetDoNotDisturb(_response);
          });
      }
  
      protected processGetDoNotDisturb(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Get mobile FTUE state for a user
       * @return Success
       */
      getFTUEState(): Promise<string> {
          let url_ = this.baseUrl + "/users/ftue-state";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetFTUEState(_response);
          });
      }
  
      protected processGetFTUEState(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Set mobile FTUE state for a user
       * @param body (optional) 
       * @return Success
       */
      setFTUEState(body: string | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/users/ftue-state";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetFTUEState(_response);
          });
      }
  
      protected processSetFTUEState(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Get headset FTUE complete for a user
       * @return Success
       */
      getHeadsetFTUEComplete(): Promise<boolean> {
          let url_ = this.baseUrl + "/users/headset-ftue-complete";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetHeadsetFTUEComplete(_response);
          });
      }
  
      protected processGetHeadsetFTUEComplete(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Set headset FTUE  complete for a user
       * @return No Content
       */
      setHeadsetFTUEComplete(): Promise<void> {
          let url_ = this.baseUrl + "/users/set-headset-ftue-complete";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "PUT",
              headers: {
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetHeadsetFTUEComplete(_response);
          });
      }
  
      protected processSetHeadsetFTUEComplete(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Get FTUE serial number for a user
       * @return Success
       */
      getFTUESerialNumber(): Promise<string> {
          let url_ = this.baseUrl + "/users/ftue-serial-number";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetFTUESerialNumber(_response);
          });
      }
  
      protected processGetFTUESerialNumber(response: Response): Promise<string> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<string>(null as any);
      }
  
      /**
       * Set FTUE serial number for a user
       * @param body (optional) 
       * @return Success
       */
      setFTUESerialNumber(body: string | undefined): Promise<boolean> {
          let url_ = this.baseUrl + "/users/ftue-serial-number";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetFTUESerialNumber(_response);
          });
      }
  
      protected processSetFTUESerialNumber(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Acknowledge safety warning for a user
       * @return Success
       */
      acknowledgeSatefyWarning(): Promise<boolean> {
          let url_ = this.baseUrl + "/users/ftue-acknowledge-safety-warning";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAcknowledgeSatefyWarning(_response);
          });
      }
  
      protected processAcknowledgeSatefyWarning(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Check if users claimed the Omni One Online trial in FTUE flow
       * @return Success
       */
      getFTUEOmniOnlineTrialClaimed(): Promise<boolean> {
          let url_ = this.baseUrl + "/users/ftue-omni-online-trial-claimed";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetFTUEOmniOnlineTrialClaimed(_response);
          });
      }
  
      protected processGetFTUEOmniOnlineTrialClaimed(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Set true for a user when they claimed the trial in FTUE flow
       * @return Success
       */
      setFTUEOmniOnlineTrialClaimed(): Promise<boolean> {
          let url_ = this.baseUrl + "/users/ftue-omni-online-trial-claimed";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "POST",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processSetFTUEOmniOnlineTrialClaimed(_response);
          });
      }
  
      protected processSetFTUEOmniOnlineTrialClaimed(response: Response): Promise<boolean> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<boolean>(null as any);
      }
  
      /**
       * Update the headset device ID as the user's most recent login device
       * @param body (optional) 
       * @return No Content
       */
      updateLastLoginHeadsetId(body: UpdateLastLoginHeadsetIdRequest | undefined): Promise<void> {
          let url_ = this.baseUrl + "/users/last-login-headset-id";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processUpdateLastLoginHeadsetId(_response);
          });
      }
  
      protected processUpdateLastLoginHeadsetId(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Returns all acquired products for user
       * @param userId (optional) 
       * @return Success
       */
      getPlayerProducts(pageNum: number, pageSize: number, userId: string | undefined): Promise<ProductBuildListItemDtoPagedResult> {
          let url_ = this.baseUrl + "/users/products?";
          if (pageNum === undefined || pageNum === null)
              throw new Error("The parameter 'pageNum' must be defined and cannot be null.");
          else
              url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
          if (pageSize === undefined || pageSize === null)
              throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
          else
              url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
          if (userId === null)
              throw new Error("The parameter 'userId' cannot be null.");
          else if (userId !== undefined)
              url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGetPlayerProducts(_response);
          });
      }
  
      protected processGetPlayerProducts(response: Response): Promise<ProductBuildListItemDtoPagedResult> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductBuildListItemDtoPagedResult;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<ProductBuildListItemDtoPagedResult>(null as any);
      }
  
      /**
       * Game installed notification
       * @param body (optional) 
       * @return Success
       */
      gameInstalledNotify(body: ChangeUserProductStateCommand | undefined): Promise<void> {
          let url_ = this.baseUrl + "/users/products/installed";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processGameInstalledNotify(_response);
          });
      }
  
      protected processGameInstalledNotify(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Create a VR Session for the logged in user
       * @param body (optional) 
       * @return No Content
       */
      createVRSession(body: VrSessionInput | undefined): Promise<void> {
          let url_ = this.baseUrl + "/vr-sessions";
          url_ = url_.replace(/[?&]$/, "");
  
          const content_ = JSON.stringify(body);
  
          let options_: RequestInit = {
              body: content_,
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processCreateVRSession(_response);
          });
      }
  
      protected processCreateVRSession(response: Response): Promise<void> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 204) {
              return response.text().then((_responseText) => {
              return;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<void>(null as any);
      }
  
      /**
       * Number of total seconds played for launcher all time
       * @return Success
       */
      totalAllTimeSecondsForLauncher(): Promise<number> {
          let url_ = this.baseUrl + "/vr-sessions/total-all-time-seconds-for-launcher";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalAllTimeSecondsForLauncher(_response);
          });
      }
  
      protected processTotalAllTimeSecondsForLauncher(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Number of total sessions played for launcher all time
       * @return Success
       */
      totalAllTimeSessionsForLauncher(): Promise<number> {
          let url_ = this.baseUrl + "/vr-sessions/total-all-time-sessions-for-launcher";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processTotalAllTimeSessionsForLauncher(_response);
          });
      }
  
      protected processTotalAllTimeSessionsForLauncher(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Number of average seconds played for launcher all time
       * @return Success
       */
      averageAllTimeSecondsForLauncher(): Promise<number> {
          let url_ = this.baseUrl + "/vr-sessions/average-all-time-seconds-for-launcher";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processAverageAllTimeSecondsForLauncher(_response);
          });
      }
  
      protected processAverageAllTimeSecondsForLauncher(response: Response): Promise<number> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<number>(null as any);
      }
  
      /**
       * Returns the members of the party the logged in user is a member of, including the status (Member = 0, Leader = 1, Pending = 2)
       * @return Success
       */
      partyMembersWithoutIdv2(): Promise<PartyDto> {
          let url_ = this.baseUrl + "/party/v2/members";
          url_ = url_.replace(/[?&]$/, "");
  
          let options_: RequestInit = {
              method: "GET",
              headers: {
                  "Accept": "application/json"
              }
          };
  
          return this.http.fetch(url_, options_).then((_response: Response) => {
              return this.processPartyMembersWithoutIdv2(_response);
          });
      }
  
      protected processPartyMembersWithoutIdv2(response: Response): Promise<PartyDto> {
          const status = response.status;
          let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
          if (status === 401) {
              return response.text().then((_responseText) => {
              let result401: any = null;
              result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Unauthorized", status, _responseText, _headers, result401);
              });
          } else if (status === 403) {
              return response.text().then((_responseText) => {
              let result403: any = null;
              result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
              return throwException("Forbidden", status, _responseText, _headers, result403);
              });
          } else if (status === 500) {
              return response.text().then((_responseText) => {
              return throwException("Server Error", status, _responseText, _headers);
              });
          } else if (status === 200) {
              return response.text().then((_responseText) => {
              let result200: any = null;
              result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartyDto;
              return result200;
              });
          } else if (status !== 200 && status !== 204) {
              return response.text().then((_responseText) => {
              return throwException("An unexpected server error occurred.", status, _responseText, _headers);
              });
          }
          return Promise.resolve<PartyDto>(null as any);
      }
  }
  
  export interface AcceptInvitationCommand {
      invitationId?: number;
      userId?: string | undefined;
  }
  
  export interface AccessTokenResponse {
      accessToken?: string | undefined;
      tokenType?: string | undefined;
      idToken?: string | undefined;
      expiresIn?: number;
      refreshToken?: string | undefined;
  }
  
  export interface AccountDto {
      userId?: string | undefined;
      email?: string | undefined;
      emailVerified?: boolean;
      userName?: UserNameDto;
      firstName?: string | undefined;
      lastName?: string | undefined;
      dateOfBirth?: Date | undefined;
      country?: string | undefined;
      metadata?: UserMetadataDto;
      profilePicture?: string | undefined;
      homescreenAvatar?: string | undefined;
      avatarSmall?: string | undefined;
      roles?: string[] | undefined;
      ftueState?: string | undefined;
      ftueOmniOnlineTrialClaimed?: boolean;
      headsetFTUEComplete?: boolean;
      readyPlayerMeAvatarId?: string | undefined;
      weight?: number;
  }
  
  export interface AchievementAddFieldsRequest {
      name?: string | undefined;
      fields?: string | undefined;
      extraData?: string | undefined;
  }
  
  export interface AchievementDefinition {
      type?: AchievementType;
      name?: string | undefined;
      bitfieldLength?: number;
      target?: number;
      description?: string | undefined;
      title?: string | undefined;
      isArchived?: boolean;
      isSecret?: boolean;
      id?: number;
      unlockedDescription?: string | undefined;
      writePolicy?: AchievementWritePolicy;
      lockedImageURL?: string | undefined;
      unlockedImageURL?: string | undefined;
      lockedIconKey?: string | undefined;
      unlockedIconKey?: string | undefined;
  }
  
  export interface AchievementDefinitionPagedResponseList {
      totalSize?: number;
      hasNextPage?: boolean;
      hasPreviousPage?: boolean;
      items?: AchievementDefinition[] | undefined;
  }
  
  export interface AchievementDefinitionPagedResponseListMessage {
      error?: Error | undefined;
      data?: AchievementDefinitionPagedResponseList;
  }
  
  export interface AchievementProgress {
      productId?: string;
      apiName?: string | undefined;
      userId?: string | undefined;
      isUnlocked?: boolean;
      count?: number;
      extraData?: string | undefined;
      bitField?: string | undefined;
      unlockTime?: Date | undefined;
  }
  
  export interface AchievementProgressPagedResponseList {
      totalSize?: number;
      hasNextPage?: boolean;
      hasPreviousPage?: boolean;
      items?: AchievementProgress[] | undefined;
  }
  
  export interface AchievementProgressPagedResponseListMessage {
      error?: Error2 | undefined;
      data?: AchievementProgressPagedResponseList;
  }
  
  export enum AchievementType {
      Unknown = 0,
      Simple = 1,
      Count = 2,
      BitField = 3,
  }
  
  export interface AchievementUpdate {
      justUnlocked?: boolean;
      name?: string | undefined;
  }
  
  export interface AchievementUpdateMessage {
      error?: Error3 | undefined;
      data?: AchievementUpdate;
  }
  
  export interface AchievementUpdateRequest {
      count?: number;
      name?: string | undefined;
      extraData?: string | undefined;
  }
  
  export enum AchievementWritePolicy {
      Unknown = 0,
      Client = 1,
      Server = 2,
  }
  
  export interface AddUserProductCommandCommand {
      releaseChannelId?: ReleaseChannel;
      reason: string;
  }
  
  export enum AgeRating {
      Everyone = 0,
      Everyone10Plus = 1,
      Teen = 2,
      Mature17Plus = 3,
  }
  
  export interface AggregatedStatementInfo {
      aggregatedStatement?: StatementInfoDto;
      monthlyStatements?: MonthlyStatement[] | undefined;
  }
  
  export interface AndroidMiddlewareFileInfoDto {
      name?: string | undefined;
      url?: string | undefined;
      size?: number;
      version?: number;
      releaseDate?: Date;
  }
  
  export interface ApiNamesRequest {
      apiNames?: string[] | undefined;
  }
  
  export interface AssignProductFromShopifyCommand {
      shopifyOrderItem: MappedShopifyOrderItem;
      userId: string;
  }
  
  export interface AuthCredentials {
      username?: string | undefined;
      password?: string | undefined;
  }
  
  export enum AuthZeroSortOrder {
      ASC = 1,
      DESC = -1,
  }
  
  export interface BooleanMessage {
      error?: Error4 | undefined;
      data?: boolean;
  }
  
  export enum BuildUpdateType {
      Fix = 0,
      Feature = 1,
  }
  
  export interface ByteArrayFileInfo {
      data?: string | undefined;
      fileName?: string | undefined;
      contentType?: string | undefined;
  }
  
  export interface ChangeUserProductStateCommand {
      packageName?: string | undefined;
      installedState: UserProductStatus;
      releaseChannel: ReleaseChannel;
  }
  
  export interface CloudAssoicateUpdateRequest {
      fileName?: string | undefined;
      tempKey?: string | undefined;
      productId?: string;
  }
  
  export enum CollaboratorPermission {
      Collaborators = 1,
      StoreDetails = 2,
      Builds = 3,
      GameServices = 4,
      Finances = 5,
      Players = 6,
      Analytics = 7,
      RedemptionCodes = 8,
  }
  
  export interface ConcurrentUser {
      maxNumber?: number;
      avgNumber?: number;
  }
  
  export interface ConsumeDlcForUserRequest {
      productId?: string;
      sku?: string | undefined;
  }
  
  export interface ContentProviderAccountDto {
      userId?: string | undefined;
      email?: string | undefined;
      emailVerified?: boolean;
      userName?: UserNameDto;
      firstName?: string | undefined;
      lastName?: string | undefined;
      dateOfBirth?: Date | undefined;
      country?: string | undefined;
      metadata?: UserMetadataDto;
      profilePicture?: string | undefined;
      homescreenAvatar?: string | undefined;
      avatarSmall?: string | undefined;
      roles?: string[] | undefined;
      ftueState?: string | undefined;
      ftueOmniOnlineTrialClaimed?: boolean;
      headsetFTUEComplete?: boolean;
      readyPlayerMeAvatarId?: string | undefined;
      weight?: number;
      projectPermissions?: ProjectPermissions[] | undefined;
  }
  
  export interface ContentProviderDailyRevenueDto {
      date?: Date;
      revenue?: number;
      copiesSold?: number;
  }
  
  export interface ContentProviderRevenueMetricsDto {
      revenue?: number;
      copiesSold?: number;
  }
  
  export interface ContentProviderRevenueSummaryDto {
      monthToDate?: ContentProviderRevenueMetricsDto;
      allTime?: ContentProviderRevenueMetricsDto;
  }
  
  export interface ContentProviderRevenueTimelineDto {
      last30Days?: ContentProviderDailyRevenueDto[] | undefined;
      last12Months?: ContentProviderDailyRevenueDto[] | undefined;
  }
  
  export interface CountryCodeDto {
      code?: string | undefined;
  }
  
  export interface CountryDto {
      code?: string | undefined;
      name?: string | undefined;
  }
  
  export interface CreateAchievementRequest {
      type?: AchievementType;
      name?: string | undefined;
      bitfieldLength?: number;
      target?: number;
      description?: string | undefined;
      title?: string | undefined;
      isArchived?: boolean;
      isSecret?: boolean;
      id?: number;
      unlockedDescription?: string | undefined;
      writePolicy?: AchievementWritePolicy;
      lockedImageURL?: string | undefined;
      unlockedImageURL?: string | undefined;
      lockedIconKey?: string | undefined;
      unlockedIconKey?: string | undefined;
      projectId?: number;
  }
  
  export interface CreateFavoriteFriendRequest {
      userId?: string | undefined;
  }
  
  export interface CreateFreeOrderCommand {
      productId?: string;
  }
  
  export interface CreateGameCreditByUserIdRequest {
      number: number;
      userId: string;
  }
  
  export interface CreateGameInviteRequest {
      invitedUserId?: string | undefined;
      data?: string | undefined;
      productId?: string;
  }
  
  export interface CreateGameStatsRequest {
      id?: number;
      apiName?: string | undefined;
      title?: string | undefined;
      format?: GameStatFormat;
      unitOfMeasurement?: UnitOfMeasurement;
      serverOnly?: boolean;
      projectId?: number;
  }
  
  export interface CreateHomescreenEventCommand {
      name: string;
      description: string;
      startDate: Date;
      endDate: Date;
      image: string;
      productId: string;
      launchDetails: string;
  }
  
  export interface CreateLeaderboardRequest {
      productId?: string;
      id?: number;
      title?: string | undefined;
      apiName?: string | undefined;
      gameStatApiName?: string | undefined;
      gameStatId?: number;
      sortOrder?: LeaderboardSortOrder;
      resetFrequency?: LeaderboardResetFrequency;
      resetHour?: Date | undefined;
      lastReset?: Date;
  }
  
  export interface CreatePaymentIntentCommand {
      planId: string;
      paymentMethodId: string;
  }
  
  export interface CreateProductStatementsToMonthRequest {
      productId?: string;
      accountId?: string | undefined;
      year?: number;
      month?: number;
  }
  
  export interface CreateProductUserReviewRequest {
      rating?: number;
      title?: string | undefined;
      reason?: string | undefined;
  }
  
  export interface CreateRedeemRedemptionCodeResponse {
      codes?: string[] | undefined;
      omniOneSerialNumber?: string | undefined;
  }
  
  export interface CreateReleaseCommand {
      patchNotes: string;
      required?: boolean;
      picoVersion?: PicoVersion;
  }
  
  export interface CreateReviewFeedbackRequest {
      isHelpful: boolean;
  }
  
  export interface CreateStripePaymentIntentCommand {
      productId?: string;
      paymentMethodId?: string | undefined;
      useForFuturePayments?: boolean;
  }
  
  export interface CreateUpfrontMgCodesRequest {
      productId: string;
      quantity: number;
      payViaStripe: boolean;
  }
  
  export interface CreateUserCommand {
      email?: string | undefined;
      password?: string | undefined;
  }
  
  export interface CreateUserReportRequest {
      reportedUserId: string;
      categories: UserReportCategory[];
      description?: string | undefined;
  }
  
  export enum DLCAssetsType {
      File = 0,
      Icon = 1,
      CoverArt = 2,
      DetailImages = 3,
      Video = 4,
      VideoScreenshot = 5,
  }
  
  export enum DLCStatus {
      Draft = 0,
      Published = 1,
  }
  
  export enum DLCType {
      Durable = 1,
      Consumable = 2,
      Subscription = 3,
  }
  
  export interface DeclineInvitationCommand {
      invitationId?: number;
      userId?: string | undefined;
  }
  
  export interface DefaultApplicationDto {
      productId?: string;
      url?: string | undefined;
      version?: string | undefined;
      versionCode?: number;
  }
  
  export interface DeleteFileCommand {
      key?: string | undefined;
  }
  
  export interface Destination {
      apiName?: string | undefined;
      deeplinkMessage?: string | undefined;
      displayName?: string | undefined;
  }
  
  export enum DeveloperSortField {
      Name = 0,
      Email = 1,
      ProjectName = 2,
      CreatedAt = 3,
  }
  
  export interface DlcAssetDetailsDto {
      assetId?: number;
      downloadPath?: string | undefined;
      filename?: string | undefined;
      iapStatus?: string | undefined;
      iapSku?: string | undefined;
      iapName?: string | undefined;
      iapPrice?: string | undefined;
      iapCurrency?: string | undefined;
      iapDescription?: string | undefined;
      iapIcon?: string | undefined;
      assetType?: string | undefined;
      metadata?: string | undefined;
      version?: number | undefined;
  }
  
  export interface DlcAssetDetailsDtoPagedResponseList {
      totalSize?: number;
      hasNextPage?: boolean;
      hasPreviousPage?: boolean;
      items?: DlcAssetDetailsDto[] | undefined;
  }
  
  export interface DlcAssetDetailsDtoPagedResponseListMessage {
      error?: Error5 | undefined;
      data?: DlcAssetDetailsDtoPagedResponseList;
  }
  
  export interface DlcPurchase {
      id?: string | undefined;
      sku?: string | undefined;
      icon?: string | undefined;
      addonType?: DLCType;
      orderComment?: string | undefined;
  }
  
  export interface DlcPurchaseDetails {
      price?: number;
      tax?: number;
      total?: number;
  }
  
  export interface DlcPurchaseDetailsMessage {
      error?: Error6 | undefined;
      data?: DlcPurchaseDetails;
  }
  
  export interface DlcPurchaseMessage {
      error?: Error7 | undefined;
      data?: DlcPurchase;
  }
  
  export interface DlcPurchasePagedResponseList {
      totalSize?: number;
      hasNextPage?: boolean;
      hasPreviousPage?: boolean;
      items?: DlcPurchase[] | undefined;
  }
  
  export interface DlcPurchasePagedResponseListMessage {
      error?: Error8 | undefined;
      data?: DlcPurchasePagedResponseList;
  }
  
  export interface DoNotDisturbRequest {
      doNotDisturb?: boolean;
  }
  
  export interface DownloadableContentAsset {
      name?: string | undefined;
      key?: string | undefined;
      type?: DLCAssetsType;
      dlcId?: number;
      url?: string | undefined;
  }
  
  export interface DownloadableContentAssetRequest {
      name?: string | undefined;
      key?: string | undefined;
      type?: DLCAssetsType;
      dlcId?: number;
  }
  
  export interface DownloadableContentClientDetailsDto {
      detailedDescription?: string | undefined;
      description?: string | undefined;
      price?: string | undefined;
      name?: string | undefined;
      sku?: string | undefined;
      icon?: string | undefined;
      addonType?: DLCType;
      originalPrice?: string | undefined;
  }
  
  export interface DownloadableContentClientDetailsDtoPagedResponseList {
      totalSize?: number;
      hasNextPage?: boolean;
      hasPreviousPage?: boolean;
      items?: DownloadableContentClientDetailsDto[] | undefined;
  }
  
  export interface DownloadableContentClientDetailsDtoPagedResponseListMessage {
      error?: Error9 | undefined;
      data?: DownloadableContentClientDetailsDtoPagedResponseList;
  }
  
  export interface DownloadableContentDetailDto {
      id?: number;
      productId?: string;
      name?: string | undefined;
      type?: DLCType;
      sku?: string | undefined;
      status?: DLCStatus;
      price?: number;
      brief?: string | undefined;
      description?: string | undefined;
      contentRatingConfirmation?: boolean;
      pricingConfirmation?: boolean;
      createdDate?: Date;
      lastModifiedDate?: Date | undefined;
      assets?: DownloadableContentAsset[] | undefined;
      minimumCompatibleVerison?: number | undefined;
  }
  
  export interface DownloadableContentFile {
      url?: string | undefined;
      name?: string | undefined;
      id?: number;
  }
  
  export enum DownloadableContentSortField {
      Name = 2,
      DateCreated = 6,
  }
  
  export interface DownloadableContentSummary {
      id?: number;
      name?: string | undefined;
      type?: DLCType;
      sku?: string | undefined;
      status?: DLCStatus;
      price?: number;
      createdDate?: Date;
  }
  
  export interface DownloadableContentSummaryPagedResult {
      totalCount?: number;
      items?: DownloadableContentSummary[] | undefined;
  }
  
  export interface ErrorDto {
      readonly code?: string | undefined;
      details?: string | undefined;
  }
  
  export enum ErrorCode {
      None = 0,
      Payment_ProductIsFree = 1,
      Payment_ProductIsNotFree = 2,
      Stripe_StripeError = 3,
      HomeScreen_ModuleNotFound = 4,
      ProductBuild_PackageNameExists = 5,
      ProductBuild_ProcessingFailed = 6,
      GameCode_NotFound = 7,
      GameCode_NotForProduct = 8,
      GameCode_AlreadyRedeemed = 9,
      GameCode_Reserved = 10,
      GameCode_RedeemedFailed = 11,
      Product_IsRequired = 12,
      Product_NotFound = 13,
      Product_AlreadyAcquired = 14,
      Entitlement_AlreadyLoggedInFromAnotherDevice = 15,
  }
  
  export interface ErrorResult {
      readonly success?: boolean;
      readonly failure?: boolean;
      message?: string | undefined;
      code?: ErrorCode;
      errors?: ErrorDto[] | undefined;
  }
  
  export enum EventStatus {
      Upcoming = 0,
      OnGoing = 1,
      Completed = 2,
  }
  
  export enum EventTableSortField {
      Name = 2,
      Description = 3,
      StartDate = 4,
      EndDate = 5,
      Status = 15,
  }
  
  export interface ExportDevelopersCommand {
      searchTerm?: string | undefined;
      sortField: DeveloperSortField;
      sortOrder: AuthZeroSortOrder;
  }
  
  export enum ExportProjection {
      Count = 0,
      Revenue = 1,
      All = 2,
  }
  
  export enum ExportType {
      Csv = 0,
  }
  
  export interface ExportUsersCommand {
      searchTerm?: string | undefined;
      sortField: UserSortField;
      sortOrder: SortOrder;
  }
  
  export interface ExtendedProfileDto {
      userId?: string | undefined;
      userName?: string | undefined;
      onlineStatus?: boolean;
      currentActivity?: string | undefined;
      profilePicture?: string | undefined;
      homescreenAvatar?: string | undefined;
      lastSeen?: string | undefined;
      avatarSmall?: string | undefined;
      ftueState?: string | undefined;
      ftueOmniOnlineTrialClaimed?: boolean;
      omniOnlineSubscription?: boolean;
      banned?: boolean;
      showOffline?: boolean;
      doNotDisturb?: boolean;
      countryCode?: string | undefined;
      headsetFTUEComplete?: boolean;
      readyPlayerMeAvatarId?: string | undefined;
      weight?: number;
      userSince?: Date;
      numberOfGamesOwned?: number | undefined;
      numberOfStoreGamesOwned?: number | undefined;
      numberOfGamesPlayed?: number | undefined;
      numberOfFriends?: number | undefined;
      favorite?: boolean | undefined;
      receivedRequestFrom?: boolean;
      sentRequestTo?: boolean;
      blocked?: boolean | undefined;
      averageVrSessionLength?: number;
      omniOnlineSince?: Date | undefined;
      tags?: string[] | undefined;
  }
  
  export interface FeaturedItem {
      id?: number | undefined;
      name?: string | undefined;
      createdAt?: Date | undefined;
      updatedAt?: Date | undefined;
      itemId?: string;
      itemTypeId?: ItemType;
      headline?: string | undefined;
      imageUrl?: string | undefined;
      imageLink?: string | undefined;
      order?: number;
      price?: number | undefined;
      productId?: string | undefined;
  }
  
  export interface FeaturedItemIEnumerableResult {
      readonly success?: boolean;
      readonly failure?: boolean;
      data?: FeaturedItem[] | undefined;
  }
  
  export interface FileStorageItemDto {
      uploadLink?: string | undefined;
      key?: string | undefined;
      contentType?: string | undefined;
  }
  
  export interface FirmwarePackageDetailDto {
      id?: number;
      agG5340?: SystemFileDto;
      agG52833?: SystemFileDto;
      footTracker?: SystemFileDto;
      createdDate?: Date;
  }
  
  export interface FirmwarePackageDetailDtoPagedResult {
      totalCount?: number;
      items?: FirmwarePackageDetailDto[] | undefined;
  }
  
  export interface FriendDto {
      userId?: string | undefined;
      userName?: string | undefined;
      currentActivity?: string | undefined;
      profilePicture?: string | undefined;
      onlineStatus?: boolean;
      favorite?: boolean;
      lastSeen?: Date | undefined;
  }
  
  export interface FriendDtoPagedResult {
      totalCount?: number;
      items?: FriendDto[] | undefined;
  }
  
  export interface FriendsWhoOwnAGameDto {
      userId?: string | undefined;
      userName?: string | undefined;
      onlineStatus?: boolean;
      currentActivity?: string | undefined;
      profilePicture?: string | undefined;
      homescreenAvatar?: string | undefined;
      lastSeen?: string | undefined;
      avatarSmall?: string | undefined;
      ftueState?: string | undefined;
      ftueOmniOnlineTrialClaimed?: boolean;
      omniOnlineSubscription?: boolean;
      banned?: boolean;
      showOffline?: boolean;
      doNotDisturb?: boolean;
      countryCode?: string | undefined;
      headsetFTUEComplete?: boolean;
      readyPlayerMeAvatarId?: string | undefined;
      weight?: number;
      tags?: string[] | undefined;
  }
  
  export interface FriendsWhoOwnAGameDtoPagedResult {
      totalCount?: number;
      items?: FriendsWhoOwnAGameDto[] | undefined;
  }
  
  export enum GalleryItemGroup {
      CoverAsset = 0,
      Hero = 1,
      Icon = 2,
      Logo = 3,
      ScreenShot = 4,
      Video = 5,
  }
  
  export enum GalleryItemType {
      Landscape = 0,
      Square = 1,
      Portrait = 2,
      Mini = 3,
      HeroImage = 4,
      Mobile = 5,
      PC = 6,
      WithTransparency = 7,
      ScreenShot = 8,
      Trailer = 9,
      Tutorial = 10,
      VideoImage = 11,
  }
  
  export interface GameCode {
      type?: GameCodeType;
      code?: string | undefined;
      productId?: string | undefined;
  }
  
  export enum GameCodeType {
      UnKnown = 0,
      RedemptionCode = 1,
      AnyGameCode = 2,
      MinimumGuaranteedCode = 3,
  }
  
  export interface GameRankingByRevenue {
      productId?: string;
      productName?: string | undefined;
      revenue?: number;
  }
  
  export interface GameRankingByRevenuePagedResult {
      totalCount?: number;
      items?: GameRankingByRevenue[] | undefined;
  }
  
  export interface GameRedemptionCodeDto {
      createdBy?: string | undefined;
      createdDate?: Date | undefined;
      lastModifiedBy?: string | undefined;
      lastModifiedDate?: Date | undefined;
      id?: number;
      code?: string | undefined;
      userId?: string | undefined;
      productId?: string | undefined;
      redeemedAt?: Date | undefined;
      sellingPrice?: number;
      amount?: number;
      transferId?: string | undefined;
      mgCodeId?: number | undefined;
      userName?: string | undefined;
      productName?: string | undefined;
  }
  
  export interface GameRedemptionCodeDtoPagedResult {
      totalCount?: number;
      items?: GameRedemptionCodeDto[] | undefined;
  }
  
  export enum GameRedemptionCodeSortField {
      Code = 2,
      RedeemedAt = 4,
      CreatedBy = 6,
      CreatedAt = 7,
      UserName = 14,
      GameRedeemed = 15,
  }
  
  export interface GameRevenues {
      date?: Date;
      toVirtuix?: number;
      toContentProvider?: number;
      copiesSold?: number;
  }
  
  export interface GameStatDto {
      id?: number;
      apiName?: string | undefined;
      title?: string | undefined;
      format?: GameStatFormat;
      unitOfMeasurement?: UnitOfMeasurement;
      serverOnly?: boolean;
  }
  
  export interface GameStatDtoPagedResult {
      totalCount?: number;
      items?: GameStatDto[] | undefined;
  }
  
  export enum GameStatFormat {
      Integer = 0,
      Decimal = 1,
      Percentage = 2,
      HourMinutesSeconds = 3,
      DaysHoursMinutes = 4,
  }
  
  export interface GameplayHours {
      productId?: string | undefined;
      secondsPlayed?: number;
      numberOfSessions?: number;
      numberOfPlayers?: number;
      date?: Date;
  }
  
  export interface GamesWithPlaytime {
      productId?: string;
      productName?: string | undefined;
      playtime?: number;
  }
  
  export interface GenerateGameRedemptionCodesRequest {
      number?: number;
  }
  
  export interface GenerateRedemptionCodesCommand {
      number?: number;
  }
  
  export interface GenerateRedemptionCodesRequest {
      number?: number;
      durationInMonths?: number;
  }
  
  export interface GenerateRedemptionCodesRequestByOmniOneSerialNumber {
      number?: number;
      durationInMonths?: number;
      omniOneSerialNumber?: string | undefined;
  }
  
  export enum Genre {
      ActionAndAdventure = 0,
      CardAndBoard = 1,
      Casino = 2,
      Classics = 3,
      Educational = 4,
      FamilyAndKids = 5,
      Fighting = 6,
      Horror = 7,
      MultiplayerOnlineBattleArena = 8,
      Music = 9,
      Other = 10,
      Platformer = 11,
      PuzzleAndTrivia = 12,
      RacingAndFlying = 13,
      RolePlaying = 14,
      Shooter = 15,
      Simulation = 16,
      Social = 17,
      Sports = 18,
      Strategy = 19,
  }
  
  export interface GetAllLeaderboardsRequest {
      productId?: string;
      pageNumber?: number;
      pageSize?: number;
      sortOrder?: SortOrder;
      sortField?: LeaderboardV2SortField;
  }
  
  export enum GetAllProjectsQuerySortField {
      Name = 2,
      CreatedDate = 5,
  }
  
  export interface GetEntriesAfterRankRequest {
      leaderboardName?: string | undefined;
      pageSize?: number;
      pageIdx?: number;
      afterRank?: number;
  }
  
  export interface GetEntriesByIdsRequest {
      leaderboardName?: string | undefined;
      pageSize?: number;
      pageIdx?: number;
      startAt?: LeaderboardStartAt;
      userIds?: string[] | undefined;
  }
  
  export interface GetEntriesRequest {
      leaderboardName?: string | undefined;
      pageSize?: number;
      pageIdx?: number;
      filter?: LeaderboardFilterType;
      startAt?: LeaderboardStartAt;
  }
  
  export interface GetLatestMiddlewareQuery {
  }
  
  export interface GetLatestVRLauncherQuery {
  }
  
  export interface GetLeaderboardDetailsRequest {
      productId?: string;
      apiName?: string | undefined;
  }
  
  export interface GetLeaderboardRequest {
      leaderboardName: string;
  }
  
  export interface GetUserRelationsRequest {
      userIds?: string[] | undefined;
  }
  
  export interface HeadsetInfomationDto {
      id?: number;
      serialNumber?: string | undefined;
      headsetName?: string | undefined;
      totalCapacity?: number | undefined;
      usedCapacity?: number | undefined;
      launcherVersion?: string | undefined;
      middlewareVersion?: string | undefined;
  }
  
  export interface HealthDto {
      productId?: string;
      steps?: number;
      calories?: number;
      miles?: number;
  }
  
  export interface HomeScreenModuleDto {
      name?: string | undefined;
      id?: number;
      moduleItems?: ModuleItem[] | undefined;
  }
  
  export interface HomeScreenModuleDtoResult {
      readonly success?: boolean;
      readonly failure?: boolean;
      data?: HomeScreenModuleDto;
  }
  
  export interface HomescreenEventDto {
      id?: string;
      name?: string | undefined;
      description?: string | undefined;
      startDate?: Date;
      endDate?: Date;
      image?: string | undefined;
      createdAt?: Date;
      totalCount?: number;
      productId?: string;
      imageUrl?: string | undefined;
      productName?: string | undefined;
      readonly isActive?: boolean;
      partyId?: number | undefined;
      startedAt?: Date | undefined;
      endedAt?: Date | undefined;
      price?: number | undefined;
      launchDetails?: string | undefined;
      status?: EventStatus;
      readonly eventStarted?: boolean;
      isFull?: boolean | undefined;
      hasJoined?: boolean | undefined;
      isCurrentlyIn?: boolean | undefined;
  }
  
  export interface HomescreenEventListItem {
      id?: string;
      name?: string | undefined;
      description?: string | undefined;
      startDate?: Date;
      endDate?: Date;
      image?: string | undefined;
      createdAt?: Date;
      totalCount?: number;
      productId?: string;
      imageUrl?: string | undefined;
      productName?: string | undefined;
      readonly isActive?: boolean;
      partyId?: number | undefined;
      startedAt?: Date | undefined;
      endedAt?: Date | undefined;
      price?: number | undefined;
      launchDetails?: string | undefined;
      status?: EventStatus;
      readonly eventStarted?: boolean;
  }
  
  export interface HomescreenEventListItemPagedResult {
      totalCount?: number;
      items?: HomescreenEventListItem[] | undefined;
  }
  
  export interface HomescreenItemDto {
      id?: string;
      itemTypeId?: ItemType;
      name?: string | undefined;
  }
  
  export interface HomescreenItemDtoIEnumerableResult {
      readonly success?: boolean;
      readonly failure?: boolean;
      data?: HomescreenItemDto[] | undefined;
  }
  
  export interface InitProjectCommand {
      projectId?: number;
      name?: string | undefined;
  }
  
  export interface InitializeDLCRequest {
      name?: string | undefined;
      sku?: string | undefined;
      type?: DLCType;
      productId?: string;
  }
  
  export interface InvitationEmailDto {
      email?: string | undefined;
      isEmailRegistered?: boolean;
  }
  
  export interface InviteCollaboratorCommand {
      projectId?: number;
      collaboratorEmail?: string | undefined;
      permissions?: CollaboratorPermission[] | undefined;
      callbackUrl?: string | undefined;
  }
  
  export interface InviteRequest {
      inviteeUserId?: string | undefined;
      partyId?: number;
  }
  
  export interface InviteTestUserCommand {
      projectId?: number;
      testUserEmails?: string[] | undefined;
      callbackUrl?: string | undefined;
  }
  
  export enum ItemType {
      Product = 0,
      Event = 1,
  }
  
  export interface KickUserRequest {
      userId?: string | undefined;
      partyId?: number;
  }
  
  export enum Language {
      English = 0,
  }
  
  export interface Leaderboard {
      id?: number;
      productId?: string;
      apiName?: string | undefined;
      destinationOptional?: Destination;
  }
  
  export interface LeaderboardDto {
      productId?: string;
      id?: number;
      title?: string | undefined;
      apiName?: string | undefined;
      gameStatApiName?: string | undefined;
      gameStatId?: number;
      sortOrder?: LeaderboardSortOrder;
      resetFrequency?: LeaderboardResetFrequency;
      resetHour?: Date | undefined;
      lastReset?: Date;
  }
  
  export interface LeaderboardEntry {
      displayScore?: string | undefined;
      extraData?: string | undefined;
      id?: number;
      rank?: number;
      score?: number;
      supplementaryMetricOptional?: number;
      timestamp?: Date;
      user?: User;
  }
  
  export interface LeaderboardEntryPagedResponseList {
      totalSize?: number;
      hasNextPage?: boolean;
      hasPreviousPage?: boolean;
      items?: LeaderboardEntry[] | undefined;
  }
  
  export interface LeaderboardEntryPagedResponseListMessage {
      error?: Error10 | undefined;
      data?: LeaderboardEntryPagedResponseList;
  }
  
  export enum LeaderboardEntryWritePolicy {
      CLIENT_AUTHORITATIVE = 1,
      SERVER_AUTHORITATIVE = 2,
  }
  
  export enum LeaderboardFilterType {
      None = 0,
      Friends = 1,
      Unknown = 2,
      UserIds = 3,
  }
  
  export interface LeaderboardPagedResponseList {
      totalSize?: number;
      hasNextPage?: boolean;
      hasPreviousPage?: boolean;
      items?: Leaderboard[] | undefined;
  }
  
  export interface LeaderboardPagedResponseListMessage {
      error?: Error11 | undefined;
      data?: LeaderboardPagedResponseList;
  }
  
  export enum LeaderboardResetFrequency {
      Daily = 0,
      Weekly = 1,
      Monthly = 2,
      Yearly = 3,
      Never = 4,
  }
  
  export enum LeaderboardScoreType {
      POINT = 1,
      TIME_IN_MILLISECOND = 2,
      TIME_IN_SECOND = 3,
      DISTANCE_IN_METERS = 4,
      DISTANCE_IN_FOOT = 5,
      PERCENTAGE = 6,
  }
  
  export enum LeaderboardSortField {
      ApiName = 2,
      Title = 3,
      GameStat = 4,
      SortOrder = 5,
      ResetFrequency = 6,
  }
  
  export enum LeaderboardSortOrder {
      LowestIsLeader = 0,
      HighestIsLeader = 1,
  }
  
  export enum LeaderboardStartAt {
      Top = 0,
      CenteredOnViewer = 1,
      CenteredOnViewerOrTop = 2,
      Unknown = 3,
  }
  
  export interface LeaderboardV2Dto {
      id?: number;
      productId?: string;
      title?: string | undefined;
      apiName?: string | undefined;
      scoreType?: LeaderboardScoreType;
      sortOrder?: LeaderboardsSortOrder;
      entryWritePolicy?: LeaderboardEntryWritePolicy;
      earliestAllowedEntryTime?: Date | undefined;
      latestAllowedEntryTime?: Date | undefined;
      isPublic?: boolean | undefined;
      enableSurpassedNotification?: boolean | undefined;
      destinationApiName?: string | undefined;
  }
  
  export enum LeaderboardV2SortField {
      ApiName = 3,
      Title = 12,
  }
  
  export interface LeaderboardValuesDto {
      userId?: string | undefined;
      userName?: string | undefined;
      value?: number;
      position?: number;
  }
  
  export interface LeaderboardValuesDtoPagedResult {
      totalCount?: number;
      items?: LeaderboardValuesDto[] | undefined;
  }
  
  export enum LeaderboardsSortOrder {
      HIGHER_IS_BETTER = 1,
      LOWER_IS_BETTER = 2,
  }
  
  export interface LeavePartyRequest {
      partyId?: number;
  }
  
  export enum LibrarySortField {
      Name = 2,
  }
  
  export interface ListLeaderboardsDto {
      productId?: string;
      id?: number;
      title?: string | undefined;
      apiName?: string | undefined;
      gameStatApiName?: string | undefined;
      gameStatId?: number;
      sortOrder?: LeaderboardSortOrder;
      resetFrequency?: LeaderboardResetFrequency;
      resetHour?: Date | undefined;
      lastReset?: Date;
  }
  
  export interface ListLeaderboardsDtoPagedResult {
      totalCount?: number;
      items?: ListLeaderboardsDto[] | undefined;
  }
  
  export interface ListLeaderboardsV2Dto {
      id?: number;
      productId?: string;
      title?: string | undefined;
      apiName?: string | undefined;
      scoreType?: LeaderboardScoreType;
      sortOrder?: LeaderboardsSortOrder;
      entryWritePolicy?: LeaderboardEntryWritePolicy;
      earliestAllowedEntryTime?: Date | undefined;
      latestAllowedEntryTime?: Date | undefined;
      isPublic?: boolean | undefined;
      enableSurpassedNotification?: boolean | undefined;
      destinationApiName?: string | undefined;
  }
  
  export interface ListLeaderboardsV2DtoPagedResult {
      totalCount?: number;
      items?: ListLeaderboardsV2Dto[] | undefined;
  }
  
  export interface MGCodesRow {
      numberOfCodes?: number;
      sellingPrice?: number;
      netRevenue?: number;
      totalRevenue?: number;
      timeOfPurchase?: Date;
      currency?: string | undefined;
      exchangeCurrency?: string | undefined;
      exchangeAmount?: number;
      exchangeRate?: number;
  }
  
  export interface ManageInviteRequest {
      partyId?: number;
  }
  
  export interface MappedShopifyOrderItem {
      orderId?: string | undefined;
      itemId?: string | undefined;
      email?: string | undefined;
      productId?: string | undefined;
      originalPrice?: number;
      tax?: number;
      refunded?: boolean;
      processedAt?: Date;
      readonly totalAmount?: number;
  }
  
  export interface MgCodeDto {
      createdBy?: string | undefined;
      createdDate?: Date | undefined;
      lastModifiedBy?: string | undefined;
      lastModifiedDate?: Date | undefined;
      id?: number;
      code?: string | undefined;
      productId?: string;
      reserved?: boolean;
      userId?: string | undefined;
      redeemedAt?: Date | undefined;
      userName?: string | undefined;
  }
  
  export interface MgCodeDtoPagedResult {
      totalCount?: number;
      items?: MgCodeDto[] | undefined;
  }
  
  export enum MgCodeListSortField {
      Code = 3,
      Redeemed = 6,
      CreatedAt = 9,
      UserName = 12,
  }
  
  export interface MgCodeMonthlyConfigDto {
      id?: number;
      productName?: string | undefined;
      monthlyCodes?: number;
      codesPurchased?: number;
      codesUsed?: number;
      codesAvailable?: number;
      startOfContract?: Date;
      endOfContract?: Date;
  }
  
  export interface MgCodeMonthlyConfigDtoPagedResult {
      totalCount?: number;
      items?: MgCodeMonthlyConfigDto[] | undefined;
  }
  
  export enum MgCodeMonthlyConfigsSortField {
      ProductName = 2,
      MonthlyCodes = 3,
      CodesPurchased = 4,
      CodesUsed = 5,
      CodesAvailable = 6,
      StartOfContract = 7,
      EndOfContract = 8,
  }
  
  export interface MgCodeMonthlyGenConfig {
      createdBy?: string | undefined;
      createdDate?: Date | undefined;
      lastModifiedBy?: string | undefined;
      lastModifiedDate?: Date | undefined;
      id?: number;
      productId?: string;
      startDate?: Date;
      durationMonths?: number;
      minimumGuaranteedCopiesPerMonth?: number;
  }
  
  export interface ModuleItem {
      id?: number;
      moduleId?: number;
      itemId?: string;
      itemTypeId?: ItemType;
      order?: number;
  }
  
  export interface MonthlyStatement {
      id?: number;
      productId?: string;
      year?: number;
      month?: number;
      netRevenue?: number;
      convertedNetRevenue?: number;
      exchangeCurrency?: string | undefined;
      isFinalized?: boolean;
      statementRows?: StatementRow[] | undefined;
      mgCodesRows?: MGCodesRow[] | undefined;
  }
  
  export enum MovementIntensity {
      Low = 0,
      Moderate = 1,
      Intense = 2,
  }
  
  export enum MovementMode {
      StandingOnly = 0,
      RoomScale = 1,
      OmniMovements = 2,
  }
  
  export enum NumberOfPlayers {
      SinglePlayer = 0,
      OnlineMultiplayer = 1,
      OnlineCoop = 2,
  }
  
  export interface OmniOnlineStatsAllTimeDto {
      monthlyMembershipRevenue?: number;
      annualMembershipRevenue?: number;
      total?: number;
  }
  
  export interface OmniOnlineStatsDto {
      unit?: string | undefined;
      day?: Date;
      activeMonthlyMembershipCount?: number;
      activeAnnualMembershipCount?: number;
      monthlyMembershipRevenue?: number;
      annualMembershipRevenue?: number;
  }
  
  export interface OrderDetailDto {
      productName?: string | undefined;
      ccSuffix?: string | undefined;
      amount?: number;
      productImageURI?: string | undefined;
      purchaseDate?: Date;
      addType?: ProductAddType;
  }
  
  export enum OrderSortField {
      OrderNumber = 2,
      PurchaseDate = 4,
  }
  
  export interface PartyMemberDto {
      status?: PartyMemberStatus;
      userProfile?: ProfileDto;
  }
  
  export enum PartyMemberStatus {
      Member = 0,
      Leader = 1,
      Pending = 2,
  }
  
  export interface Payment {
      id?: number;
      userId?: string | undefined;
      shopifyItemId?: string | undefined;
      productId?: string;
      price?: number;
      transactionTotal?: number;
      taxEstimated?: number;
      commissionRate?: number;
      commissionCollected?: number;
      redemptionCode?: string | undefined;
      purchaser?: string | undefined;
      completed?: boolean;
      createdDate?: Date;
      dlcId?: number | undefined;
      mgCodeId?: number | undefined;
      cpRevenue?: number;
  }
  
  export interface PaymentPagedResult {
      totalCount?: number;
      items?: Payment[] | undefined;
  }
  
  export enum PicoVersion {
      V3 = 3,
      V4 = 4,
  }
  
  export enum PlayStyle {
      SinglePlayer = 0,
      OnlineCoop = 1,
      OnlinePvP = 2,
      OnlineSocial = 3,
  }
  
  export interface PlayersWithPlaytime {
      productId?: string;
      username?: string | undefined;
      playtime?: number;
  }
  
  export interface PrivacySettingsDto {
      healthStats?: Visibility;
      gameStats?: Visibility;
      recentlyPlayedGames?: Visibility;
      friends?: Visibility;
  }
  
  export interface PrivacyVisibilitiesDto {
      healthStats?: boolean;
      gameStats?: boolean;
      recentlyPlayedGames?: boolean;
      friends?: boolean;
  }
  
  export interface ProblemDetails {
      type?: string | undefined;
      title?: string | undefined;
      status?: number | undefined;
      detail?: string | undefined;
      instance?: string | undefined;
  
      [key: string]: any;
  }
  
  export enum ProductAddType {
      GameCode = 1,
      Purchased = 2,
      InvitedAsTestUser = 3,
      AssignedForReview = 4,
      AssignedByAdmin = 5,
      DefaultProduct = 6,
      GameCredit = 7,
      BundledOmniOnlineProduct = 8,
  }
  
  export interface ProductBuildDto {
      name?: string | undefined;
      size?: number;
      s3Key?: string | undefined;
      url?: string | undefined;
      versionCode?: number;
      requiredVersionCode?: number;
  }
  
  export interface ProductBuildListItemDto {
      id?: string;
      name?: string | undefined;
      productReleases?: ProductReleaseDto[] | undefined;
      packageName?: string | undefined;
      versionCode?: number;
      orderNumber?: string | undefined;
      description?: string | undefined;
      logoImage?: string | undefined;
      fullImage?: string | undefined;
      landscapeImage?: string | undefined;
      userProductStatusId?: string | undefined;
      lastTimePlayed?: Date | undefined;
      totalTimePlayed?: number | undefined;
      releaseChannelId?: ReleaseChannel;
      requiredVersionCode?: number;
  }
  
  export interface ProductBuildListItemDtoPagedResult {
      totalCount?: number;
      items?: ProductBuildListItemDto[] | undefined;
  }
  
  export enum ProductBuildListSortField {
      ContentOwned = 2,
  }
  
  export interface ProductDetailsDto {
      productId?: string;
      name?: string | undefined;
      description?: string | undefined;
      price?: number | undefined;
      acquired?: boolean;
      galleryItems?: ProductGalleryItemDto[] | undefined;
      status?: ProductStatus;
      userProductStatus?: UserProductStatus;
      genres?: Genre[] | undefined;
      languages?: Language[] | undefined;
      ageRating?: AgeRating;
      movementIntensity?: MovementIntensity;
      numberOfPlayers?: NumberOfPlayers[] | undefined;
      developer?: string | undefined;
      publisher?: string | undefined;
      omniOneCompatible?: boolean;
      packageName?: string | undefined;
      movementModes?: MovementMode[] | undefined;
      playStyles?: PlayStyle[] | undefined;
      productPlayStyleItems?: ProductPlayStyleItem[] | undefined;
      taxCalculated?: number | undefined;
      minPlayers?: number;
      maxPlayers?: number;
      readonly omniOnlineRequired?: boolean;
      readonly singlePlayerAvailable?: boolean;
      releaseDate?: Date | undefined;
  }
  
  export interface ProductGalleryItemDto {
      id?: string;
      type?: GalleryItemType;
      group?: GalleryItemGroup;
      parentId?: string | undefined;
      url?: string | undefined;
      fileName?: string | undefined;
      s3Key?: string | undefined;
      childItems?: ProductGalleryItemDto[] | undefined;
  }
  
  export interface ProductListItemDto {
      productId?: string;
      name?: string | undefined;
      description?: string | undefined;
      price?: number | undefined;
      acquired?: boolean;
      galleryItems?: ProductGalleryItemDto[] | undefined;
      status?: ProductStatus;
      userProductStatus?: UserProductStatus;
      genres?: Genre[] | undefined;
      languages?: Language[] | undefined;
      ageRating?: AgeRating;
      movementIntensity?: MovementIntensity;
      numberOfPlayers?: NumberOfPlayers[] | undefined;
      developer?: string | undefined;
      publisher?: string | undefined;
      omniOneCompatible?: boolean;
      packageName?: string | undefined;
      movementModes?: MovementMode[] | undefined;
      playStyles?: PlayStyle[] | undefined;
      productPlayStyleItems?: ProductPlayStyleItem[] | undefined;
      taxCalculated?: number | undefined;
      minPlayers?: number;
      maxPlayers?: number;
      readonly omniOnlineRequired?: boolean;
      readonly singlePlayerAvailable?: boolean;
      releaseDate?: string | undefined;
      imageUrl?: string | undefined;
      acquisitionDate?: Date;
      releaseChannelId?: ReleaseChannel;
      id?: string;
      productReleases?: ProductReleaseDto[] | undefined;
      versionCode?: number;
      orderNumber?: string | undefined;
      logoImage?: string | undefined;
      fullImage?: string | undefined;
      landscapeImage?: string | undefined;
      userProductStatusId?: string | undefined;
      requiredVersionCode?: number;
      versionName?: string | undefined;
      packageSize?: number | undefined;
      ifOmniOnlineIsRequired?: boolean;
  }
  
  export interface ProductListItemDtoPagedResult {
      totalCount?: number;
      items?: ProductListItemDto[] | undefined;
  }
  
  export interface ProductPaymentDto {
      createdDate?: Date;
      virtuixRevenue?: number;
      price?: number;
      redemptionCode?: string | undefined;
      id?: string | undefined;
      purchaser?: string | undefined;
      totalCount?: number;
  }
  
  export interface ProductPaymentDtoPagedResult {
      totalCount?: number;
      items?: ProductPaymentDto[] | undefined;
  }
  
  export interface ProductPlayStyleDto {
      playStyleId?: PlayStyle;
      minPlayers?: number;
      maxPlayers?: number;
  }
  
  export interface ProductPlayStyleItem {
      productId?: string;
      playStyleId?: PlayStyle;
      minPlayers?: number;
      maxPlayers?: number;
  }
  
  export interface ProductPriceDto {
      price?: number;
      userName?: string | undefined;
      dateCreated?: Date;
  }
  
  export enum ProductPriceSortField {
      Price = 1,
      UserName = 2,
      DateCreated = 3,
  }
  
  export interface ProductPublishingRequirementRecordDto {
      createdBy?: string | undefined;
      createdDate?: Date | undefined;
      lastModifiedBy?: string | undefined;
      lastModifiedDate?: Date | undefined;
      id?: number;
      productId?: string;
      itemId?: number;
      itemOrder?: number;
      description?: string | undefined;
      categoryId?: PublishingRequirementCategoryV2;
      prefix?: string | undefined;
      isCompleted?: boolean;
  }
  
  export interface ProductPurchaseIntentDto {
      paymentIntentId?: string | undefined;
      clientSecret?: string | undefined;
      customerId?: string | undefined;
      ephemeralKey?: string | undefined;
      payment?: Payment;
  }
  
  export interface ProductPurchaseIntentDtoErrorResult {
      readonly success?: boolean;
      readonly failure?: boolean;
      code?: ErrorCode;
      message?: string | undefined;
      readonly errors?: ErrorDto[] | undefined;
      readonly hasErrorCode?: boolean;
      data?: ProductPurchaseIntentDto;
  }
  
  export interface ProductRatingDetailDto {
      rating?: number;
      percent?: number;
      count?: number;
  }
  
  export interface ProductRatingSummaryDto {
      avgRating?: number;
      totalCount?: number;
      totalRatings?: number;
      totalReviews?: number;
      ratings?: ProductRatingDetailDto[] | undefined;
  }
  
  export interface ProductReleaseDto {
      url?: string | undefined;
      size?: number;
      fileName?: string | undefined;
      versionCode?: number;
      releaseChannelId?: ReleaseChannel;
      requiredSpace?: string | undefined;
      version?: string | undefined;
      lastModifiedDate?: Date;
      id?: string;
      createdDate?: Date;
      buildName?: string | undefined;
      productId?: string;
      required?: boolean;
      updateType?: BuildUpdateType;
      changeLogUri?: string | undefined;
      requiredVersionCode?: number;
  }
  
  export interface ProductReleaseDtoIEnumerableResult {
      readonly success?: boolean;
      readonly failure?: boolean;
      data?: ProductReleaseDto[] | undefined;
  }
  
  export interface ProductReviewItems {
      entitlement?: boolean | undefined;
      omniOnline?: boolean | undefined;
      fulfillsTechnicalRequirements?: boolean | undefined;
      storeDetails?: boolean | undefined;
      assetsVisible?: boolean | undefined;
      assetResolution?: boolean | undefined;
      assetSafeArea?: boolean | undefined;
      fulfillsAssetRequirements?: boolean | undefined;
      omniMovement?: boolean | undefined;
      feedBackDocument?: S3Item;
      movementModes?: MovementMode[] | undefined;
      commission?: number;
  }
  
  export enum ProductStatus {
      Draft = 0,
      Released = 1,
      SubmittedForReview = 2,
      Rejected = 3,
      AwaitingChanges = 4,
      ApprovedForStore = 5,
      ApprovedForWorkshop = 6,
      InReview = 7,
      ChangesSubmitted = 8,
  }
  
  export enum ProductTableSortField {
      Name = 2,
      ReleaseDate = 5,
      Status = 6,
      Price = 7,
  }
  
  export interface ProductUserReviewDto {
      id?: number;
      productId?: string;
      userId?: string | undefined;
      secondsPlayedAtReviewTime?: number;
      versionAtReviewTime?: string | undefined;
      rating?: number;
      title?: string | undefined;
      reason?: string | undefined;
      createdDate?: Date;
      userName?: string | undefined;
      profilePicture?: string | undefined;
      secondsPlayedTotal?: number;
      isHelpful?: boolean | undefined;
      status?: ProductUserReviewStatus;
  }
  
  export interface ProductUserReviewForReviewingDto {
      id?: number;
      productId?: string;
      productName?: string | undefined;
      userId?: string | undefined;
      userName?: string | undefined;
      rating?: number;
      title?: string | undefined;
      reason?: string | undefined;
      createdDate?: Date;
      status?: ProductUserReviewStatus;
      reviewedById?: string | undefined;
      reviewedByName?: string | undefined;
  }
  
  export interface ProductUserReviewForReviewingDtoPagedResult {
      totalCount?: number;
      items?: ProductUserReviewForReviewingDto[] | undefined;
  }
  
  export enum ProductUserReviewForReviewingSortField {
      ProductName = 3,
      Rating = 5,
      Title = 6,
      CreatedDate = 8,
      Status = 9,
      ReviewedByName = 11,
  }
  
  export interface ProductUserReviewListItemDto {
      id?: number;
      productId?: string;
      userId?: string | undefined;
      secondsPlayedAtReviewTime?: number;
      versionAtReviewTime?: string | undefined;
      rating?: number;
      title?: string | undefined;
      reason?: string | undefined;
      createdDate?: Date;
      userName?: string | undefined;
      profilePicture?: string | undefined;
      secondsPlayedTotal?: number;
      isHelpful?: boolean | undefined;
      status?: ProductUserReviewStatus;
      totalCount?: number;
  }
  
  export interface ProductUserReviewListItemDtoPagedResult {
      totalCount?: number;
      items?: ProductUserReviewListItemDto[] | undefined;
  }
  
  export enum ProductUserReviewStatus {
      New = 0,
      Reviewed = 1,
      Removed = 2,
  }
  
  export interface ProfileDto {
      userId?: string | undefined;
      userName?: string | undefined;
      onlineStatus?: boolean;
      currentActivity?: string | undefined;
      profilePicture?: string | undefined;
      homescreenAvatar?: string | undefined;
      lastSeen?: string | undefined;
      avatarSmall?: string | undefined;
      ftueState?: string | undefined;
      ftueOmniOnlineTrialClaimed?: boolean;
      omniOnlineSubscription?: boolean;
      banned?: boolean;
      showOffline?: boolean;
      doNotDisturb?: boolean;
      countryCode?: string | undefined;
      headsetFTUEComplete?: boolean;
      readyPlayerMeAvatarId?: string | undefined;
      weight?: number;
      tags?: string[] | undefined;
  }
  
  export interface Project {
      createdBy?: string | undefined;
      createdDate?: Date | undefined;
      lastModifiedBy?: string | undefined;
      lastModifiedDate?: Date | undefined;
      productId?: string;
      releaseDate?: Date;
      id?: number;
      name?: string | undefined;
      status?: ProductStatus;
      readonly sdkKey?: string | undefined;
      entitlementKey?: string | undefined;
      serverKey?: string | undefined;
  }
  
  export interface ProjectCollaboratorDto {
      collaboratorId?: number;
      projectId?: number;
      userEmail?: string | undefined;
      userName?: string | undefined;
      permissions?: CollaboratorPermission[] | undefined;
      readonly isProjectAdministrator?: boolean;
  }
  
  export interface ProjectCollaboratorDtoPagedResult {
      totalCount?: number;
      items?: ProjectCollaboratorDto[] | undefined;
  }
  
  export interface ProjectDto {
      createdBy?: string | undefined;
      createdDate?: Date | undefined;
      lastModifiedBy?: string | undefined;
      lastModifiedDate?: Date | undefined;
      productId?: string;
      releaseDate?: Date;
      id?: number;
      name?: string | undefined;
      status?: ProductStatus;
      readonly sdkKey?: string | undefined;
      entitlementKey?: string | undefined;
      serverKey?: string | undefined;
      heroImage?: string | undefined;
  }
  
  export interface ProjectDtoPagedResult {
      totalCount?: number;
      items?: ProjectDto[] | undefined;
  }
  
  export interface ProjectInvitationDto {
      invitationId?: number;
      projectName?: string | undefined;
      inviterName?: string | undefined;
  }
  
  export interface ProjectPermissions {
      projectId?: number;
      permissions?: CollaboratorPermission[] | undefined;
  }
  
  export interface ProjectProductDetailsDto {
      productId?: string;
      projectId?: number;
      website?: string | undefined;
      developer?: string | undefined;
      publisher?: string | undefined;
      description?: string | undefined;
      ageRatingId?: AgeRating;
      price?: number | undefined;
      movementIntensityId?: MovementIntensity;
      name?: string | undefined;
      genres?: Genre[] | undefined;
      languages?: Language[] | undefined;
      galleryItems?: ProductGalleryItemDto[] | undefined;
      playStyles?: ProductPlayStyleDto[] | undefined;
  }
  
  export interface ProjectStatusDto {
      hasDetails?: boolean;
      hasPaymentDetails?: boolean;
      hasBuild?: boolean;
      hasBetaBuild?: boolean;
      hasCompletedAllRequirements?: boolean;
      status?: ProductStatus;
      readonly hasRequiredDataToSubmit?: boolean;
      isDefaultApplication?: boolean;
      isBundledWithOmniOnline?: boolean;
  }
  
  export interface PromoteToOwnerRequest {
      userId?: string | undefined;
      partyId?: number;
  }
  
  export enum PublishContentListSortField {
      ProductName = 2,
      ReleaseDate = 3,
      Status = 5,
  }
  
  export interface PublishedContentDto {
      productId?: string;
      productName?: string | undefined;
      publisher?: string | undefined;
      releaseDate?: Date;
      status?: ProductStatus;
  }
  
  export interface PublishedContentDtoPagedResult {
      totalCount?: number;
      items?: PublishedContentDto[] | undefined;
  }
  
  export enum PublishingRequirementCategoryV2 {
      Security = 0,
      PlayerMovement = 1,
      OnlineFeatures = 2,
      MultiplayerFeatures = 3,
      Performance = 4,
      VRInputFunctionality = 5,
      PublishingRequirements = 6,
  }
  
  export interface PurchaseDlcRequest {
      productId?: string;
      sku?: string | undefined;
      paymentMethodId?: string | undefined;
      orderComment?: string | undefined;
  }
  
  export enum QueryProductUserReviewSortField {
      Relevant = 0,
      CreatedDate = 1,
      Rating = 2,
  }
  
  export enum QueryUserAuditSortField {
      Action = 4,
      CreatedDate = 6,
  }
  
  export enum QueryUserReportSortField {
      ReporterName = 3,
      ReportedUserName = 5,
      Categories = 6,
      ReportDate = 8,
      Status = 9,
      HandlingAdminName = 11,
  }
  
  export interface ReactivateBeforeExpirationCommand {
      planId: string;
  }
  
  export interface RealtimeMessageDto {
      id?: number;
      userId?: string | undefined;
      type?: RealtimeMessageType;
      message?: string | undefined;
  }
  
  export enum RealtimeMessageType {
      PARTY_INVITE = 0,
      PARTY_UPDATE = 1,
      FRIEND_UPDATE = 2,
      GAME_INVITE = 3,
  }
  
  export interface RecentlyPlayedDto {
      productId?: string | undefined;
      name?: string | undefined;
      uri?: string | undefined;
      movementModes?: MovementMode[] | undefined;
      stopTime?: Date;
  }
  
  export interface RecentlyPlayedDtoPagedResult {
      totalCount?: number;
      items?: RecentlyPlayedDto[] | undefined;
  }
  
  export interface Recurring {
      aggregateUsage?: string | undefined;
      interval?: string | undefined;
      intervalCount?: number;
      trialPeriodDays?: number | undefined;
      usageType?: string | undefined;
  }
  
  export interface RedeemAnyGameRedemptionCodeRequest {
      code?: string | undefined;
      productId?: string;
  }
  
  export interface RedeemCodeRequest {
      code: string;
      productId?: string | undefined;
  }
  
  export interface RedeemCommand {
      code?: string | undefined;
  }
  
  export interface RedeemGameCreditRequest {
      productId?: string;
  }
  
  export interface RedeemRedemptionCodeRequest {
      code?: string | undefined;
      omniOneSerialNumber?: string | undefined;
  }
  
  export interface RedeemRedemptionCodeResponse {
      code?: SubscriptionRedemptionCode;
      subscription?: SubscriptionDto;
  }
  
  export interface RedemptionCodeDto {
      createdBy?: string | undefined;
      createdDate?: Date | undefined;
      lastModifiedBy?: string | undefined;
      lastModifiedDate?: Date | undefined;
      id?: number;
      productId?: string;
      code?: string | undefined;
      userId?: string | undefined;
      sellingPrice?: number;
      amount?: number;
      userName?: string | undefined;
  }
  
  export interface RedemptionCodeDtoPagedResult {
      totalCount?: number;
      items?: RedemptionCodeDto[] | undefined;
  }
  
  export enum RedemptionCodeListSortField {
      Code = 3,
      RedeemedAt = 4,
      CreatedBy = 5,
      CreatedAt = 6,
      UserName = 10,
  }
  
  export interface RejectProductCommand {
      productId?: string;
      status?: ProductStatus;
      feedback?: string | undefined;
  }
  
  export enum ReleaseChannel {
      Store = 0,
      RC = 1,
      BETA = 2,
  }
  
  export interface ReleaseDto {
      releaseId?: number;
      releaseVersion?: string | undefined;
      middleware?: AndroidMiddlewareFileInfoDto;
      vrLauncher?: VRLauncherFileInfoDto;
      virtualEnvironment?: VRLauncherFileInfoDto;
      androidLauncher?: VRLauncherFileInfoDto;
      releaseDate?: Date | undefined;
      patchNotes?: string | undefined;
      required?: boolean;
      pui?: SystemFileDto;
      firmwarePackage?: ReleaseFirmwarePackageDto;
      userId?: string | undefined;
      userName?: string | undefined;
  }
  
  export interface ReleaseDtoPagedResult {
      totalCount?: number;
      items?: ReleaseDto[] | undefined;
  }
  
  export interface ReleaseFirmwarePackageDto {
      id?: number;
      agG5340?: SystemFileDto;
      agG52833?: SystemFileDto;
      footTracker?: SystemFileDto;
  }
  
  export interface RemoveUserProductCommand {
      releaseChannelId?: ReleaseChannel;
      reason: string;
  }
  
  export interface RequirementItemRecord {
      itemId?: number;
      isCompleted?: boolean;
  }
  
  export interface Result {
      readonly success?: boolean;
      readonly failure?: boolean;
  }
  
  export interface RevenueByDateDto {
      date?: Date;
      virtuixRevenue?: number;
      cpRevenue?: number;
      copiesSold?: number;
  }
  
  export interface RevenuePerUserDto {
      date?: Date;
      averageRevenue?: number;
      averageNumberPurchases?: number;
  }
  
  export enum RevenuePeriod {
      Month = 0,
      Year = 1,
  }
  
  export interface RevenueTransactionSummaryDto {
      virtuixRevenue?: number;
      cpRevenue?: number;
      gameCopiesSold?: number;
      averageSellingPrice?: number;
      totalRevenue?: number;
  }
  
  export interface S3Item {
      fileName?: string | undefined;
      s3Key?: string | undefined;
  }
  
  export enum SafetyShutoffTreadmillState {
      Healthy = 0,
      Warning = 1,
      Shutoff = 2,
  }
  
  export interface SearchAccount {
      userName?: string | undefined;
      pageNumber?: number;
      pageSize?: number;
  }
  
  export interface SetDateForScheduleGamePublishingRequest {
      productId?: string;
      date?: Date;
  }
  
  export interface SetupSubscriptionRenewalCommand {
      planId: string;
      paymentMethodId: string;
  }
  
  export interface ShowOfflineRequest {
      showOffline?: boolean;
  }
  
  export interface SimpleProfileDto {
      userId?: string | undefined;
      userName?: string | undefined;
      profilePicture?: string | undefined;
      onlineStatus?: boolean;
      avatarSmall?: string | undefined;
      countryCode?: string | undefined;
  }
  
  export interface SocialRequest {
      targetUserId?: string | undefined;
  }
  
  export enum SortOrder {
      ASC = 0,
      DESC = 1,
  }
  
  export interface StartGameSessionRequest {
      startTime?: Date;
      productId?: string | undefined;
      releaseChannel?: ReleaseChannel;
  }
  
  export interface StatementInfoDto {
      fileIdentifier?: string;
      applicationName?: string | undefined;
      developerName?: string | undefined;
      publisherName?: string | undefined;
      netRevenue?: number;
      invoiceDate?: Date;
      statementRows?: StatementRow[] | undefined;
      localFilePath?: string | undefined;
      mgCodesRow?: MGCodesRow;
      mgCodesRows?: MGCodesRow[] | undefined;
      currency?: string | undefined;
      exchangeCurrency?: string | undefined;
      convertedNetRevenue?: number;
  }
  
  export interface StatementResult {
      dateExecuted?: Date;
      success?: boolean;
      message?: string | undefined;
  }
  
  export interface StatementRow {
      sellingPrice?: number;
      netRevenue?: number | undefined;
      redemptionCode?: string | undefined;
      purchaser?: string | undefined;
      timeOfPurchase?: Date;
      currency?: string | undefined;
      exchangeCurrency?: string | undefined;
      exchangeAmount?: number;
      exchangeRate?: number;
  }
  
  export enum StatementStatus {
      InProcess = 0,
      Paid = 1,
      Accrued = 2,
  }
  
  export enum StatementsSortField {
      ProductName = 1,
      PublisherName = 2,
      Month = 3,
      Amount = 4,
      Status = 5,
  }
  
  export interface StopGameSessionRequest {
      startTime?: Date;
      stopTime?: Date;
      stepCount?: number;
      productId?: string | undefined;
      offlineSession?: boolean;
      calories?: number;
      miles?: number;
      releaseChannel?: ReleaseChannel;
      omniSerialNumber?: string | undefined;
  }
  
  export interface StoreManagementProductBuild {
      s3Key?: string | undefined;
      fileName?: string | undefined;
      versionCode?: number;
      requiredVersionCode?: number;
  }
  
  export interface StoreManagementProductDetailsDto {
      productId?: string;
      name?: string | undefined;
      description?: string | undefined;
      readonly sdkKey?: string | undefined;
      entitlementKey?: string | undefined;
      galleryItems?: ProductGalleryItemDto[] | undefined;
      builds?: ProductBuildDto[] | undefined;
      status?: ProductStatus;
      price?: number | undefined;
      genres?: Genre[] | undefined;
      ageRating?: AgeRating;
      movementIntensity?: MovementIntensity;
      languages?: Language[] | undefined;
      numberOfPlayers?: NumberOfPlayers[] | undefined;
      developer?: string | undefined;
      publisher?: string | undefined;
      movementMode?: MovementMode[] | undefined;
      commission?: number;
      projectId?: number;
      isDefaultApplication?: boolean;
      isDemoApplication?: boolean;
      isBundledWithOmniOnline?: boolean;
      ifOmniOnlineIsRequired?: boolean;
      scheduleGamePublishingDate?: Date | undefined;
  }
  
  export interface StoreManagementProductGalleryItemDto {
      id?: string;
      type?: GalleryItemType;
      group?: GalleryItemGroup;
      parentId?: string | undefined;
      s3Key?: string | undefined;
      fileName?: string | undefined;
      childItems?: StoreManagementProductGalleryItemDto[] | undefined;
  }
  
  export interface StoreManagementProductListItemDto {
      productId?: string;
      name?: string | undefined;
      publisher?: string | undefined;
      providerName?: string | undefined;
      genres?: Genre[] | undefined;
      releaseDate?: Date | undefined;
      status?: ProductStatus;
      price?: number;
  }
  
  export interface StoreManagementProductListItemDtoPagedResult {
      totalCount?: number;
      items?: StoreManagementProductListItemDto[] | undefined;
  }
  
  export interface StripeAccountLinkDto {
      url?: string | undefined;
  }
  
  export interface StripeAccountResponseDto {
      metadata?: { [key: string]: string; } | undefined;
      stripeResponse?: string | undefined;
  }
  
  export interface StripeBalanceDto {
      id?: number;
      productName?: string | undefined;
      publisher?: string | undefined;
      amount?: number;
      pendingAmount?: number;
      month?: Date;
      status?: StatementStatus;
      statementUrl?: string | undefined;
      statementPath?: string | undefined;
      accountId?: string | undefined;
      totalCount?: number;
      payoutId?: string | undefined;
      projectId?: number;
      productId?: string;
      currency?: string | undefined;
      isPayoutEnabled?: boolean;
  }
  
  export interface StripeBalanceDtoPagedResult {
      totalCount?: number;
      items?: StripeBalanceDto[] | undefined;
  }
  
  export interface StripePaymentIntentConfirmDto {
      amount?: number;
      status?: string | undefined;
  }
  
  export interface StripePaymentIntentDto {
      paymentIntentId?: string | undefined;
      clientSecret?: string | undefined;
      customerId?: string | undefined;
      ephemeralKey?: string | undefined;
  }
  
  export interface StripePaymentMethodCardDto {
      id?: string | undefined;
      brand?: string | undefined;
      funding?: string | undefined;
      last4?: string | undefined;
      expMonth?: number;
      expYear?: number;
  }
  
  export interface StripePaymentMethodDto {
      id?: string | undefined;
      card?: StripePaymentMethodCardDto;
      isDefault?: boolean;
      created?: Date;
  }
  
  export interface StripePaymentMethodListDto {
      data?: StripePaymentMethodDto[] | undefined;
      hasMore?: boolean;
  }
  
  export interface StripeSetupIntentDto {
      id?: string | undefined;
      clientSecret?: string | undefined;
      customerId?: string | undefined;
  }
  
  export interface SubmissionItemDto {
      productId?: string;
      name?: string | undefined;
      developerName?: string | undefined;
      submissionDate?: Date;
      status?: ProductStatus;
      lastUpdatedDate?: Date;
  }
  
  export interface SubmissionItemDtoPagedResult {
      totalCount?: number;
      items?: SubmissionItemDto[] | undefined;
  }
  
  export interface SubmissionReviewDto {
      isAcquired?: boolean;
      isEntitled?: boolean;
      isSubscribed?: boolean;
      currentReviewFormValues?: ProductReviewItems;
      previousReviewFormValues?: ProductReviewItems;
  }
  
  export interface SubmissionsAuditLogDto {
      userName?: string | undefined;
      productName?: string | undefined;
      status?: ProductStatus;
      createdDate?: Date;
      userId?: string | undefined;
      productId?: string;
      id?: number;
  }
  
  export interface SubmissionsAuditLogDtoPagedResult {
      totalCount?: number;
      items?: SubmissionsAuditLogDto[] | undefined;
  }
  
  export enum SubmissionsAuditLogSortField {
      Status = 2,
      CreatedDate = 4,
      ProductName = 5,
      UserName = 6,
  }
  
  export enum SubmissionsTableSortField {
      Name = 2,
      DateSubmitted = 4,
      Status = 5,
      LastUpdated = 6,
  }
  
  export interface SubmitFtueFeedbackRequest {
      isPostiveFeedback: boolean;
      reason?: string | undefined;
  }
  
  export interface Subscription {
      id?: string | undefined;
      endedAt?: Date | undefined;
      cancelAt?: Date | undefined;
      cancelAtPeriodEnd?: boolean;
      canceledAt?: Date | undefined;
      created?: Date;
      currentPeriodStart?: Date;
      currentPeriodEnd?: Date;
      dueCurrentPeriodEnd?: Date;
      dueTrialEnd?: Date | undefined;
      customerId?: string | undefined;
      daysUntilDue?: number | undefined;
      defaultPaymentMethod?: StripePaymentMethodDto;
      subscriptionItemId?: string | undefined;
      plan?: SubscriptionPlan;
      startDate?: Date;
      status?: string | undefined;
      description?: string | undefined;
      readonly expired?: boolean;
      readonly aboutToExpire?: boolean;
      readonly autoRenewal?: boolean;
      readonly expirationDate?: Date | undefined;
      readonly daysUntilExpiration?: number | undefined;
      readonly aboutToExpireIn30Days?: boolean;
  }
  
  export interface SubscriptionDto {
      id?: string | undefined;
      endedAt?: Date | undefined;
      cancelAt?: Date | undefined;
      cancelAtPeriodEnd?: boolean;
      canceledAt?: Date | undefined;
      collectionMethod?: string | undefined;
      created?: Date;
      currentPeriodStart?: Date;
      currentPeriodEnd?: Date;
      dueCurrentPeriodEnd?: Date;
      dueTrialEnd?: Date | undefined;
      customerId?: string | undefined;
      daysUntilDue?: number | undefined;
      defaultPaymentMethod?: StripePaymentMethodDto;
      subscriptionItemId?: string | undefined;
      plan?: SubscriptionPlanDto;
      metadata?: { [key: string]: string; } | undefined;
      livemode?: boolean;
      startDate?: Date;
      status?: string | undefined;
      description?: string | undefined;
      stripeObject?: string | undefined;
      readonly expired?: boolean;
      readonly aboutToExpire?: boolean;
      readonly autoRenewal?: boolean;
      readonly expirationDate?: Date | undefined;
      readonly daysUntilExpiration?: number | undefined;
      readonly aboutToExpireIn30Days?: boolean;
  }
  
  export interface SubscriptionPlan {
      id?: string | undefined;
      planType?: SubscriptionPlanType;
      totalAmount?: number;
      discountedAmount?: number;
      tax?: number;
      originalAmount?: number;
      discountDescription?: string | undefined;
  }
  
  export interface SubscriptionPlanDto {
      id?: string | undefined;
      active?: boolean;
      billingScheme?: string | undefined;
      created?: Date;
      currency?: string | undefined;
      livemode?: boolean;
      lookupKey?: string | undefined;
      metadata?: { [key: string]: string; } | undefined;
      nickname?: string | undefined;
      object?: string | undefined;
      recurring?: Recurring;
      type?: string | undefined;
      unitAmount?: number | undefined;
      unitAmountDecimal?: number | undefined;
      productId?: string | undefined;
      tax?: number;
  }
  
  export enum SubscriptionPlanType {
      Month = 0,
      Year = 1,
  }
  
  export interface SubscriptionPlans {
      plans?: SubscriptionPlan[] | undefined;
  }
  
  export interface SubscriptionPriceResult {
      tax?: number;
      totalAmount?: number;
      renewalDate?: Date;
  }
  
  export interface SubscriptionRedemptionCode {
      createdBy?: string | undefined;
      createdDate?: Date | undefined;
      lastModifiedBy?: string | undefined;
      lastModifiedDate?: Date | undefined;
      id?: number;
      code?: string | undefined;
      userId?: string | undefined;
      durationInMonths?: number;
      redeemedAt?: Date | undefined;
      omniOneSerialNumber?: string | undefined;
  }
  
  export interface SubscriptionRedemptionCodeDto {
      createdBy?: string | undefined;
      createdDate?: Date | undefined;
      lastModifiedBy?: string | undefined;
      lastModifiedDate?: Date | undefined;
      id?: number;
      code?: string | undefined;
      userId?: string | undefined;
      durationInMonths?: number;
      redeemedAt?: Date | undefined;
      omniOneSerialNumber?: string | undefined;
      userName?: string | undefined;
  }
  
  export interface SubscriptionRedemptionCodeDtoPagedResult {
      totalCount?: number;
      items?: SubscriptionRedemptionCodeDto[] | undefined;
  }
  
  export interface SubscriptionRedemptionCodeForHeadset {
      code?: string | undefined;
      serialNumber?: string | undefined;
  }
  
  export enum SubscriptionRedemptionCodeSortField {
      Code = 2,
      RedeemedAt = 4,
      UserName = 6,
      CreatedBy = 7,
      CreatedAt = 8,
  }
  
  export interface SummaryOfAllReviewsDto {
      newReviews?: number;
      reviewedReviews?: number;
      totalReviews?: number;
  }
  
  export interface SyncHeadsetInfomationRequest {
      serialNumber: string;
      headsetName?: string | undefined;
      totalCapacity?: number | undefined;
      usedCapacity?: number | undefined;
      launcherVersion?: string | undefined;
      middlewareVersion?: string | undefined;
  }
  
  export interface SyncTreadmillInfomationRequest {
      blbSerialNumber?: string | undefined;
      blbManufacturerCode?: string | undefined;
      blbBuildDate?: string | undefined;
      blbBoardType?: string | undefined;
      blbBoardRev?: string | undefined;
      scb0HingeNumber?: string | undefined;
      scb0SerialNumber?: string | undefined;
      scb0ManufacturerCode?: string | undefined;
      scb0BuildDate?: string | undefined;
      scb0BoardType?: string | undefined;
      scb0BoardRev?: string | undefined;
      scb1HingeNumber?: string | undefined;
      scb1SerialNumber?: string | undefined;
      scb1ManufacturerCode?: string | undefined;
      scb1BuildDate?: string | undefined;
      scb1BoardType?: string | undefined;
      scb1BoardRev?: string | undefined;
      scb2HingeNumber?: string | undefined;
      scb2SerialNumber?: string | undefined;
      scb2ManufacturerCode?: string | undefined;
      scb2BuildDate?: string | undefined;
      scb2BoardType?: string | undefined;
      scb2BoardRev?: string | undefined;
      scb3HingeNumber?: string | undefined;
      scb3SerialNumber?: string | undefined;
      scb3ManufacturerCode?: string | undefined;
      scb3BuildDate?: string | undefined;
      scb3BoardType?: string | undefined;
      scb3BoardRev?: string | undefined;
      hsbHingeNumber?: string | undefined;
      hsbSerialNumber?: string | undefined;
      hsbManufacturerCode?: string | undefined;
      hsbBuildDate?: string | undefined;
      hsbBoardType?: string | undefined;
      hsbBoardRev?: string | undefined;
      omniSerialNumber: string;
      omniManufacturerCode?: string | undefined;
      omniBuildDate?: string | undefined;
      hebSerialNumber?: string | undefined;
      hebManufacturerCode?: string | undefined;
      hebBuildDate?: string | undefined;
      hebBoardType?: string | undefined;
      hebBoardRev?: string | undefined;
      aggSerialNumber?: string | undefined;
      aggManufacturerCode?: string | undefined;
      aggBuildDate?: string | undefined;
      aggBoardType?: string | undefined;
      aggBoardRev?: string | undefined;
      aggFirmwareVersion?: string | undefined;
      agg52833MajorRevision?: string | undefined;
      agg52833MinorRevision?: string | undefined;
      agg52833DeviceAddress0?: string | undefined;
      agg52833DeviceAddress1?: string | undefined;
      agg52833Variant?: string | undefined;
      gazelleAggPower?: string | undefined;
      gazelleRightTrackerPower?: string | undefined;
      gazelleLeftTrackerPower?: string | undefined;
      gazelleChannel?: string | undefined;
      leftFooterTrackerSerialNumber?: string | undefined;
      leftFooterTrackerName?: string | undefined;
      leftFooterFirmwareVersion?: string | undefined;
      leftFooterHardwareVersion?: string | undefined;
      leftFooterVariant?: string | undefined;
      leftFooterDeviceAddress?: string | undefined;
      leftFooterDeviceMfgInfo?: string | undefined;
      rightFooterTrackerSerialNumber?: string | undefined;
      rightFooterTrackerName?: string | undefined;
      rightFooterFirmwareVersion?: string | undefined;
      rightFooterHardwareVersion?: string | undefined;
      rightFooterVariant?: string | undefined;
      rightFooterDeviceAddress?: string | undefined;
      rightFooterDeviceMfgInfo?: string | undefined;
  }
  
  export interface SystemFileDto {
      id?: string;
      name?: string | undefined;
      size?: number;
      version?: number;
      date?: Date;
      active?: boolean;
      semVersion?: string | undefined;
      url?: string | undefined;
      userName?: string | undefined;
      userId?: string | undefined;
  }
  
  export interface SystemFileDtoPagedResult {
      totalCount?: number;
      items?: SystemFileDto[] | undefined;
  }
  
  export enum SystemFileTableSortField {
      UploadDate = 5,
  }
  
  export enum SystemFileType {
      AndroidMiddleware = 0,
      VrLauncher = 1,
      CustomPui = 2,
      AGG5340 = 3,
      AGG52833 = 4,
      FootTracker = 5,
      VirtualEnvironment = 6,
      AndroidLauncher = 7,
  }
  
  export interface TermsAndConditionsDto {
      version?: string | undefined;
      template?: string | undefined;
  }
  
  export interface TermsAndConditionsRecordsDto {
      createdDate?: Date;
      versionId?: number;
      versionNumber?: string | undefined;
      required?: boolean | undefined;
      userName?: string | undefined;
      userId?: string | undefined;
      template?: string | undefined;
      url?: string | undefined;
  }
  
  export interface TermsAndConditionsRecordsDtoPagedResult {
      totalCount?: number;
      items?: TermsAndConditionsRecordsDto[] | undefined;
  }
  
  export enum TermsAndConditionsRecordsSortField {
      CreatedDate = 2,
      Required = 5,
      UserName = 7,
  }
  
  export interface TermsAndConditionsUserMetadataDto {
      accepted?: boolean;
      version?: string | undefined;
      dateAccepted?: Date | undefined;
  }
  
  export interface TestUserDto {
      id?: number;
      projectId?: number;
      testUserId?: string | undefined;
      testUserEmail?: string | undefined;
      status?: TestUserStatus;
      testUserName?: string | undefined;
  }
  
  export interface TestUserDtoPagedResult {
      totalCount?: number;
      items?: TestUserDto[] | undefined;
  }
  
  export enum TestUserStatus {
      Pending = 0,
      Joined = 1,
  }
  
  export interface TimeSeriesGraphDto {
      last30Days?: RevenueByDateDto[] | undefined;
      last12Months?: RevenueByDateDto[] | undefined;
  }
  
  export interface TotalGameHealthStatistics {
      allTimeSteps?: number;
      allTimeMiles?: number;
      allTimeCalories?: number;
  }
  
  export interface TreadmillInfomationDto {
      id?: number;
      blbSerialNumber?: string | undefined;
      blbManufacturerCode?: string | undefined;
      blbBuildDate?: string | undefined;
      blbBoardType?: string | undefined;
      blbBoardRev?: string | undefined;
      scb0HingeNumber?: string | undefined;
      scb0SerialNumber?: string | undefined;
      scb0ManufacturerCode?: string | undefined;
      scb0BuildDate?: string | undefined;
      scb0BoardType?: string | undefined;
      scb0BoardRev?: string | undefined;
      scb1HingeNumber?: string | undefined;
      scb1SerialNumber?: string | undefined;
      scb1ManufacturerCode?: string | undefined;
      scb1BuildDate?: string | undefined;
      scb1BoardType?: string | undefined;
      scb1BoardRev?: string | undefined;
      scb2HingeNumber?: string | undefined;
      scb2SerialNumber?: string | undefined;
      scb2ManufacturerCode?: string | undefined;
      scb2BuildDate?: string | undefined;
      scb2BoardType?: string | undefined;
      scb2BoardRev?: string | undefined;
      scb3HingeNumber?: string | undefined;
      scb3SerialNumber?: string | undefined;
      scb3ManufacturerCode?: string | undefined;
      scb3BuildDate?: string | undefined;
      scb3BoardType?: string | undefined;
      scb3BoardRev?: string | undefined;
      hsbHingeNumber?: string | undefined;
      hsbSerialNumber?: string | undefined;
      hsbManufacturerCode?: string | undefined;
      hsbBuildDate?: string | undefined;
      hsbBoardType?: string | undefined;
      hsbBoardRev?: string | undefined;
      omniSerialNumber?: string | undefined;
      omniManufacturerCode?: string | undefined;
      omniBuildDate?: string | undefined;
      hebSerialNumber?: string | undefined;
      hebManufacturerCode?: string | undefined;
      hebBuildDate?: string | undefined;
      hebBoardType?: string | undefined;
      hebBoardRev?: string | undefined;
      aggSerialNumber?: string | undefined;
      aggManufacturerCode?: string | undefined;
      aggBuildDate?: string | undefined;
      aggBoardType?: string | undefined;
      aggBoardRev?: string | undefined;
      aggFirmwareVersion?: string | undefined;
      agg52833MajorRevision?: string | undefined;
      agg52833MinorRevision?: string | undefined;
      agg52833DeviceAddress0?: string | undefined;
      agg52833DeviceAddress1?: string | undefined;
      agg52833Variant?: string | undefined;
      gazelleAggPower?: string | undefined;
      gazelleRightTrackerPower?: string | undefined;
      gazelleLeftTrackerPower?: string | undefined;
      gazelleChannel?: string | undefined;
      leftFooterTrackerSerialNumber?: string | undefined;
      leftFooterTrackerName?: string | undefined;
      leftFooterFirmwareVersion?: string | undefined;
      leftFooterHardwareVersion?: string | undefined;
      leftFooterVariant?: string | undefined;
      leftFooterDeviceAddress?: string | undefined;
      leftFooterDeviceMfgInfo?: string | undefined;
      rightFooterTrackerSerialNumber?: string | undefined;
      rightFooterTrackerName?: string | undefined;
      rightFooterFirmwareVersion?: string | undefined;
      rightFooterHardwareVersion?: string | undefined;
      rightFooterVariant?: string | undefined;
      rightFooterDeviceAddress?: string | undefined;
      rightFooterDeviceMfgInfo?: string | undefined;
  }
  
  export interface TreadmillSummary {
      totalUnits?: number;
      activatedUnitsInLastNinetyDays?: number;
  }
  
  export interface TreadmillThresholdDto {
      omniSerialNumber?: string | undefined;
      threshold?: number;
      state?: SafetyShutoffTreadmillState;
  }
  
  export interface TreadmillThresholdDtoPagedResult {
      totalCount?: number;
      items?: TreadmillThresholdDto[] | undefined;
  }
  
  export interface UnfriendRequest {
      userId?: string | undefined;
  }
  
  export enum UnitOfMeasurement {
      Inches = 0,
      Feet = 1,
      Miles = 2,
      Centimeters = 3,
      Kilometers = 4,
      Milliseconds = 5,
      Seconds = 6,
      Minutes = 7,
      Hours = 8,
      Days = 9,
      Meters = 10,
      Numbers = 11,
  }
  
  export interface UnlockUserAchievementRequest {
      name?: string | undefined;
      extraData?: string | undefined;
  }
  
  export interface UpdateAcquirementToggleCommand {
      toggleValue?: boolean;
      userId?: string | undefined;
      productId?: string;
  }
  
  export interface UpdateAvatarCommand {
      pictureModel?: string | undefined;
  }
  
  export interface UpdateCollaboratorsCommand {
      collaboratorId?: number;
      projectId?: number;
      userId?: string | undefined;
      permissions?: CollaboratorPermission[] | undefined;
  }
  
  export interface UpdateContentRatingRequest {
      id?: number;
      confirmation?: boolean;
  }
  
  export interface UpdateDefaultPaymentmMethodCommand {
      paymentmMethodId: string;
  }
  
  export interface UpdateDescriptionRequest {
      id?: number;
      name?: string | undefined;
      brief?: string | undefined;
      description?: string | undefined;
  }
  
  export interface UpdateDownloadableContentAssetItemsRequest {
      assetItems?: DownloadableContentAssetRequest[] | undefined;
      productId?: string;
      minimumCompatibleVerison?: number | undefined;
  }
  
  export interface UpdateEntitlementToggleCommand {
      toggleValue?: boolean;
      userId?: string | undefined;
      productId?: string;
  }
  
  export interface UpdateFeaturedItemsCommand {
      featuredItems?: FeaturedItem[] | undefined;
  }
  
  export interface UpdateGameSessionRequest {
      productId?: string | undefined;
      stepCount?: number;
  }
  
  export interface UpdateHomesceenModuleCommand {
      name?: string | undefined;
      id?: number;
      items?: ModuleItem[] | undefined;
  }
  
  export interface UpdateHomescreenEventCommand {
      name: string;
      description: string;
      startDate: Date;
      endDate: Date;
      image: string;
      productId: string;
      launchDetails: string;
      id: string;
  }
  
  export interface UpdateLastLoginHeadsetIdRequest {
      headsetId: string;
  }
  
  export interface UpdatePricingRequest {
      id?: number;
      price?: number;
      confirmation?: boolean;
  }
  
  export interface UpdateProjectBuildNameCommand {
      releaseChannelId: ReleaseChannel;
      buildName: string;
  }
  
  export interface UpdateProjectNameCommand {
      projectId?: number;
      name?: string | undefined;
      applyToStore?: boolean | undefined;
  }
  
  export interface UpdateProjectStoreDetailsCommand {
      projectId?: number;
      createdAt?: Date;
      website?: string | undefined;
      developer?: string | undefined;
      publisher?: string | undefined;
      description?: string | undefined;
      productId?: string;
      ageRatingId?: AgeRating;
      price?: number;
      movementIntensityId?: MovementIntensity;
      name?: string | undefined;
      genres?: Genre[] | undefined;
      languages?: Language[] | undefined;
      supportedPlayStyles?: ProductPlayStyleItem[] | undefined;
      galleryItems?: StoreManagementProductGalleryItemDto[] | undefined;
  }
  
  export interface UpdateReviewStatusRequest {
      status: ProductUserReviewStatus;
  }
  
  export interface UpdateReviewValuesCommand {
      entitlement?: boolean | undefined;
      omniOnline?: boolean | undefined;
      fulfillsTechnicalRequirements?: boolean | undefined;
      storeDetails?: boolean | undefined;
      assetsVisible?: boolean | undefined;
      assetResolution?: boolean | undefined;
      assetSafeArea?: boolean | undefined;
      fulfillsAssetRequirements?: boolean | undefined;
      omniMovement?: boolean | undefined;
      feedBackDocument?: S3Item;
      movementModes?: MovementMode[] | undefined;
      commission?: number;
      productId?: string;
      userId?: string | undefined;
  }
  
  export interface UpdateStatusRequest {
      id?: number;
      status?: DLCStatus;
  }
  
  export interface UpdateStoreManagementProductCommand {
      id?: string;
      movementMode?: MovementMode[] | undefined;
      commission?: number;
      isDefaultApplication?: boolean;
      ifOmniOnlineIsRequired?: boolean;
      isDemoApplication?: boolean;
      isBundledWithOmniOnline?: boolean;
  }
  
  export interface UpdateSubscriptionPlanCommand {
      planId: string;
  }
  
  export interface UpdateTermsAndConditionsRequest {
      required?: boolean;
      allowNotify?: boolean;
      s3Key?: string | undefined;
  }
  
  export interface UpdateUserAccountCommand {
      userName?: string | undefined;
      firstName?: string | undefined;
      lastName?: string | undefined;
      dateOfBirth?: Date;
      country?: string | undefined;
      password?: string | undefined;
      email?: string | undefined;
      avatarModel?: string | undefined;
  }
  
  export interface UpdateUserCommand {
      userName?: string | undefined;
      firstName?: string | undefined;
      lastName?: string | undefined;
      dateOfBirth?: Date;
      country?: string | undefined;
      email?: string | undefined;
      omniOnlineSubscription?: boolean;
      updateReason?: string | undefined;
  }
  
  export interface UpdateUserGameStatRequest {
      apiName?: string | undefined;
      value?: number;
      productId?: string;
      releaseChannel?: ReleaseChannel;
      hasServerRole?: boolean;
  }
  
  export interface UpdateUserGameStatsRequest {
      productId?: string;
      releaseChannel?: ReleaseChannel;
      stats?: UserGameStatDto[] | undefined;
      hasServerRole?: boolean;
  }
  
  export interface UploadAndroidFileCommand {
      fileName?: string | undefined;
      s3Key?: string | undefined;
      fileType?: SystemFileType;
  }
  
  export interface UploadAndroidMiddlewareCommand {
      fileName?: string | undefined;
      s3Key?: string | undefined;
  }
  
  export interface UploadCsvToBatchAddResultDto {
      haveInvalidAccounts?: boolean;
      numberOfAddedGameCredits?: number;
      numberOfInvalidAccounts?: number;
      fileInfo?: ByteArrayFileInfo;
  }
  
  export interface UploadCustomPuiCommand {
      fileName?: string | undefined;
      s3Key?: string | undefined;
  }
  
  export interface UploadFirmwareCommand {
      fileName?: string | undefined;
      s3Key?: string | undefined;
      type?: SystemFileType;
  }
  
  export interface UploadProjectBuildCommand {
      buildDetails?: StoreManagementProductBuild[] | undefined;
      buildName?: string | undefined;
      buildId?: string;
      releaseChannelId?: ReleaseChannel;
      required: boolean;
      updateType: BuildUpdateType;
      changeLogUri?: string | undefined;
  }
  
  export interface UploadStepsThreshold {
      key?: string | undefined;
  }
  
  export interface UpsertLeaderboardRequest {
      title: string;
      apiName: string;
      scoreType: LeaderboardScoreType;
      sortOrder: LeaderboardsSortOrder;
      entryWritePolicy: LeaderboardEntryWritePolicy;
      earliestAllowedEntryTime?: Date | undefined;
      latestAllowedEntryTime?: Date | undefined;
      isPublic?: boolean;
      enableSurpassedNotification?: boolean;
      destinationApiName?: string | undefined;
  }
  
  export interface UpsertMonthlyMgCodesGenConfigRequest {
      productId: string;
      startDate: Date;
      durationMonths: number;
      minimumGuaranteedCopiesPerMonth: number;
  }
  
  export interface UpsertProductPublishingRequirementRecordsRequest {
      productId?: string;
      requirementItems?: RequirementItemRecord[] | undefined;
      userId?: string | undefined;
  }
  
  export interface UseReportActionRequest {
      reason: string;
      duration?: number | undefined;
  }
  
  export interface User {
      id?: string | undefined;
      displayName?: string | undefined;
      imageUrl?: string | undefined;
      smallImageUrl?: string | undefined;
      inviteToken?: string | undefined;
      storeRegion?: string | undefined;
  }
  
  export interface UserAcceptanceHistoryDto {
      userId?: string | undefined;
      userName?: UserNameDto;
      email?: string | undefined;
      firstName?: string | undefined;
      lastName?: string | undefined;
      userMetadata?: UserMetadataDto;
  }
  
  export interface UserAcceptanceHistoryDtoPagedResult {
      totalCount?: number;
      items?: UserAcceptanceHistoryDto[] | undefined;
  }
  
  export enum UserAcceptanceHistorySortField {
      UserName = 0,
      DateAccepted = 1,
  }
  
  export interface UserActionRequest {
      reason: string;
      duration?: number | undefined;
  }
  
  export interface UserActivity {
      totalNumberOfActiveUsers?: number;
      totalNumberOfInactiveUsers?: number;
      totalNumberOfLapsedUsers?: number;
      date?: Date;
  }
  
  export enum UserAuditAction {
      UserInfoModify = 0,
      ProductDelete = 1,
      PasswordChange = 2,
      Warn = 3,
      Suspend = 4,
      Ban = 5,
      Unsuspend = 6,
      Unban = 7,
      ProductAdd = 8,
  }
  
  export interface UserAuditListItemDto {
      createdBy?: string | undefined;
      createdDate?: Date | undefined;
      lastModifiedBy?: string | undefined;
      lastModifiedDate?: Date | undefined;
      id?: number;
      userId?: string | undefined;
      userName?: string | undefined;
      operatorUserId?: string | undefined;
      operatorUserName?: string | undefined;
      action?: UserAuditAction;
      actionDesc?: string | undefined;
      description?: string | undefined;
      details?: string | undefined;
      totalCount?: number;
  }
  
  export interface UserAuditListItemDtoPagedResult {
      totalCount?: number;
      items?: UserAuditListItemDto[] | undefined;
  }
  
  export interface UserChurn {
      activityTotal?: number;
      activityChurn?: number;
      date?: Date;
  }
  
  export interface UserDto {
      userId?: string | undefined;
      userName?: UserNameDto;
      email?: string | undefined;
      firstName?: string | undefined;
      lastName?: string | undefined;
      userMetadata?: UserMetadataDto;
      dateCreated?: Date | undefined;
      omniOnlineSubscription?: boolean;
      banned?: boolean;
      suspended?: boolean;
      tags?: string[] | undefined;
  }
  
  export interface UserGameCreditDto {
      redeemedNumber?: number;
      availableNumber?: number;
  }
  
  export interface UserGameCreditListDto {
      userId?: string | undefined;
      userName?: string | undefined;
      totalCredits?: number;
      redeemedCredits?: number;
      availableCredits?: number;
      email?: string | undefined;
  }
  
  export interface UserGameCreditListDtoPagedResult {
      totalCount?: number;
      items?: UserGameCreditListDto[] | undefined;
  }
  
  export enum UserGameCreditListSortField {
      TotalCredits = 2,
      RedeemedCredits = 3,
      AvailableCredits = 4,
      UserName = 5,
  }
  
  export interface UserGameHealthStatistics {
      userId?: string | undefined;
      productId?: string;
      hoursPlayed?: number | undefined;
      averageSessionLength?: number | undefined;
      allTimeSteps?: number | undefined;
      allTimeMiles?: number | undefined;
      allTimeCalories?: number | undefined;
  }
  
  export interface UserGameStatDto {
      apiName?: string | undefined;
      value?: number;
  }
  
  export interface UserGameplayMinutes {
      userId?: string | undefined;
      unit?: string | undefined;
      day?: Date;
      minutes?: number;
  }
  
  export interface UserHealthStatisticsDto {
      caloriesPerDay?: number | undefined;
      caloriesPerMonth?: number | undefined;
      caloriesAllTime?: number | undefined;
      milesPerDay?: number | undefined;
      milesPerMonth?: number | undefined;
      milesAllTime?: number | undefined;
      stepsPerDay?: number | undefined;
      stepsPerMonth?: number | undefined;
      stepsAllTime?: number | undefined;
      timePlayedPerDay?: number | undefined;
      timePlayedPerMonth?: number | undefined;
      timePlayedAllTime?: number | undefined;
      gameSessionsAllTime?: number | undefined;
      numberOfGamesPlayed?: number | undefined;
      vrSessionsAllTime?: number | undefined;
      vrSessionSecondsAllTime?: number | undefined;
  }
  
  export interface UserManagementDeveloperListItemDto {
      userId?: string | undefined;
      userName?: string | undefined;
      email?: string | undefined;
      firstName?: string | undefined;
      lastName?: string | undefined;
      projects?: ProjectDto[] | undefined;
      latestProjectName?: string | undefined;
      createdAt?: Date | undefined;
  }
  
  export interface UserManagementDeveloperListItemDtoPagedResult {
      totalCount?: number;
      items?: UserManagementDeveloperListItemDto[] | undefined;
  }
  
  export interface UserManagementUserListItemDto {
      userId?: string | undefined;
      userName?: string | undefined;
      email?: string | undefined;
      firstName?: string | undefined;
      lastName?: string | undefined;
      omniOnlineSubscription?: boolean;
      createdAt?: Date | undefined;
  }
  
  export interface UserManagementUserListItemDtoPagedResult {
      totalCount?: number;
      items?: UserManagementUserListItemDto[] | undefined;
  }
  
  export interface UserManagementUserOrderListItemDto {
      id?: string;
      userId?: string | undefined;
      number?: string | undefined;
      productName?: string | undefined;
      dlcName?: string | undefined;
      datePurchased?: Date;
      price?: number;
      taxEstimated?: number;
      isSubscriptionOrder?: boolean;
  }
  
  export interface UserMetadataDto {
      location?: string | undefined;
      dateOfBirth?: Date | undefined;
      profileUpdatedDate?: Date | undefined;
      termsAndConditions?: TermsAndConditionsUserMetadataDto;
  }
  
  export interface UserNameDto {
      name?: string | undefined;
      suffix?: number;
  }
  
  export enum UserProductStatus {
      Uninstalled = 0,
      Installed = 1,
      InstallQueued = 2,
      UninstallQueued = 3,
      Installing = 4,
  }
  
  export interface UserRankingByRevenue {
      userId?: string | undefined;
      userName?: string | undefined;
      revenue?: number;
  }
  
  export interface UserRankingByRevenuePagedResult {
      totalCount?: number;
      items?: UserRankingByRevenue[] | undefined;
  }
  
  export enum UserRelationType {
      Unknown = 0,
      IsFriend = 1,
      NotFriend = 2,
      Blocked = 3,
      BlockedBy = 4,
      ApplyingFriend = 5,
  }
  
  export enum UserReportCategory {
      PlayerBehavior = 0,
      PlayerName = 1,
  }
  
  export interface UserReportListItemDto {
      id?: number;
      reporterId?: string | undefined;
      reporterName?: string | undefined;
      reportedUserId?: string | undefined;
      reportedUserName?: string | undefined;
      categories?: UserReportCategory[] | undefined;
      description?: string | undefined;
      reportDate?: Date;
      status?: UserReportStatus;
      handlingAdminId?: string | undefined;
      handlingAdminName?: string | undefined;
      duration?: number | undefined;
      handlingDescription?: string | undefined;
      handleDate?: Date | undefined;
      totalCount?: number;
  }
  
  export interface UserReportListItemDtoPagedResult {
      totalCount?: number;
      items?: UserReportListItemDto[] | undefined;
  }
  
  export enum UserReportStatus {
      New = 0,
      Banned = 1,
      Suspended = 2,
      Warned = 3,
      Dismissed = 4,
  }
  
  export interface UserSearchResultDto {
      userId?: string | undefined;
      userName?: string | undefined;
      currentActivity?: string | undefined;
      profilePicture?: string | undefined;
      onlineStatus?: boolean;
      lastSeen?: Date;
      avatarSmall?: string | undefined;
      blocked?: boolean | undefined;
      applyingFriend?: boolean | undefined;
      isFriend?: boolean | undefined;
  }
  
  export interface UserSearchResultDtoPagedResult {
      totalCount?: number;
      items?: UserSearchResultDto[] | undefined;
  }
  
  export enum UserSortField {
      Name = 2,
      OmniOnlineSubscription = 6,
      CreatedAt = 7,
  }
  
  export interface UsersWithPlayTime {
      userId?: string | undefined;
      userName?: string | undefined;
      playtime?: number;
  }
  
  export interface UsersWithPlayTimePagedResult {
      totalCount?: number;
      items?: UsersWithPlayTime[] | undefined;
  }
  
  export interface VRLauncherFileInfoDto {
      name?: string | undefined;
      url?: string | undefined;
      size?: number;
      version?: number;
      releaseDate?: Date;
  }
  
  export interface VRplayHours {
      date?: Date;
      vrLauncherHours?: number;
      gameOnlineHours?: number;
      gameNonOnlineHours?: number;
      numberOfVrSessions?: number;
  }
  
  export interface VRplayMinutesPerActivUser {
      date?: Date;
      averageMinutes?: number;
      averageSessions?: number;
  }
  
  export interface ValidateGameStatApiNameRequest {
      projectId?: number;
      apiName?: string | undefined;
  }
  
  export interface ValidateLeaderboardApiNameRequest {
      productId?: string;
      apiName?: string | undefined;
  }
  
  export interface ValidateLeaderboardV2ApiNameRequest {
      productId?: string;
      apiName?: string | undefined;
  }
  
  export interface ValidateSKURequest {
      sku?: string | undefined;
      productId?: string;
  }
  
  export interface ValidationProblemDetails {
      type?: string | undefined;
      title?: string | undefined;
      status?: number | undefined;
      detail?: string | undefined;
      instance?: string | undefined;
      readonly errors?: { [key: string]: string[]; } | undefined;
  
      [key: string]: any;
  }
  
  export interface VersionCodesDto {
      id?: string;
      versionCode?: number;
      fileName?: string | undefined;
      packageName?: string | undefined;
      releaseChannelId?: ReleaseChannel;
  }
  
  export enum Visibility {
      User = 0,
      Friends = 1,
      Everyone = 2,
  }
  
  export interface VrSessionInput {
      startTime?: string | undefined;
      stopTime?: string | undefined;
  }
  
  export interface WriteEntryRequest {
      leaderboardName: string;
      score: number;
      extraData?: string | undefined;
      forceUpdate?: boolean;
  }
  
  export interface WriteEntryWithSupplementaryMetricRequest {
      leaderboardName: string;
      score: number;
      extraData?: string | undefined;
      forceUpdate?: boolean;
      supplementaryMetric: number;
  }
  
  export interface PartyDto {
      partyId?: number;
      members?: PartyMemberDto[] | undefined;
  }
  
  export interface Error {
      code?: number;
      message?: string;
  
      [key: string]: any;
  }
  
  export interface Error2 {
      code?: number;
      message?: string;
  
      [key: string]: any;
  }
  
  export interface Error3 {
      code?: number;
      message?: string;
  
      [key: string]: any;
  }
  
  export interface Error4 {
      code?: number;
      message?: string;
  
      [key: string]: any;
  }
  
  export interface Error5 {
      code?: number;
      message?: string;
  
      [key: string]: any;
  }
  
  export interface Error6 {
      code?: number;
      message?: string;
  
      [key: string]: any;
  }
  
  export interface Error7 {
      code?: number;
      message?: string;
  
      [key: string]: any;
  }
  
  export interface Error8 {
      code?: number;
      message?: string;
  
      [key: string]: any;
  }
  
  export interface Error9 {
      code?: number;
      message?: string;
  
      [key: string]: any;
  }
  
  export interface Error10 {
      code?: number;
      message?: string;
  
      [key: string]: any;
  }
  
  export interface Error11 {
      code?: number;
      message?: string;
  
      [key: string]: any;
  }
  
  export interface FileParameter {
      data: any;
      fileName: string;
  }
  
  export interface FileResponse {
      data: Blob;
      status: number;
      fileName?: string;
      headers?: { [name: string]: any };
  }
  
  export class ApiException extends Error {
      message: string;
      status: number;
      response: string;
      headers: { [key: string]: any; };
      result: any;
  
      constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
          super();
  
          this.message = message;
          this.status = status;
          this.response = response;
          this.headers = headers;
          this.result = result;
      }
  
      protected isApiException = true;
  
      static isApiException(obj: any): obj is ApiException {
          return obj.isApiException === true;
      }
  }
  
  function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
      if (result !== null && result !== undefined)
          throw result;
      else
          throw new ApiException(message, status, response, headers, null);
  }